import Fr from "crypto-js";
import { v4 as Du } from "uuid";
import ut, { useEffect as J, createContext as be, useContext as xe, useMemo as le, useCallback as $e, useState as hr, useReducer as st, isValidElement as jt, useRef as Mu } from "react";
import ui from "@mqd/graphql-utils";
import Kr from "graphql-tag";
import { useQuery as da, useMutation as Uu, useApolloClient as li } from "@apollo/react-hooks";
import { FlipFlop as Fu } from "@mqd/flip-flop";
import { compose as di } from "ramda";
import N from "prop-types";
import { Icon as et, VSpacer as fr, Text as ae, HSpacer as St, Colors as $n, Flex as po, EmptyState as ju, Link as Bu, Select as fi, Tooltip as pi, RawDropdown as Vu, Hr as vo, Modal as zu, Button as Hu } from "@mqd/volt-base";
import Gu from "currency.js";
import { MockedProvider as $u } from "@apollo/react-testing";
import { Button as qu } from "@mqd/volt-core";
import { setLocalFlag as Ku } from "@mqd/volt-toolbox";
import Wu from "apollo-boost";
function mi(e) {
  return Object.keys(e).reduce((t, r) => (t.append(r, e[r]), t), new URLSearchParams()).toString();
}
function Yu(e) {
  return Object.keys(e).length > 0 ? "?" + mi(e) : "";
}
function Xu() {
  return decodeURIComponent(`${window.location.pathname}${window.location.search}`);
}
const fa = {
  convertObjectToQuery: mi,
  convertObjectToSearch: Yu,
  windowPathnameAndSearchString: Xu
}, se = {
  getItem: (e) => localStorage.getItem(e),
  setItem: (e, t) => {
    localStorage.setItem(e, t);
  },
  removeItem: (e) => {
    localStorage.removeItem(e);
  },
  clear: () => {
    localStorage.clear();
  },
  findOrSetItem: (e, t) => {
    const r = se.getItem(e);
    let n;
    try {
      n = JSON.parse(r);
    } catch {
    }
    return [void 0, null].includes(n) ? (se.setItem(e, t), t) : r;
  },
  clearByMatch: (e) => {
    if (typeof e != "string")
      return;
    const t = new RegExp(e, "g");
    Object.keys(localStorage).forEach((r) => {
      r.match(t) && localStorage.removeItem(r);
    });
  }
}, hi = [
  { localStorageKey: "redsea_first_name" },
  { localStorageKey: "redsea_last_name" },
  { localStorageKey: "redsea_phone" },
  { localStorageKey: "redsea_email" },
  { localStorageKey: "redsea_token" },
  {
    localStorageKey: "redsea_mfa_totp_enabled",
    defaultVal: !1,
    parse: !0
  },
  { localStorageKey: "redseaPrograms", defaultVal: [], parse: !0 },
  { localStorageKey: "redseaRoles", defaultVal: [], parse: !0 },
  { localStorageKey: "redseaRolesToProgramsMap", defaultVal: [], parse: !0 },
  { localStorageKey: "redseaRolesToProgramsEnvironmentsMap", defaultVal: [], parse: !0 }
], gi = "prod", _i = "sbx", Ju = "Production", Zu = "Sandbox", Qu = "selectedEnvironment", yi = (e) => Array.from(new Set(e)), Si = (e) => {
  for (const t in e) {
    const r = e[t];
    e[t] = [...r];
  }
  return e;
}, mo = {
  first_name: "redsea_first_name",
  last_name: "redsea_last_name",
  phone: "redsea_phone",
  email: "redsea_email",
  mfa_enabled: "redsea_mfa_enabled",
  mfa_totp_enabled: "redsea_mfa_totp_enabled",
  token: "redsea_token"
}, el = (e) => yi(e.map((t) => t.domain_id)), bi = (e) => yi(e.map((t) => t.role_token)), wi = (e = []) => {
  const t = {};
  e.forEach(({ domain_type: r, domain_id: n, role_token: a }) => {
    r === "program" && (t[a] || (t[a] = /* @__PURE__ */ new Set()), t[a].add(n));
  });
  for (const r in t) {
    const n = t[r];
    t[r] = [...n];
  }
  return Si(t);
}, Ai = (e = []) => {
  const t = {};
  e.forEach(({ domain_type: r, domain_id: n, role_token: a, environment: o }) => {
    r === "program" && (t[a] || (t[a] = []), t[a].push({
      domain_id: n,
      environment: o
    }));
  });
  for (const r in t) {
    const n = t[r];
    t[r] = [...n];
  }
  return Si(t);
}, Ei = (e) => Object.entries(e).reduce((t, [r, n]) => {
  if (r === "roles") {
    const a = el(n), o = wi(n), i = Ai(n), s = bi(n);
    return {
      ...t,
      redseaPrograms: a,
      redseaRolesToProgramsMap: o,
      redseaRolesToProgramsEnvironmentsMap: i,
      redseaRoles: s
    };
  }
  if (mo[r]) {
    const a = mo[r];
    return {
      ...t,
      [a]: n
    };
  }
  return t;
}, {}), Ti = () => hi.forEach(({ localStorageKey: e }) => se.removeItem(e));
function Wr() {
  const e = sessionStorage.getItem("accessToken");
  return e ? {
    Authorization: `Bearer ${e}`
  } : null;
}
const Nb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extractRedseaRoles: bi,
  mapApiKeysToHumanReadableKeys: Ei,
  mapRolesToPrograms: wi,
  mapRolesToProgramsEnvironments: Ai,
  redseaAuthHeaders: Wr,
  removeRedseaUserKeysFromLocalStorage: Ti
}, Symbol.toStringTag, { value: "Module" }));
function pa(e, t = "") {
  return window.env && window.env[e] || t;
}
var Yr = {
  log: "log",
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
}, Xe = console, Dt = {};
Object.keys(Yr).forEach(function(e) {
  Dt[e] = Xe[e];
});
var rr = "Datadog Browser SDK:", H = {
  debug: Dt.debug.bind(Xe, rr),
  log: Dt.log.bind(Xe, rr),
  info: Dt.info.bind(Xe, rr),
  warn: Dt.warn.bind(Xe, rr),
  error: Dt.error.bind(Xe, rr)
};
function Ri(e, t) {
  return function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    try {
      return e.apply(void 0, r);
    } catch (a) {
      H.error(t, a);
    }
  };
}
var ve;
(function(e) {
  e.PAGEHIDE = "pagehide", e.FEATURE_FLAGS = "feature_flags", e.RESOURCE_PAGE_STATES = "resource_page_states", e.PAGE_STATES = "page_states", e.COLLECT_FLUSH_REASON = "collect_flush_reason", e.NO_RESOURCE_DURATION_FROZEN_STATE = "no_resource_duration_frozen_state", e.SCROLLMAP = "scrollmap", e.INTERACTION_TO_NEXT_PAINT = "interaction_to_next_paint", e.WEB_VITALS_ATTRIBUTION = "web_vitals_attribution", e.DISABLE_REPLAY_INLINE_CSS = "disable_replay_inline_css";
})(ve || (ve = {}));
var va = /* @__PURE__ */ new Set();
function tl(e) {
  e.forEach(function(t) {
    va.add(t);
  });
}
function Ie(e) {
  return va.has(e);
}
function rl() {
  return va;
}
function zt(e) {
  return e !== 0 && Math.random() * 100 <= e;
}
function jr(e, t) {
  return +e.toFixed(t);
}
function Bt(e) {
  return qt(e) && e >= 0 && e <= 100;
}
function qt(e) {
  return typeof e == "number";
}
var _e = 1e3, we = 60 * _e, Ci = 60 * we, nl = 24 * Ci, al = 365 * nl;
function ma(e) {
  return { relative: e, timeStamp: ol(e) };
}
function ol(e) {
  var t = Ve() - performance.now();
  return t > gr() ? Math.round(Kt(t, e)) : sl(e);
}
function il() {
  return Math.round(Ve() - Kt(gr(), performance.now()));
}
function X(e) {
  return qt(e) ? jr(e * 1e6, 0) : e;
}
function Ve() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function ue() {
  return Ve();
}
function Oe() {
  return performance.now();
}
function Re() {
  return { relative: Oe(), timeStamp: ue() };
}
function Ii() {
  return { relative: 0, timeStamp: gr() };
}
function ye(e, t) {
  return t - e;
}
function Kt(e, t) {
  return e + t;
}
function Oi(e) {
  return e - gr();
}
function sl(e) {
  return Math.round(Kt(gr(), e));
}
function cl(e) {
  return e < al;
}
var wn;
function gr() {
  return wn === void 0 && (wn = performance.timing.navigationStart), wn;
}
var bt = 1024, xi = 1024 * bt, ul = /[^\u0000-\u007F]/;
function pr(e) {
  return ul.test(e) ? window.TextEncoder !== void 0 ? new TextEncoder().encode(e).length : new Blob([e]).size : e.length;
}
function ll(e) {
  for (var t = e.reduce(function(s, c) {
    return s + c.length;
  }, 0), r = new Uint8Array(t), n = 0, a = 0, o = e; a < o.length; a++) {
    var i = o[a];
    r.set(i, n), n += i.length;
  }
  return r;
}
function Qe(e, t) {
  return e.indexOf(t) !== -1;
}
function ki(e) {
  if (Array.from)
    return Array.from(e);
  var t = [];
  if (e instanceof Set)
    e.forEach(function(n) {
      return t.push(n);
    });
  else
    for (var r = 0; r < e.length; r++)
      t.push(e[r]);
  return t;
}
function Wt(e, t) {
  for (var r = 0; r < e.length; r += 1) {
    var n = e[r];
    if (t(n, r))
      return n;
  }
}
function dl(e, t) {
  for (var r = e.length - 1; r >= 0; r -= 1) {
    var n = e[r];
    if (t(n, r, e))
      return n;
  }
}
function fl(e, t) {
  Array.prototype.forEach.call(e, t);
}
function Xr(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
function ha(e) {
  return Object.keys(e).map(function(t) {
    return [t, e[t]];
  });
}
function Jr(e, t) {
  return e.slice(0, t.length) === t;
}
function pl(e, t) {
  return e.slice(-t.length) === t;
}
function vl(e, t) {
  return e.matches ? e.matches(t) : e.msMatchesSelector ? e.msMatchesSelector(t) : !1;
}
function lt(e) {
  return window.CSS && window.CSS.escape ? window.CSS.escape(e) : e.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(t, r) {
    return r ? t === "\0" ? "�" : "".concat(t.slice(0, -1), "\\").concat(t.charCodeAt(t.length - 1).toString(16), " ") : "\\".concat(t);
  });
}
function B(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.forEach(function(n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
  }), e;
}
function vr(e) {
  return B({}, e);
}
function ga(e, t) {
  return Object.keys(e).some(function(r) {
    return e[r] === t;
  });
}
function Je(e) {
  return Object.keys(e).length === 0;
}
function ml(e, t) {
  for (var r = {}, n = 0, a = Object.keys(e); n < a.length; n++) {
    var o = a[n];
    r[o] = t(e[o]);
  }
  return r;
}
function pt() {
  if (typeof globalThis == "object")
    return globalThis;
  Object.defineProperty(Object.prototype, "_dd_temp_", {
    get: function() {
      return this;
    },
    configurable: !0
  });
  var e = _dd_temp_;
  return delete Object.prototype._dd_temp_, typeof e != "object" && (typeof self == "object" ? e = self : typeof window == "object" ? e = window : e = {}), e;
}
function dt(e, t) {
  var r = pt(), n;
  return r.Zone && typeof r.Zone.__symbol__ == "function" && (n = e[r.Zone.__symbol__(t)]), n || (n = e[t]), n;
}
var hl = function(e, t, r) {
  if (arguments.length === 2)
    for (var n = 0, a = t.length, o; n < a; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qn, Pi = !1;
function gl(e) {
  qn = e;
}
function _l(e) {
  Pi = e;
}
function D(e) {
  return function() {
    return ft(e, this, arguments);
  };
}
function ft(e, t, r) {
  try {
    return e.apply(t, r);
  } catch (n) {
    if (Kn(n), qn)
      try {
        qn(n);
      } catch (a) {
        Kn(a);
      }
  }
}
function Kn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  Pi && H.error.apply(H, hl(["[MONITOR]"], e, !1));
}
function pe(e, t) {
  return dt(pt(), "setTimeout")(D(e), t);
}
function je(e) {
  dt(pt(), "clearTimeout")(e);
}
function _r(e, t) {
  return dt(pt(), "setInterval")(D(e), t);
}
function _a(e) {
  dt(pt(), "clearInterval")(e);
}
var te = (
  /** @class */
  function() {
    function e(t) {
      this.onFirstSubscribe = t, this.observers = [];
    }
    return e.prototype.subscribe = function(t) {
      var r = this;
      return !this.observers.length && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe() || void 0), this.observers.push(t), {
        unsubscribe: function() {
          r.observers = r.observers.filter(function(n) {
            return t !== n;
          }), !r.observers.length && r.onLastUnsubscribe && r.onLastUnsubscribe();
        }
      };
    }, e.prototype.notify = function(t) {
      this.observers.forEach(function(r) {
        return r(t);
      });
    }, e;
  }()
);
function Ni() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = new te(function() {
    var n = e.map(function(a) {
      return a.subscribe(function(o) {
        return r.notify(o);
      });
    });
    return function() {
      return n.forEach(function(a) {
        return a.unsubscribe();
      });
    };
  });
  return r;
}
function tt(e, t, r) {
  var n = r && r.leading !== void 0 ? r.leading : !0, a = r && r.trailing !== void 0 ? r.trailing : !0, o = !1, i, s;
  return {
    throttled: function() {
      for (var c = [], u = 0; u < arguments.length; u++)
        c[u] = arguments[u];
      if (o) {
        i = c;
        return;
      }
      n ? e.apply(void 0, c) : i = c, o = !0, s = pe(function() {
        a && i && e.apply(void 0, i), o = !1, i = void 0;
      }, t);
    },
    cancel: function() {
      je(s), o = !1, i = void 0;
    }
  };
}
function Q() {
}
function Ae(e) {
  return e ? (
    // eslint-disable-next-line  no-bitwise
    (parseInt(e, 10) ^ Math.random() * 16 >> parseInt(e, 10) / 4).toString(16)
  ) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, Ae);
}
function Wn(e, t) {
  var r = new RegExp("(?:^|;)\\s*".concat(t, "\\s*=\\s*([^;]+)")), n = r.exec(e);
  return n ? n[1] : void 0;
}
function Li(e, t, r) {
  r === void 0 && (r = "");
  var n = e.charCodeAt(t - 1), a = n >= 55296 && n <= 56319, o = a ? t + 1 : t;
  return e.length <= o ? e : "".concat(e.slice(0, o)).concat(r);
}
var Yt = 4 * Ci, Di = 15 * we, Tr;
function yl() {
  return Tr ?? (Tr = !!document.documentMode);
}
var Rr;
function Sl() {
  return Rr ?? (Rr = !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent));
}
var Cr;
function bl() {
  return Cr ?? (Cr = /^((?!chrome|android).)*safari/i.test(navigator.userAgent));
}
function Zr(e, t, r, n) {
  var a = /* @__PURE__ */ new Date();
  a.setTime(a.getTime() + r);
  var o = "expires=".concat(a.toUTCString()), i = n && n.crossSite ? "none" : "strict", s = n && n.domain ? ";domain=".concat(n.domain) : "", c = n && n.secure ? ";secure" : "";
  document.cookie = "".concat(e, "=").concat(t, ";").concat(o, ";path=/;samesite=").concat(i).concat(s).concat(c);
}
function Be(e) {
  return Wn(document.cookie, e);
}
function ya(e, t) {
  Zr(e, "", 0, t);
}
function wl(e) {
  if (document.cookie === void 0 || document.cookie === null)
    return !1;
  try {
    var t = "dd_cookie_test_".concat(Ae()), r = "test";
    Zr(t, r, we, e);
    var n = Be(t) === r;
    return ya(t, e), n;
  } catch (a) {
    return H.error(a), !1;
  }
}
var An;
function Al() {
  if (An === void 0) {
    for (var e = "dd_site_test_".concat(Ae()), t = "test", r = window.location.hostname.split("."), n = r.pop(); r.length && !Be(e); )
      n = "".concat(r.pop(), ".").concat(n), Zr(e, t, _e, { domain: n });
    ya(e, { domain: n }), An = n;
  }
  return An;
}
var At = "_dd_s", Mi = /^([a-z]+)=([a-z0-9-]+)$/, Sa = "&";
function Yn(e) {
  return Je(e);
}
function Ui(e) {
  e.expire = String(Ve() + Di);
}
function Fi(e) {
  return ha(e).map(function(t) {
    var r = t[0], n = t[1];
    return "".concat(r, "=").concat(n);
  }).join(Sa);
}
function ji(e) {
  var t = {};
  return El(e) && e.split(Sa).forEach(function(r) {
    var n = Mi.exec(r);
    if (n !== null) {
      var a = n[1], o = n[2];
      t[a] = o;
    }
  }), t;
}
function El(e) {
  return !!e && (e.indexOf(Sa) !== -1 || Mi.test(e));
}
var Tl = "_dd", Rl = "_dd_r", Cl = "_dd_l", Il = "rum", Ol = "logs";
function xl(e) {
  var t = Be(At);
  if (!t) {
    var r = Be(Tl), n = Be(Rl), a = Be(Cl), o = {};
    r && (o.id = r), a && /^[01]$/.test(a) && (o[Ol] = a), n && /^[012]$/.test(n) && (o[Il] = n), Yn(o) || (Ui(o), e.persistSession(o));
  }
}
function kl(e) {
  var t = Ml(e);
  return wl(t) ? { type: "Cookie", cookieOptions: t } : void 0;
}
function Pl(e) {
  var t = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: Sl(),
    persistSession: Nl(e),
    retrieveSession: Ll,
    clearSession: Dl(e)
  };
  return xl(t), t;
}
function Nl(e) {
  return function(t) {
    Zr(At, Fi(t), Di, e);
  };
}
function Ll() {
  var e = Be(At);
  return ji(e);
}
function Dl(e) {
  return function() {
    ya(At, e);
  };
}
function Ml(e) {
  var t = {};
  return t.secure = !!e.useSecureSessionCookie || !!e.useCrossSiteSessionCookie, t.crossSite = !!e.useCrossSiteSessionCookie, e.trackSessionAcrossSubdomains && (t.domain = Al()), t;
}
var Ul = "_dd_test_";
function Fl() {
  try {
    var e = Ae(), t = "".concat(Ul).concat(e);
    localStorage.setItem(t, e);
    var r = localStorage.getItem(t);
    return localStorage.removeItem(t), e === r ? { type: "LocalStorage" } : void 0;
  } catch {
    return;
  }
}
function jl() {
  return {
    isLockEnabled: !1,
    persistSession: Bl,
    retrieveSession: Vl,
    clearSession: zl
  };
}
function Bl(e) {
  localStorage.setItem(At, Fi(e));
}
function Vl() {
  var e = localStorage.getItem(At);
  return ji(e);
}
function zl() {
  localStorage.removeItem(At);
}
var Hl = 10, Gl = 100, Bi = [], Dr;
function cr(e, t, r) {
  var n;
  r === void 0 && (r = 0);
  var a = t.isLockEnabled, o = t.retrieveSession, i = t.persistSession, s = t.clearSession;
  if (Dr || (Dr = e), e !== Dr) {
    Bi.push(e);
    return;
  }
  if (a && r >= Gl) {
    ho(t);
    return;
  }
  var c, u = o();
  if (a) {
    if (u.lock) {
      Ir(e, t, r);
      return;
    }
    if (c = Ae(), u.lock = c, i(u), u = o(), u.lock !== c) {
      Ir(e, t, r);
      return;
    }
  }
  var l = e.process(u);
  if (a && (u = o(), u.lock !== c)) {
    Ir(e, t, r);
    return;
  }
  if (l && (Yn(l) ? s() : (Ui(l), i(l))), a && !(l && Yn(l))) {
    if (u = o(), u.lock !== c) {
      Ir(e, t, r);
      return;
    }
    delete u.lock, i(u), l = u;
  }
  (n = e.after) === null || n === void 0 || n.call(e, l || u), ho(t);
}
function Ir(e, t, r) {
  pe(function() {
    cr(e, t, r + 1);
  }, Hl);
}
function ho(e) {
  Dr = void 0;
  var t = Bi.shift();
  t && cr(t, e);
}
var go = _e;
function $l(e) {
  var t = kl(e);
  return !t && e.allowFallbackToLocalStorage && (t = Fl()), t;
}
function ql(e, t, r) {
  var n = new te(), a = new te(), o = e.type === "Cookie" ? Pl(e.cookieOptions) : jl(), i = o.clearSession, s = o.retrieveSession, c = _r(p, go), u = F();
  function l() {
    var R;
    cr({
      process: function(L) {
        var j = m(L);
        return R = g(j), j;
      },
      after: function(L) {
        R && !S() && T(L), u = L;
      }
    }, o);
  }
  function f() {
    cr({
      process: function(R) {
        return S() ? m(R) : void 0;
      }
    }, o);
  }
  function p() {
    cr({
      process: function(R) {
        return M(R) ? void 0 : {};
      },
      after: m
    }, o);
  }
  function m(R) {
    return M(R) || (R = {}), S() && (x(R) ? P() : u = R), R;
  }
  function g(R) {
    var L = r(R[t]), j = L.trackingType, ne = L.isTracked;
    return R[t] = j, ne && !R.id && (R.id = Ae(), R.created = String(Ve())), ne;
  }
  function S() {
    return u[t] !== void 0;
  }
  function x(R) {
    return u.id !== R.id || u[t] !== R[t];
  }
  function P() {
    u = {}, a.notify();
  }
  function T(R) {
    u = R, n.notify();
  }
  function F() {
    var R = s();
    return M(R) ? R : {};
  }
  function M(R) {
    return (R.created === void 0 || Ve() - Number(R.created) < Yt) && (R.expire === void 0 || Ve() < Number(R.expire));
  }
  return {
    expandOrRenewSession: tt(l, go).throttled,
    expandSession: f,
    getSession: function() {
      return u;
    },
    renewObservable: n,
    expireObservable: a,
    expire: function() {
      i(), m({});
    },
    stop: function() {
      _a(c);
    }
  };
}
function Et(e, t, r) {
  if (typeof e != "object" || e === null)
    return JSON.stringify(e);
  var n = Ut(Object.prototype), a = Ut(Array.prototype), o = Ut(Object.getPrototypeOf(e)), i = Ut(e);
  try {
    return JSON.stringify(e, t, r);
  } catch {
    return "<error: unable to serialize object>";
  } finally {
    n(), a(), o(), i();
  }
}
function Ut(e) {
  var t = e, r = t.toJSON;
  return r ? (delete t.toJSON, function() {
    t.toJSON = r;
  }) : Q;
}
function Br(e) {
  return yr(e, Xl()).href;
}
function Kl(e) {
  try {
    return !!yr(e);
  } catch {
    return !1;
  }
}
function _o(e) {
  return Vi(yr(e));
}
function Wl(e) {
  var t = yr(e).pathname;
  return t[0] === "/" ? t : "/".concat(t);
}
function yr(e, t) {
  var r = Yl();
  if (r)
    try {
      return t !== void 0 ? new r(e, t) : new r(e);
    } catch (i) {
      throw new Error("Failed to construct URL: ".concat(String(i), " ").concat(Et({ url: e, base: t })));
    }
  if (t === void 0 && !/:/.test(e))
    throw new Error("Invalid URL: '".concat(e, "'"));
  var n = document, a = n.createElement("a");
  if (t !== void 0) {
    n = document.implementation.createHTMLDocument("");
    var o = n.createElement("base");
    o.href = t, n.head.appendChild(o), n.body.appendChild(a);
  }
  return a.href = e, a;
}
var yo = URL, Or;
function Yl() {
  if (Or === void 0)
    try {
      var e = new yo("http://test/path");
      Or = e.href === "http://test/path";
    } catch {
      Or = !1;
    }
  return Or ? yo : void 0;
}
function Xl() {
  return Vi(window.location);
}
function Vi(e) {
  if (e.origin && e.origin !== "null")
    return e.origin;
  var t = e.host.replace(/(:80|:443)$/, "");
  return "".concat(e.protocol, "//").concat(t);
}
var zi = "datad0g.com", Vt = "datadoghq.com", Jl = "datadoghq.eu", Zl = "ap1.datadoghq.com", Ql = "ddog-gov.com", ed = {
  logs: "logs",
  rum: "rum",
  sessionReplay: "session-replay"
}, td = {
  logs: "logs",
  rum: "rum",
  sessionReplay: "replay"
};
function ur(e, t, r) {
  var n = rd(e, t);
  return {
    build: function(a, o) {
      var i = ad(e, t, r, a, o);
      return n(i);
    },
    urlPrefix: n(""),
    endpointType: t
  };
}
function rd(e, t) {
  var r = "/api/v2/".concat(td[t]), n = e.proxy, a = e.proxyUrl;
  if (n) {
    var o = Br(n);
    return function(c) {
      return "".concat(o, "?ddforward=").concat(encodeURIComponent("".concat(r, "?").concat(c)));
    };
  }
  var i = nd(e, t);
  if (n === void 0 && a) {
    var s = Br(a);
    return function(c) {
      return "".concat(s, "?ddforward=").concat(encodeURIComponent("https://".concat(i).concat(r, "?").concat(c)));
    };
  }
  return function(c) {
    return "https://".concat(i).concat(r, "?").concat(c);
  };
}
function nd(e, t) {
  var r = e.site, n = r === void 0 ? Vt : r, a = e.internalAnalyticsSubdomain;
  if (a && n === Vt)
    return "".concat(a, ".").concat(Vt);
  var o = n.split("."), i = o.pop(), s = n !== Zl ? "".concat(ed[t], ".") : "";
  return "".concat(s, "browser-intake-").concat(o.join("-"), ".").concat(i);
}
function ad(e, t, r, n, a) {
  var o = e.clientToken, i = e.internalAnalyticsSubdomain, s = a.retry, c = a.flushReason, u = a.encoding, l = ["sdk_version:".concat("4.50.1"), "api:".concat(n)].concat(r);
  c && Ie(ve.COLLECT_FLUSH_REASON) && l.push("flush_reason:".concat(c)), s && l.push("retry_count:".concat(s.count), "retry_after:".concat(s.lastFailureStatus));
  var f = [
    "ddsource=browser",
    "ddtags=".concat(encodeURIComponent(l.join(","))),
    "dd-api-key=".concat(o),
    "dd-evp-origin-version=".concat(encodeURIComponent("4.50.1")),
    "dd-evp-origin=browser",
    "dd-request-id=".concat(Ae())
  ];
  return u && f.push("dd-evp-encoding=".concat(u)), t === "rum" && f.push("batch_time=".concat(ue())), i && f.reverse(), f.join("&");
}
var od = 200;
function id(e) {
  var t = e.env, r = e.service, n = e.version, a = e.datacenter, o = [];
  return t && o.push(xr("env", t)), r && o.push(xr("service", r)), n && o.push(xr("version", n)), a && o.push(xr("datacenter", a)), o;
}
var sd = /[^a-z0-9_:./-]/;
function xr(e, t) {
  var r = od - e.length - 1;
  (t.length > r || sd.test(t)) && H.warn("".concat(e, " value doesn't meet tag requirements and will be sanitized"));
  var n = t.replace(/,/g, "_");
  return "".concat(e, ":").concat(n);
}
function cd(e) {
  var t = id(e), r = ud(e, t), n = Xr(r).map(function(o) {
    return o.urlPrefix;
  }), a = ld(e, n, t);
  return B({
    isIntakeUrl: function(o) {
      return n.some(function(i) {
        return o.indexOf(i) === 0;
      });
    },
    replica: a,
    site: e.site || Vt
  }, r);
}
function ud(e, t) {
  return {
    logsEndpointBuilder: ur(e, "logs", t),
    rumEndpointBuilder: ur(e, "rum", t),
    sessionReplayEndpointBuilder: ur(e, "sessionReplay", t)
  };
}
function ld(e, t, r) {
  if (e.replica) {
    var n = B({}, e, {
      site: Vt,
      clientToken: e.replica.clientToken
    }), a = {
      logsEndpointBuilder: ur(n, "logs", r),
      rumEndpointBuilder: ur(n, "rum", r)
    };
    return t.push.apply(t, Xr(a).map(function(o) {
      return o.urlPrefix;
    })), B({ applicationId: e.replica.applicationId }, a);
  }
}
var lr = {
  ALLOW: "allow",
  MASK: "mask",
  MASK_USER_INPUT: "mask-user-input"
};
function dd(e) {
  var t, r, n;
  if (!e || !e.clientToken) {
    H.error("Client Token is not configured, we will not send any data.");
    return;
  }
  var a = (t = e.sessionSampleRate) !== null && t !== void 0 ? t : e.sampleRate;
  if (a !== void 0 && !Bt(a)) {
    H.error("Session Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.telemetrySampleRate !== void 0 && !Bt(e.telemetrySampleRate)) {
    H.error("Telemetry Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.telemetryConfigurationSampleRate !== void 0 && !Bt(e.telemetryConfigurationSampleRate)) {
    H.error("Telemetry Configuration Sample Rate should be a number between 0 and 100");
    return;
  }
  return Array.isArray(e.enableExperimentalFeatures) && tl(e.enableExperimentalFeatures.filter(function(o) {
    return ga(ve, o);
  })), B({
    beforeSend: e.beforeSend && Ri(e.beforeSend, "beforeSend threw an error:"),
    sessionStoreStrategyType: $l(e),
    sessionSampleRate: a ?? 100,
    telemetrySampleRate: (r = e.telemetrySampleRate) !== null && r !== void 0 ? r : 20,
    telemetryConfigurationSampleRate: (n = e.telemetryConfigurationSampleRate) !== null && n !== void 0 ? n : 5,
    service: e.service,
    silentMultipleInit: !!e.silentMultipleInit,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * bt,
    eventRateLimiterThreshold: 3e3,
    maxTelemetryEventsPerPage: 15,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * _e,
    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * bt
  }, cd(e));
}
function fd(e) {
  var t, r, n = (t = e.proxy) !== null && t !== void 0 ? t : e.proxyUrl;
  return {
    session_sample_rate: (r = e.sessionSampleRate) !== null && r !== void 0 ? r : e.sampleRate,
    telemetry_sample_rate: e.telemetrySampleRate,
    telemetry_configuration_sample_rate: e.telemetryConfigurationSampleRate,
    use_before_send: !!e.beforeSend,
    use_cross_site_session_cookie: e.useCrossSiteSessionCookie,
    use_secure_session_cookie: e.useSecureSessionCookie,
    use_proxy: n !== void 0 ? !!n : void 0,
    silent_multiple_init: e.silentMultipleInit,
    track_session_across_subdomains: e.trackSessionAcrossSubdomains,
    track_resources: e.trackResources,
    track_long_task: e.trackLongTasks,
    allow_fallback_to_local_storage: !!e.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!e.storeContextsAcrossPages
  };
}
var Sr = "?";
function vt(e) {
  var t = [], r = En(e, "stack"), n = String(e);
  return r && Jr(r, n) && (r = r.slice(n.length)), r && r.split(`
`).forEach(function(a) {
    var o = md(a) || gd(a) || yd(a) || wd(a);
    o && (!o.func && o.line && (o.func = Sr), t.push(o));
  }), {
    message: En(e, "message"),
    name: En(e, "name"),
    stack: t
  };
}
var Hi = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", Ht = "(?::(\\d+))", pd = new RegExp("^\\s*at (.*?) ?\\(".concat(Hi).concat(Ht, "?").concat(Ht, "?\\)?\\s*$"), "i"), vd = new RegExp("\\((\\S*)".concat(Ht).concat(Ht, "\\)"));
function md(e) {
  var t = pd.exec(e);
  if (t) {
    var r = t[2] && t[2].indexOf("native") === 0, n = t[2] && t[2].indexOf("eval") === 0, a = vd.exec(t[2]);
    return n && a && (t[2] = a[1], t[3] = a[2], t[4] = a[3]), {
      args: r ? [t[2]] : [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || Sr,
      line: t[3] ? +t[3] : void 0,
      url: r ? void 0 : t[2]
    };
  }
}
var hd = new RegExp("^\\s*at ?".concat(Hi).concat(Ht, "?").concat(Ht, "??\\s*$"), "i");
function gd(e) {
  var t = hd.exec(e);
  if (t)
    return {
      args: [],
      column: t[3] ? +t[3] : void 0,
      func: Sr,
      line: t[2] ? +t[2] : void 0,
      url: t[1]
    };
}
var _d = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function yd(e) {
  var t = _d.exec(e);
  if (t)
    return {
      args: [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || Sr,
      line: +t[3],
      url: t[2]
    };
}
var Sd = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, bd = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function wd(e) {
  var t = Sd.exec(e);
  if (t) {
    var r = t[3] && t[3].indexOf(" > eval") > -1, n = bd.exec(t[3]);
    return r && n && (t[3] = n[1], t[4] = n[2], t[5] = void 0), {
      args: t[2] ? t[2].split(",") : [],
      column: t[5] ? +t[5] : void 0,
      func: t[1] || Sr,
      line: t[4] ? +t[4] : void 0,
      url: t[3]
    };
  }
}
function En(e, t) {
  if (!(typeof e != "object" || !e || !(t in e))) {
    var r = e[t];
    return typeof r == "string" ? r : void 0;
  }
}
function Gi(e, t, r) {
  var n = e[t], a = r(n), o = function() {
    if (typeof a == "function")
      return a.apply(this, arguments);
  };
  return e[t] = o, {
    stop: function() {
      e[t] === o ? e[t] = n : a = n;
    }
  };
}
function Te(e, t, r) {
  var n = r.before, a = r.after;
  return Gi(e, t, function(o) {
    return function() {
      var i = arguments, s;
      return n && ft(n, this, i), typeof o == "function" && (s = o.apply(this, i)), a && ft(a, this, i), s;
    };
  });
}
function nr(e, t, r) {
  var n = Object.getOwnPropertyDescriptor(e, t);
  if (!n || !n.set || !n.configurable)
    return { stop: Q };
  var a = function(i, s) {
    pe(function() {
      r(i, s);
    }, 0);
  }, o = function(i) {
    n.set.call(this, i), a(this, i);
  };
  return Object.defineProperty(e, t, {
    set: o
  }), {
    stop: function() {
      var i;
      ((i = Object.getOwnPropertyDescriptor(e, t)) === null || i === void 0 ? void 0 : i.set) === o ? Object.defineProperty(e, t, n) : a = Q;
    }
  };
}
var Ad = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function Ed(e) {
  var t = Td(e).stop, r = Cd(e).stop;
  return {
    stop: function() {
      t(), r();
    }
  };
}
function Td(e) {
  return Te(window, "onerror", {
    before: function(t, r, n, a, o) {
      var i;
      if (o instanceof Error)
        i = vt(o);
      else {
        var s = [{ url: r, column: a, line: n }], c = Rd(t), u = c.name, l = c.message;
        i = {
          name: u,
          message: l,
          stack: s
        };
      }
      e(i, o ?? t);
    }
  });
}
function Rd(e) {
  var t, r, n;
  return {}.toString.call(e) === "[object String]" && (t = Ad.exec(e), r = t[1], n = t[2]), { name: r, message: n };
}
function Cd(e) {
  return Te(window, "onunhandledrejection", {
    before: function(t) {
      var r = t.reason || "Empty reason", n = vt(r);
      e(n, r);
    }
  });
}
var Id = 220 * bt, Od = "$", xd = 3;
function Ce(e, t) {
  var r;
  t === void 0 && (t = Id);
  var n = Ut(Object.prototype), a = Ut(Array.prototype), o = [], i = /* @__PURE__ */ new WeakMap(), s = Tn(e, Od, void 0, o, i), c = ((r = JSON.stringify(s)) === null || r === void 0 ? void 0 : r.length) || 0;
  if (c > t) {
    Rn(t, "discarded", e);
    return;
  }
  for (; o.length > 0 && c < t; ) {
    var u = o.shift(), l = 0;
    if (Array.isArray(u.source))
      for (var f = 0; f < u.source.length; f++) {
        var p = Tn(u.source[f], u.path, f, o, i);
        if (p !== void 0 ? c += JSON.stringify(p).length : c += 4, c += l, l = 1, c > t) {
          Rn(t, "truncated", e);
          break;
        }
        u.target[f] = p;
      }
    else
      for (var f in u.source)
        if (Object.prototype.hasOwnProperty.call(u.source, f)) {
          var p = Tn(u.source[f], u.path, f, o, i);
          if (p !== void 0 && (c += JSON.stringify(p).length + l + f.length + xd, l = 1), c > t) {
            Rn(t, "truncated", e);
            break;
          }
          u.target[f] = p;
        }
  }
  return n(), a(), s;
}
function Tn(e, t, r, n, a) {
  var o = Nd(e);
  if (!o || typeof o != "object")
    return kd(o);
  var i = Pd(o);
  if (i !== "[Object]" && i !== "[Array]" && i !== "[Error]")
    return i;
  var s = e;
  if (a.has(s))
    return "[Reference seen at ".concat(a.get(s), "]");
  var c = r !== void 0 ? "".concat(t, ".").concat(r) : t, u = Array.isArray(o) ? [] : {};
  return a.set(s, c), n.push({ source: o, target: u, path: c }), u;
}
function kd(e) {
  return typeof e == "bigint" ? "[BigInt] ".concat(e.toString()) : typeof e == "function" ? "[Function] ".concat(e.name || "unknown") : typeof e == "symbol" ? "[Symbol] ".concat(e.description || e.toString()) : e;
}
function Pd(e) {
  try {
    if (e instanceof Event)
      return {
        isTrusted: e.isTrusted
      };
    var t = Object.prototype.toString.call(e), r = t.match(/\[object (.*)\]/);
    if (r && r[1])
      return "[".concat(r[1], "]");
  } catch {
  }
  return "[Unserializable]";
}
function Nd(e) {
  var t = e;
  if (t && typeof t.toJSON == "function")
    try {
      return t.toJSON();
    } catch {
    }
  return e;
}
function Rn(e, t, r) {
  H.warn("The data provided has been ".concat(t, " as it is over the limit of ").concat(e, " characters:"), r);
}
var $i = "No stack, consider using an instance of Error";
function qi(e) {
  var t = e.stackTrace, r = e.originalError, n = e.handlingStack, a = e.startClocks, o = e.nonErrorPrefix, i = e.source, s = e.handling, c = r instanceof Error, u = Ld(t, c, o, r), l = Dd(c, t) ? Xt(t) : $i, f = c ? Md(r, i) : void 0, p = t == null ? void 0 : t.name, m = Ki(r);
  return {
    startClocks: a,
    source: i,
    handling: s,
    handlingStack: n,
    originalError: r,
    type: p,
    message: u,
    stack: l,
    causes: f,
    fingerprint: m
  };
}
function Ld(e, t, r, n) {
  return e != null && e.message && (e != null && e.name) ? e.message : t ? "Empty message" : "".concat(r, " ").concat(Et(Ce(n)));
}
function Dd(e, t) {
  return t === void 0 ? !1 : e ? !0 : t.stack.length > 0 && (t.stack.length > 1 || t.stack[0].url !== void 0);
}
function Ki(e) {
  return e instanceof Error && "dd_fingerprint" in e ? String(e.dd_fingerprint) : void 0;
}
function Xt(e) {
  var t = Wi(e);
  return e.stack.forEach(function(r) {
    var n = r.func === "?" ? "<anonymous>" : r.func, a = r.args && r.args.length > 0 ? "(".concat(r.args.join(", "), ")") : "", o = r.line ? ":".concat(r.line) : "", i = r.line && r.column ? ":".concat(r.column) : "";
    t += `
  at `.concat(n).concat(a, " @ ").concat(r.url).concat(o).concat(i);
  }), t;
}
function Wi(e) {
  return "".concat(e.name || "Error", ": ").concat(e.message);
}
function Yi() {
  var e = 2, t = new Error(), r;
  if (!t.stack)
    try {
      throw t;
    } catch {
    }
  return ft(function() {
    var n = vt(t);
    n.stack = n.stack.slice(e), r = Xt(n);
  }), r;
}
function Md(e, t) {
  for (var r = e, n = []; (r == null ? void 0 : r.cause) instanceof Error && n.length < 10; ) {
    var a = vt(r.cause);
    n.push({
      message: r.cause.message,
      source: t,
      type: a == null ? void 0 : a.name,
      stack: a && Xt(a)
    }), r = r.cause;
  }
  return n.length ? n : void 0;
}
var Jt = {
  AGENT: "agent",
  CONSOLE: "console",
  CUSTOM: "custom",
  LOGGER: "logger",
  NETWORK: "network",
  SOURCE: "source",
  REPORT: "report"
};
function Ud(e) {
  return Ed(function(t, r) {
    e.notify(qi({
      stackTrace: t,
      originalError: r,
      startClocks: Re(),
      nonErrorPrefix: "Uncaught",
      source: Jt.SOURCE,
      handling: "unhandled"
    }));
  });
}
function Fd(e) {
  var t = B({
    version: "4.50.1",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function(r) {
      r();
    }
  }, e);
  return Object.defineProperty(t, "_setDebug", {
    get: function() {
      return _l;
    },
    enumerable: !1
  }), t;
}
function jd(e, t, r) {
  var n = e[t];
  e[t] = r, n && n.q && n.q.forEach(function(a) {
    return Ri(a, "onReady callback threw an error:")();
  });
}
function oe(e, t, r, n, a) {
  return Se(e, t, [r], n, a);
}
function Se(e, t, r, n, a) {
  var o = a === void 0 ? {} : a, i = o.once, s = o.capture, c = o.passive, u = D(i ? function(m) {
    p(), n(m);
  } : n), l = c ? { capture: s, passive: c } : s, f = dt(t, "addEventListener");
  r.forEach(function(m) {
    return f.call(t, m, u, l);
  });
  function p() {
    var m = dt(t, "removeEventListener");
    r.forEach(function(g) {
      return m.call(t, g, u, l);
    });
  }
  return {
    stop: p
  };
}
var Gt = {
  intervention: "intervention",
  deprecation: "deprecation",
  cspViolation: "csp_violation"
};
function Bd(e, t) {
  var r = [];
  Qe(t, Gt.cspViolation) && r.push(zd(e));
  var n = t.filter(function(a) {
    return a !== Gt.cspViolation;
  });
  return n.length && r.push(Vd(n)), Ni.apply(void 0, r);
}
function Vd(e) {
  var t = new te(function() {
    if (window.ReportingObserver) {
      var r = D(function(a, o) {
        return a.forEach(function(i) {
          t.notify(Hd(i));
        });
      }), n = new window.ReportingObserver(r, {
        types: e,
        buffered: !0
      });
      return n.observe(), function() {
        n.disconnect();
      };
    }
  });
  return t;
}
function zd(e) {
  var t = new te(function() {
    var r = oe(e, document, "securitypolicyviolation", function(n) {
      t.notify(Gd(n));
    }).stop;
    return r;
  });
  return t;
}
function Hd(e) {
  var t = e.type, r = e.body;
  return {
    type: t,
    subtype: r.id,
    message: "".concat(t, ": ").concat(r.message),
    stack: Xi(r.id, r.message, r.sourceFile, r.lineNumber, r.columnNumber)
  };
}
function Gd(e) {
  var t = Gt.cspViolation, r = "'".concat(e.blockedURI, "' blocked by '").concat(e.effectiveDirective, "' directive");
  return {
    type: Gt.cspViolation,
    subtype: e.effectiveDirective,
    message: "".concat(t, ": ").concat(r),
    stack: Xi(e.effectiveDirective, e.originalPolicy ? "".concat(r, ' of the policy "').concat(Li(e.originalPolicy, 100, "..."), '"') : "no policy", e.sourceFile, e.lineNumber, e.columnNumber)
  };
}
function Xi(e, t, r, n, a) {
  return r ? Xt({
    name: e,
    message: t,
    stack: [
      {
        func: "?",
        url: r,
        line: n ?? void 0,
        column: a ?? void 0
      }
    ]
  }) : void 0;
}
function ba(e, t) {
  var r = window.__ddBrowserSdkExtensionCallback;
  r && r({ type: e, payload: t });
}
function mt(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function Vr(e, t, r) {
  if (r === void 0 && (r = $d()), t === void 0)
    return e;
  if (typeof t != "object" || t === null)
    return t;
  if (t instanceof Date)
    return new Date(t.getTime());
  if (t instanceof RegExp) {
    var n = t.flags || // old browsers compatibility
    [
      t.global ? "g" : "",
      t.ignoreCase ? "i" : "",
      t.multiline ? "m" : "",
      t.sticky ? "y" : "",
      t.unicode ? "u" : ""
    ].join("");
    return new RegExp(t.source, n);
  }
  if (!r.hasAlreadyBeenSeen(t)) {
    if (Array.isArray(t)) {
      for (var a = Array.isArray(e) ? e : [], o = 0; o < t.length; ++o)
        a[o] = Vr(a[o], t[o], r);
      return a;
    }
    var i = mt(e) === "object" ? e : {};
    for (var s in t)
      Object.prototype.hasOwnProperty.call(t, s) && (i[s] = Vr(i[s], t[s], r));
    return i;
  }
}
function wa(e) {
  return Vr(void 0, e);
}
function Ge() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r, n = 0, a = e; n < a.length; n++) {
    var o = a[n];
    o != null && (r = Vr(r, o));
  }
  return r;
}
function $d() {
  if (typeof WeakSet < "u") {
    var e = /* @__PURE__ */ new WeakSet();
    return {
      hasAlreadyBeenSeen: function(r) {
        var n = e.has(r);
        return n || e.add(r), n;
      }
    };
  }
  var t = [];
  return {
    hasAlreadyBeenSeen: function(r) {
      var n = t.indexOf(r) >= 0;
      return n || t.push(r), n;
    }
  };
}
var Aa = {
  log: "log",
  configuration: "configuration"
}, qd = [
  "https://www.datadoghq-browser-agent.com",
  "https://www.datad0g-browser-agent.com",
  "https://d3uc069fcn7uxw.cloudfront.net",
  "https://d20xtzwzcl0ceb.cloudfront.net",
  "http://localhost",
  "<anonymous>"
], Kd = [Ql], Me = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: !1, telemetryConfigurationEnabled: !1 }, Xn;
function Wd(e, t) {
  var r, n = new te();
  Me.telemetryEnabled = !Qe(Kd, t.site) && zt(t.telemetrySampleRate), Me.telemetryConfigurationEnabled = Me.telemetryEnabled && zt(t.telemetryConfigurationSampleRate);
  var a = Yd();
  Xn = function(i) {
    if (Me.telemetryEnabled) {
      var s = o(e, i, a);
      n.notify(s), ba("telemetry", s);
    }
  }, gl(zr), B(Me, {
    maxEventsPerPage: t.maxTelemetryEventsPerPage,
    sentEventCount: 0
  });
  function o(i, s, c) {
    return Ge({
      type: "telemetry",
      date: ue(),
      service: i,
      version: "4.50.1",
      source: "browser",
      _dd: {
        format_version: 2
      },
      telemetry: Ge(s, {
        runtime_env: c
      }),
      experimental_features: ki(rl())
    }, r !== void 0 ? r() : {});
  }
  return {
    setContextProvider: function(i) {
      r = i;
    },
    observable: n,
    enabled: Me.telemetryEnabled
  };
}
function Yd() {
  return {
    is_local_file: window.location.protocol === "file:",
    is_worker: "WorkerGlobalScope" in self
  };
}
function Xd(e) {
  return e.site === zi;
}
function Tt(e, t) {
  Kn(Yr.debug, e, t), Ea(B({
    type: Aa.log,
    message: e,
    status: "debug"
  }, t));
}
function zr(e, t) {
  Ea(B({
    type: Aa.log,
    status: "error"
  }, Zd(e), t));
}
function Jd(e) {
  Me.telemetryConfigurationEnabled && Ea({
    type: Aa.configuration,
    configuration: e
  });
}
function Ea(e) {
  Xn && Me.sentEventCount < Me.maxEventsPerPage && (Me.sentEventCount += 1, Xn(e));
}
function Zd(e) {
  if (e instanceof Error) {
    var t = vt(e);
    return {
      error: {
        kind: t.name,
        stack: Xt(Qd(t))
      },
      message: t.message
    };
  }
  return {
    error: {
      stack: $i
    },
    message: "".concat("Uncaught", " ").concat(Et(e))
  };
}
function Qd(e) {
  return e.stack = e.stack.filter(function(t) {
    return !t.url || qd.some(function(r) {
      return Jr(t.url, r);
    });
  }), e;
}
var kr = 1 / 0, ef = we, Zt = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this.expireDelay = t, this.maxEntries = r, this.entries = [], this.clearOldValuesInterval = _r(function() {
        return n.clearOldValues();
      }, ef);
    }
    return e.prototype.add = function(t, r) {
      var n = this, a = {
        value: t,
        startTime: r,
        endTime: kr,
        remove: function() {
          var o = n.entries.indexOf(a);
          o >= 0 && n.entries.splice(o, 1);
        },
        close: function(o) {
          a.endTime = o;
        }
      };
      return this.maxEntries && this.entries.length >= this.maxEntries && this.entries.pop(), this.entries.unshift(a), a;
    }, e.prototype.find = function(t) {
      t === void 0 && (t = kr);
      for (var r = 0, n = this.entries; r < n.length; r++) {
        var a = n[r];
        if (a.startTime <= t) {
          if (t <= a.endTime)
            return a.value;
          break;
        }
      }
    }, e.prototype.closeActive = function(t) {
      var r = this.entries[0];
      r && r.endTime === kr && r.close(t);
    }, e.prototype.findAll = function(t, r) {
      t === void 0 && (t = kr), r === void 0 && (r = 0);
      var n = Kt(t, r);
      return this.entries.filter(function(a) {
        return a.startTime <= n && t <= a.endTime;
      }).map(function(a) {
        return a.value;
      });
    }, e.prototype.reset = function() {
      this.entries = [];
    }, e.prototype.stop = function() {
      _a(this.clearOldValuesInterval);
    }, e.prototype.clearOldValues = function() {
      for (var t = Oe() - this.expireDelay; this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < t; )
        this.entries.pop();
    }, e;
  }()
), tf = we, rf = Yt;
function nf(e, t, r) {
  var n = ql(e.sessionStoreStrategyType, t, r), a = new Zt(rf);
  n.renewObservable.subscribe(function() {
    a.add(o(), Oe());
  }), n.expireObservable.subscribe(function() {
    a.closeActive(Oe());
  }), n.expandOrRenewSession(), a.add(o(), Ii().relative), af(e, function() {
    return n.expandOrRenewSession();
  }), of(e, function() {
    return n.expandSession();
  });
  function o() {
    return {
      id: n.getSession().id,
      trackingType: n.getSession()[t]
    };
  }
  return {
    findActiveSession: function(i) {
      return a.find(i);
    },
    renewObservable: n.renewObservable,
    expireObservable: n.expireObservable,
    expire: n.expire
  };
}
function af(e, t) {
  Se(e, window, [
    "click",
    "touchstart",
    "keydown",
    "scroll"
    /* DOM_EVENT.SCROLL */
  ], t, { capture: !0, passive: !0 }).stop;
}
function of(e, t) {
  var r = function() {
    document.visibilityState === "visible" && t();
  };
  oe(e, document, "visibilitychange", r).stop, _r(r, tf);
}
function sf(e) {
  return e >= 500;
}
function cf(e) {
  try {
    return e.clone();
  } catch {
    return;
  }
}
var uf = 80 * bt, lf = 32, Ji = 3 * xi, df = we, Zi = _e;
function Qi(e, t, r, n, a) {
  t.transportStatus === 0 && t.queuedPayloads.size() === 0 && t.bandwidthMonitor.canHandle(e) ? ts(e, t, r, {
    onSuccess: function() {
      return rs(0, t, r, n, a);
    },
    onFailure: function() {
      t.queuedPayloads.enqueue(e), es(t, r, n, a);
    }
  }) : t.queuedPayloads.enqueue(e);
}
function es(e, t, r, n) {
  e.transportStatus === 2 && pe(function() {
    var a = e.queuedPayloads.first();
    ts(a, e, t, {
      onSuccess: function() {
        e.queuedPayloads.dequeue(), e.currentBackoffTime = Zi, rs(1, e, t, r, n);
      },
      onFailure: function() {
        e.currentBackoffTime = Math.min(df, e.currentBackoffTime * 2), es(e, t, r, n);
      }
    });
  }, e.currentBackoffTime);
}
function ts(e, t, r, n) {
  var a = n.onSuccess, o = n.onFailure;
  t.bandwidthMonitor.add(e), r(e, function(i) {
    t.bandwidthMonitor.remove(e), ff(i) ? (t.transportStatus = t.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, e.retry = {
      count: e.retry ? e.retry.count + 1 : 1,
      lastFailureStatus: i.status
    }, o()) : (t.transportStatus = 0, a());
  });
}
function rs(e, t, r, n, a) {
  e === 0 && t.queuedPayloads.isFull() && !t.queueFullReported && (a({
    message: "Reached max ".concat(n, " events size queued for upload: ").concat(Ji / xi, "MiB"),
    source: Jt.AGENT,
    startClocks: Re()
  }), t.queueFullReported = !0);
  var o = t.queuedPayloads;
  for (t.queuedPayloads = ns(); o.size() > 0; )
    Qi(o.dequeue(), t, r, n, a);
}
function ff(e) {
  return e.type !== "opaque" && (e.status === 0 && !navigator.onLine || e.status === 408 || e.status === 429 || sf(e.status));
}
function pf() {
  return {
    transportStatus: 0,
    currentBackoffTime: Zi,
    bandwidthMonitor: vf(),
    queuedPayloads: ns(),
    queueFullReported: !1
  };
}
function ns() {
  var e = [];
  return {
    bytesCount: 0,
    enqueue: function(t) {
      this.isFull() || (e.push(t), this.bytesCount += t.bytesCount);
    },
    first: function() {
      return e[0];
    },
    dequeue: function() {
      var t = e.shift();
      return t && (this.bytesCount -= t.bytesCount), t;
    },
    size: function() {
      return e.length;
    },
    isFull: function() {
      return this.bytesCount >= Ji;
    }
  };
}
function vf() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function(e) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + e.bytesCount <= uf && this.ongoingRequestCount < lf;
    },
    add: function(e) {
      this.ongoingRequestCount += 1, this.ongoingByteCount += e.bytesCount;
    },
    remove: function(e) {
      this.ongoingRequestCount -= 1, this.ongoingByteCount -= e.bytesCount;
    }
  };
}
function as(e, t, r, n) {
  var a = pf(), o = function(i, s) {
    return gf(e, t, r, i, s);
  };
  return {
    send: function(i) {
      Qi(i, a, o, t.endpointType, n);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function(i) {
      mf(e, t, r, i);
    }
  };
}
function mf(e, t, r, n) {
  var a = !!navigator.sendBeacon && n.bytesCount < r;
  if (a)
    try {
      var o = t.build("beacon", n), i = navigator.sendBeacon(o, n.data);
      if (i)
        return;
    } catch (c) {
      hf(c);
    }
  var s = t.build("xhr", n);
  Jn(e, s, n.data);
}
var So = !1;
function hf(e) {
  So || (So = !0, zr(e));
}
function gf(e, t, r, n, a) {
  var o = _f() && n.bytesCount < r;
  if (o) {
    var i = t.build("fetch", n);
    fetch(i, { method: "POST", body: n.data, keepalive: !0, mode: "cors" }).then(D(function(c) {
      return a == null ? void 0 : a({ status: c.status, type: c.type });
    }), D(function() {
      var c = t.build("xhr", n);
      Jn(e, c, n.data, a);
    }));
  } else {
    var s = t.build("xhr", n);
    Jn(e, s, n.data, a);
  }
}
function _f() {
  try {
    return window.Request && "keepalive" in new Request("http://a");
  } catch {
    return !1;
  }
}
function Jn(e, t, r, n) {
  var a = new XMLHttpRequest();
  a.open("POST", t, !0), oe(e, a, "loadend", function() {
    n == null || n({ status: a.status });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: !0
  }), a.send(r);
}
function Ta() {
  var e = yf();
  if (e)
    return {
      getAllowedWebViewHosts: function() {
        return JSON.parse(e.getAllowedWebViewHosts());
      },
      send: function(t, r) {
        e.send(JSON.stringify({ eventType: t, event: r }));
      }
    };
}
function $t(e) {
  var t;
  e === void 0 && (e = (t = pt().location) === null || t === void 0 ? void 0 : t.hostname);
  var r = Ta();
  return !!r && r.getAllowedWebViewHosts().some(function(n) {
    return e === n || pl(e, ".".concat(n));
  });
}
function yf() {
  return pt().DatadogEventBridge;
}
var _t = {
  HIDDEN: "visibility_hidden",
  UNLOADING: "before_unload",
  PAGEHIDE: "page_hide",
  FROZEN: "page_frozen"
};
function Sf(e) {
  var t = new te(function() {
    var r = Ie(ve.PAGEHIDE), n = Se(e, window, [
      "visibilitychange",
      "freeze",
      "pagehide"
      /* DOM_EVENT.PAGE_HIDE */
    ], function(o) {
      o.type === "pagehide" && r ? t.notify({ reason: _t.PAGEHIDE }) : o.type === "visibilitychange" && document.visibilityState === "hidden" ? t.notify({ reason: _t.HIDDEN }) : o.type === "freeze" && t.notify({ reason: _t.FROZEN });
    }, { capture: !0 }).stop, a = Q;
    return r || (a = oe(e, window, "beforeunload", function() {
      t.notify({ reason: _t.UNLOADING });
    }).stop), function() {
      n(), a();
    };
  });
  return t;
}
function os(e) {
  return Qe(Xr(_t), e);
}
var bf = (
  /** @class */
  function() {
    function e(t, r, n) {
      var a = this;
      this.request = t, this.flushController = r, this.messageBytesLimit = n, this.pushOnlyBuffer = [], this.upsertBuffer = {}, this.flushSubscription = this.flushController.flushObservable.subscribe(function(o) {
        return a.flush(o);
      });
    }
    return e.prototype.add = function(t) {
      this.addOrUpdate(t);
    }, e.prototype.upsert = function(t, r) {
      this.addOrUpdate(t, r);
    }, e.prototype.stop = function() {
      this.flushSubscription.unsubscribe();
    }, e.prototype.flush = function(t) {
      var r = this.pushOnlyBuffer.concat(Xr(this.upsertBuffer));
      this.pushOnlyBuffer = [], this.upsertBuffer = {};
      var n = { data: r.join(`
`), bytesCount: t.bytesCount, flushReason: t.reason };
      os(t.reason) ? this.request.sendOnExit(n) : this.request.send(n);
    }, e.prototype.addOrUpdate = function(t, r) {
      var n = this.process(t), a = n.processedMessage, o = n.messageBytesCount;
      if (o >= this.messageBytesLimit) {
        H.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
        return;
      }
      this.hasMessageFor(r) && this.remove(r), this.push(a, o, r);
    }, e.prototype.process = function(t) {
      var r = Et(t), n = pr(r);
      return { processedMessage: r, messageBytesCount: n };
    }, e.prototype.push = function(t, r, n) {
      var a = this.flushController.messagesCount > 0 ? 1 : 0;
      this.flushController.notifyBeforeAddMessage(r + a), n !== void 0 ? this.upsertBuffer[n] = t : this.pushOnlyBuffer.push(t), this.flushController.notifyAfterAddMessage();
    }, e.prototype.remove = function(t) {
      var r = this.upsertBuffer[t];
      delete this.upsertBuffer[t];
      var n = pr(r), a = this.flushController.messagesCount > 1 ? 1 : 0;
      this.flushController.notifyAfterRemoveMessage(n + a);
    }, e.prototype.hasMessageFor = function(t) {
      return t !== void 0 && this.upsertBuffer[t] !== void 0;
    }, e;
  }()
);
function wf(e) {
  var t = e.messagesLimit, r = e.bytesLimit, n = e.durationLimit, a = e.pageExitObservable, o = e.sessionExpireObservable, i = a.subscribe(function(S) {
    return f(S.reason);
  }), s = o.subscribe(function() {
    return f("session_expire");
  }), c = new te(function() {
    return function() {
      i.unsubscribe(), s.unsubscribe();
    };
  }), u = 0, l = 0;
  function f(S) {
    if (l !== 0) {
      var x = l, P = u;
      l = 0, u = 0, g(), c.notify({
        reason: S,
        messagesCount: x,
        bytesCount: P
      });
    }
  }
  var p;
  function m() {
    p === void 0 && (p = pe(function() {
      f("duration_limit");
    }, n));
  }
  function g() {
    je(p), p = void 0;
  }
  return {
    flushObservable: c,
    get messagesCount() {
      return l;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     */
    notifyBeforeAddMessage: function(S) {
      u + S >= r && f("bytes_limit"), l += 1, u += S, m();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     */
    notifyAfterAddMessage: function() {
      l >= t ? f("messages_limit") : u >= r && f("bytes_limit");
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     */
    notifyAfterRemoveMessage: function(S) {
      u -= S, l -= 1, l === 0 && g();
    }
  };
}
function Af(e, t, r, n, a, o) {
  var i = c(e, t.endpoint), s = r && c(e, r.endpoint);
  function c(u, l) {
    return new bf(as(u, l, u.batchBytesLimit, n), wf({
      messagesLimit: u.batchMessagesLimit,
      bytesLimit: u.batchBytesLimit,
      durationLimit: u.flushTimeout,
      pageExitObservable: a,
      sessionExpireObservable: o
    }), u.messageBytesLimit);
  }
  return {
    flushObservable: i.flushController.flushObservable,
    add: function(u, l) {
      l === void 0 && (l = !0), i.add(u), s && l && s.add(r.transformMessage ? r.transformMessage(u) : u);
    },
    upsert: function(u, l) {
      i.upsert(u, l), s && s.upsert(r.transformMessage ? r.transformMessage(u) : u, l);
    },
    stop: function() {
      i.stop(), s == null || s.stop();
    }
  };
}
var Ef = (
  /** @class */
  function() {
    function e() {
      this.callbacks = {};
    }
    return e.prototype.notify = function(t, r) {
      var n = this.callbacks[t];
      n && n.forEach(function(a) {
        return a(r);
      });
    }, e.prototype.subscribe = function(t, r) {
      var n = this;
      return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(r), {
        unsubscribe: function() {
          n.callbacks[t] = n.callbacks[t].filter(function(a) {
            return r !== a;
          });
        }
      };
    }, e;
  }()
);
function bo(e, t, r) {
  var n = 0, a = !1;
  return {
    isLimitReached: function() {
      if (n === 0 && pe(function() {
        n = 0;
      }, we), n += 1, n <= t || a)
        return a = !1, !1;
      if (n === t + 1) {
        a = !0;
        try {
          r({
            message: "Reached max number of ".concat(e, "s by minute: ").concat(t),
            source: Jt.AGENT,
            startClocks: Re()
          });
        } finally {
          a = !1;
        }
      }
      return !0;
    }
  };
}
function Ra(e, t, r) {
  if (document.readyState === t || document.readyState === "complete")
    r();
  else {
    var n = t === "complete" ? "load" : "DOMContentLoaded";
    oe(e, window, n, r, { once: !0 });
  }
}
var Cn, Ca = /* @__PURE__ */ new WeakMap();
function Tf(e) {
  return Cn || (Cn = Rf(e)), Cn;
}
function Rf(e) {
  var t = new te(function() {
    var r = Te(XMLHttpRequest.prototype, "open", {
      before: Cf
    }).stop, n = Te(XMLHttpRequest.prototype, "send", {
      before: function() {
        If.call(this, e, t);
      }
    }).stop, a = Te(XMLHttpRequest.prototype, "abort", {
      before: Of
    }).stop;
    return function() {
      r(), n(), a();
    };
  });
  return t;
}
function Cf(e, t) {
  Ca.set(this, {
    state: "open",
    method: e,
    url: Br(String(t))
  });
}
function If(e, t) {
  var r = this, n = Ca.get(this);
  if (n) {
    var a = n;
    a.state = "start", a.startTime = Oe(), a.startClocks = Re(), a.isAborted = !1, a.xhr = this;
    var o = !1, i = Te(this, "onreadystatechange", {
      before: function() {
        this.readyState === XMLHttpRequest.DONE && s();
      }
    }).stop, s = function() {
      if (c(), i(), !o) {
        o = !0;
        var u = n;
        u.state = "complete", u.duration = ye(a.startClocks.timeStamp, ue()), u.status = r.status, t.notify(vr(u));
      }
    }, c = oe(e, this, "loadend", s).stop;
    t.notify(a);
  }
}
function Of() {
  var e = Ca.get(this);
  e && (e.isAborted = !0);
}
var In;
function xf() {
  return In || (In = kf()), In;
}
function kf() {
  var e = new te(function() {
    if (window.fetch) {
      var t = Gi(window, "fetch", function(r) {
        return function(n, a) {
          var o, i = ft(Pf, null, [e, n, a]);
          return i ? (o = r.call(this, i.input, i.init), ft(Nf, null, [e, o, i])) : o = r.call(this, n, a), o;
        };
      }).stop;
      return t;
    }
  });
  return e;
}
function Pf(e, t, r) {
  var n = r && r.method || t instanceof Request && t.method || "GET", a = t instanceof Request ? t.url : Br(String(t)), o = Re(), i = {
    state: "start",
    init: r,
    input: t,
    method: n,
    startClocks: o,
    url: a
  };
  return e.notify(i), i;
}
function Nf(e, t, r) {
  var n = function(a) {
    var o = r;
    o.state = "resolve", "stack" in a || a instanceof Error ? (o.status = 0, o.isAborted = a instanceof DOMException && a.code === DOMException.ABORT_ERR, o.error = a) : "status" in a && (o.response = a, o.responseType = a.type, o.status = a.status, o.isAborted = !1), e.notify(o);
  };
  t.then(D(n), D(n));
}
var On = {};
function Lf(e) {
  var t = e.map(function(r) {
    return On[r] || (On[r] = Df(r)), On[r];
  });
  return Ni.apply(void 0, t);
}
function Df(e) {
  var t = new te(function() {
    var r = Xe[e];
    return Xe[e] = function() {
      for (var n = [], a = 0; a < arguments.length; a++)
        n[a] = arguments[a];
      r.apply(console, n);
      var o = Yi();
      ft(function() {
        t.notify(Mf(n, e, o));
      });
    }, function() {
      Xe[e] = r;
    };
  });
  return t;
}
function Mf(e, t, r) {
  var n = e.map(function(s) {
    return Uf(s);
  }).join(" "), a, o;
  if (t === Yr.error) {
    var i = Wt(e, function(s) {
      return s instanceof Error;
    });
    a = i ? Xt(vt(i)) : void 0, o = Ki(i), n = "console error: ".concat(n);
  }
  return {
    api: t,
    message: n,
    stack: a,
    handlingStack: r,
    fingerprint: o
  };
}
function Uf(e) {
  return typeof e == "string" ? Ce(e) : e instanceof Error ? Wi(vt(e)) : Et(Ce(e), void 0, 2);
}
var Ff = 500, wo = (
  /** @class */
  function() {
    function e() {
      this.buffer = [];
    }
    return e.prototype.add = function(t) {
      var r = this.buffer.push(t);
      r > Ff && this.buffer.splice(0, 1);
    }, e.prototype.drain = function() {
      this.buffer.forEach(function(t) {
        return t();
      }), this.buffer.length = 0;
    }, e;
  }()
), Pt, Ao = 3 * bt, jf = (Pt = {}, Pt[
  0
  /* CustomerDataType.FeatureFlag */
] = "feature flag evaluation", Pt[
  1
  /* CustomerDataType.User */
] = "user", Pt[
  2
  /* CustomerDataType.GlobalContext */
] = "global context", Pt[
  3
  /* CustomerDataType.LoggerContext */
] = "logger context", Pt);
function is(e, t) {
  return e > Ao ? (H.warn("The ".concat(jf[t], " data exceeds the recommended ").concat(Ao / bt, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-3kib-warning")), !0) : !1;
}
var Bf = 200;
function Zn(e, t) {
  t === void 0 && (t = pr);
  var r = {}, n, a = !1, o = new te(), i = tt(function(c) {
    n = t(Et(c)), a || (a = is(n, e));
  }, Bf).throttled, s = {
    getBytesCount: function() {
      return n;
    },
    /** @deprecated use getContext instead */
    get: function() {
      return r;
    },
    /** @deprecated use setContextProperty instead */
    add: function(c, u) {
      r[c] = u, i(r), o.notify();
    },
    /** @deprecated renamed to removeContextProperty */
    remove: function(c) {
      delete r[c], i(r), o.notify();
    },
    /** @deprecated use setContext instead */
    set: function(c) {
      r = c, i(r), o.notify();
    },
    getContext: function() {
      return wa(r);
    },
    setContext: function(c) {
      mt(c) === "object" ? (r = Ce(c), i(r)) : s.clearContext(), o.notify();
    },
    setContextProperty: function(c, u) {
      r[c] = Ce(u), i(r), o.notify();
    },
    removeContextProperty: function(c) {
      delete r[c], i(r), o.notify();
    },
    clearContext: function() {
      r = {}, n = 0, o.notify();
    },
    changeObservable: o
  };
  return s;
}
var Vf = "_dd_c", zf = [];
function Eo(e, t, r, n) {
  n === void 0 && (n = pr);
  var a = Hf(t, r), o = Zn(r, n);
  return i(), zf.push(oe(e, window, "storage", function(c) {
    var u = c.key;
    a === u && i();
  })), o.changeObservable.subscribe(s), o;
  function i() {
    var c = localStorage.getItem(a), u = c !== null ? JSON.parse(c) : {};
    o.setContext(u);
  }
  function s() {
    localStorage.setItem(a, JSON.stringify(o.getContext()));
  }
}
function Hf(e, t) {
  return "".concat(Vf, "_").concat(e, "_").concat(t);
}
function Gf(e, t, r) {
  var n = e.getReader(), a = 0;
  o();
  function o() {
    n.read().then(D(function(s) {
      if (s.done) {
        i();
        return;
      }
      a += s.value.length, a > r.bytesLimit ? i() : o();
    }), D(function(s) {
      return t(s);
    }));
  }
  function i() {
    n.cancel().catch(
      // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
      // as an unhandled rejection
      Q
    );
    var s, c;
    t(void 0, s, c);
  }
}
var $f = "datadog-synthetics-public-id", qf = "datadog-synthetics-result-id", Kf = "datadog-synthetics-injects-rum";
function ss() {
  return !!(window._DATADOG_SYNTHETICS_INJECTS_RUM || Be(Kf));
}
function Wf() {
  var e = window._DATADOG_SYNTHETICS_PUBLIC_ID || Be($f);
  return typeof e == "string" ? e : void 0;
}
function Yf() {
  var e = window._DATADOG_SYNTHETICS_RESULT_ID || Be(qf);
  return typeof e == "string" ? e : void 0;
}
function To(e) {
  var t = B({}, e), r = ["id", "name", "email"];
  return r.forEach(function(n) {
    n in t && (t[n] = String(t[n]));
  }), t;
}
function Xf(e) {
  var t = mt(e) === "object";
  return t || H.error("Unsupported user:", e), t;
}
function Ia(e) {
  var t = mt(e);
  return t === "string" || t === "function" || e instanceof RegExp;
}
function cs(e, t, r) {
  return r === void 0 && (r = !1), e.some(function(n) {
    try {
      if (typeof n == "function")
        return n(t);
      if (n instanceof RegExp)
        return n.test(t);
      if (typeof n == "string")
        return r ? Jr(t, n) : n === t;
    } catch (a) {
      H.error(a);
    }
    return !1;
  });
}
function Jf(e) {
  var t = e;
  return mt(t) === "object" && Ia(t.match) && Array.isArray(t.propagatorTypes);
}
function Zf(e) {
  e.status === 0 && !e.isAborted && (e.traceId = void 0, e.spanId = void 0, e.traceSampled = void 0);
}
function Qf(e, t) {
  return {
    clearTracingIfNeeded: Zf,
    traceFetch: function(r) {
      return Ro(e, r, t, function(n) {
        var a;
        if (r.input instanceof Request && !(!((a = r.init) === null || a === void 0) && a.headers))
          r.input = new Request(r.input), Object.keys(n).forEach(function(i) {
            r.input.headers.append(i, n[i]);
          });
        else {
          r.init = vr(r.init);
          var o = [];
          r.init.headers instanceof Headers ? r.init.headers.forEach(function(i, s) {
            o.push([s, i]);
          }) : Array.isArray(r.init.headers) ? r.init.headers.forEach(function(i) {
            o.push(i);
          }) : r.init.headers && Object.keys(r.init.headers).forEach(function(i) {
            o.push([i, r.init.headers[i]]);
          }), r.init.headers = o.concat(ha(n));
        }
      });
    },
    traceXhr: function(r, n) {
      return Ro(e, r, t, function(a) {
        Object.keys(a).forEach(function(o) {
          n.setRequestHeader(o, a[o]);
        });
      });
    }
  };
}
function Ro(e, t, r, n) {
  if (!(!ep() || !r.findTrackedSession())) {
    var a = Wt(e.allowedTracingUrls, function(o) {
      return cs([o.match], t.url, !0);
    });
    a && (t.traceId = new Co(), t.spanId = new Co(), t.traceSampled = !qt(e.traceSampleRate) || zt(e.traceSampleRate), n(tp(t.traceId, t.spanId, t.traceSampled, a.propagatorTypes)));
  }
}
function ep() {
  return us() !== void 0;
}
function us() {
  return window.crypto || window.msCrypto;
}
function tp(e, t, r, n) {
  var a = {};
  return n.forEach(function(o) {
    switch (o) {
      case "datadog": {
        B(a, {
          "x-datadog-origin": "rum",
          "x-datadog-parent-id": t.toDecimalString(),
          "x-datadog-sampling-priority": r ? "1" : "0",
          "x-datadog-trace-id": e.toDecimalString()
        });
        break;
      }
      case "tracecontext": {
        B(a, {
          traceparent: "00-0000000000000000".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-0").concat(r ? "1" : "0")
        });
        break;
      }
      case "b3": {
        B(a, {
          b3: "".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-").concat(r ? "1" : "0")
        });
        break;
      }
      case "b3multi": {
        B(a, {
          "X-B3-TraceId": e.toPaddedHexadecimalString(),
          "X-B3-SpanId": t.toPaddedHexadecimalString(),
          "X-B3-Sampled": r ? "1" : "0"
        });
        break;
      }
    }
  }), a;
}
var Co = (
  /** @class */
  function() {
    function e() {
      this.buffer = new Uint8Array(8), us().getRandomValues(this.buffer), this.buffer[0] = this.buffer[0] & 127;
    }
    return e.prototype.toString = function(t) {
      var r = this.readInt32(0), n = this.readInt32(4), a = "";
      do {
        var o = r % t * 4294967296 + n;
        r = Math.floor(r / t), n = Math.floor(o / t), a = (o % t).toString(t) + a;
      } while (r || n);
      return a;
    }, e.prototype.toDecimalString = function() {
      return this.toString(10);
    }, e.prototype.toPaddedHexadecimalString = function() {
      var t = this.toString(16);
      return Array(17 - t.length).join("0") + t;
    }, e.prototype.readInt32 = function(t) {
      return this.buffer[t] * 16777216 + (this.buffer[t + 1] << 16) + (this.buffer[t + 2] << 8) + this.buffer[t + 3];
    }, e;
  }()
);
function rp(e) {
  var t, r, n, a, o, i;
  if (!e.applicationId) {
    H.error("Application ID is not configured, no RUM data will be collected.");
    return;
  }
  if (e.sessionReplaySampleRate !== void 0 && !Bt(e.sessionReplaySampleRate)) {
    H.error("Session Replay Sample Rate should be a number between 0 and 100");
    return;
  }
  var s = (t = e.premiumSampleRate) !== null && t !== void 0 ? t : e.replaySampleRate;
  if (s !== void 0 && e.sessionReplaySampleRate !== void 0 && (H.warn("Ignoring Premium Sample Rate because Session Replay Sample Rate is set"), s = void 0), s !== void 0 && !Bt(s)) {
    H.error("Premium Sample Rate should be a number between 0 and 100");
    return;
  }
  var c = (r = e.traceSampleRate) !== null && r !== void 0 ? r : e.tracingSampleRate;
  if (c !== void 0 && !Bt(c)) {
    H.error("Trace Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.excludedActivityUrls !== void 0 && !Array.isArray(e.excludedActivityUrls)) {
    H.error("Excluded Activity Urls should be an array");
    return;
  }
  var u = np(e);
  if (u) {
    var l = dd(e);
    if (l) {
      var f = !!((n = e.trackUserInteractions) !== null && n !== void 0 ? n : e.trackInteractions), p = !!e.trackFrustrations;
      return B({
        applicationId: e.applicationId,
        version: e.version,
        actionNameAttribute: e.actionNameAttribute,
        sessionReplaySampleRate: (o = (a = e.sessionReplaySampleRate) !== null && a !== void 0 ? a : s) !== null && o !== void 0 ? o : 100,
        oldPlansBehavior: e.sessionReplaySampleRate === void 0,
        traceSampleRate: c,
        allowedTracingUrls: u,
        excludedActivityUrls: (i = e.excludedActivityUrls) !== null && i !== void 0 ? i : [],
        workerUrl: e.workerUrl,
        trackUserInteractions: f || p,
        trackFrustrations: p,
        trackViewsManually: !!e.trackViewsManually,
        trackResources: e.trackResources,
        trackLongTasks: e.trackLongTasks,
        subdomain: e.subdomain,
        defaultPrivacyLevel: ga(lr, e.defaultPrivacyLevel) ? e.defaultPrivacyLevel : lr.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1
      }, l);
    }
  }
}
function np(e) {
  if (e.allowedTracingUrls !== void 0 && e.allowedTracingOrigins !== void 0 && H.warn("Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins."), e.allowedTracingUrls !== void 0) {
    if (!Array.isArray(e.allowedTracingUrls)) {
      H.error("Allowed Tracing URLs should be an array");
      return;
    }
    if (e.allowedTracingUrls.length !== 0 && e.service === void 0) {
      H.error("Service needs to be configured when tracing is enabled");
      return;
    }
    var t = [];
    return e.allowedTracingUrls.forEach(function(n) {
      Ia(n) ? t.push({ match: n, propagatorTypes: ["datadog"] }) : Jf(n) ? t.push(n) : H.warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", n);
    }), t;
  }
  if (e.allowedTracingOrigins !== void 0) {
    if (!Array.isArray(e.allowedTracingOrigins)) {
      H.error("Allowed Tracing Origins should be an array");
      return;
    }
    if (e.allowedTracingOrigins.length !== 0 && e.service === void 0) {
      H.error("Service needs to be configured when tracing is enabled");
      return;
    }
    var r = [];
    return e.allowedTracingOrigins.forEach(function(n) {
      var a = ap(n);
      a && r.push(a);
    }), r;
  }
  return [];
}
function ap(e) {
  var t;
  if (typeof e == "string" ? t = e : e instanceof RegExp ? t = function(r) {
    return e.test(_o(r));
  } : typeof e == "function" && (t = function(r) {
    return e(_o(r));
  }), t === void 0) {
    H.warn("Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter", e);
    return;
  }
  return { match: t, propagatorTypes: ["datadog"] };
}
function op(e) {
  var t = /* @__PURE__ */ new Set();
  return Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0 && e.allowedTracingUrls.forEach(function(r) {
    Ia(r) ? t.add("datadog") : mt(r) === "object" && Array.isArray(r.propagatorTypes) && r.propagatorTypes.forEach(function(n) {
      return t.add(n);
    });
  }), Array.isArray(e.allowedTracingOrigins) && e.allowedTracingOrigins.length > 0 && t.add("datadog"), ki(t);
}
function ip(e) {
  var t, r, n = fd(e);
  return B({
    premium_sample_rate: e.premiumSampleRate,
    replay_sample_rate: e.replaySampleRate,
    session_replay_sample_rate: e.sessionReplaySampleRate,
    trace_sample_rate: (t = e.traceSampleRate) !== null && t !== void 0 ? t : e.tracingSampleRate,
    action_name_attribute: e.actionNameAttribute,
    use_allowed_tracing_origins: Array.isArray(e.allowedTracingOrigins) && e.allowedTracingOrigins.length > 0,
    use_allowed_tracing_urls: Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0,
    selected_tracing_propagators: op(e),
    default_privacy_level: e.defaultPrivacyLevel,
    use_excluded_activity_urls: Array.isArray(e.excludedActivityUrls) && e.excludedActivityUrls.length > 0,
    use_worker_url: !!e.workerUrl,
    track_frustrations: e.trackFrustrations,
    track_views_manually: e.trackViewsManually,
    track_user_interactions: (r = e.trackUserInteractions) !== null && r !== void 0 ? r : e.trackInteractions
  }, n);
}
function Qn(e, t, r) {
  return {
    context: e.getContext(),
    user: t.getContext(),
    hasReplay: r.isRecording() ? !0 : void 0
  };
}
var Io = "rum";
function sp(e, t, r) {
  var n = {}, a = n.ignoreInitIfSyntheticsWillInjectRum, o = a === void 0 ? !0 : a, i = !1, s = Zn(
    2
    /* CustomerDataType.GlobalContext */
  ), c = Zn(
    1
    /* CustomerDataType.User */
  ), u = function() {
  }, l = function() {
  }, f = Q, p = function() {
  }, m = new wo(), g = function(w, I) {
    I === void 0 && (I = ue()), m.add(function() {
      return g(w, I);
    });
  }, S = function(w, I) {
    I === void 0 && (I = Re()), m.add(function() {
      return S(w, I);
    });
  }, x = function(w, I) {
    I === void 0 && (I = Qn(s, c, t)), m.add(function() {
      return x(w, I);
    });
  }, P = function(w, I) {
    I === void 0 && (I = Qn(s, c, t)), m.add(function() {
      return P(w, I);
    });
  }, T = function(w, I) {
    m.add(function() {
      return T(w, I);
    });
  };
  function F(w) {
    if (!w) {
      H.error("Missing configuration");
      return;
    }
    if (l = function() {
      return wa(w);
    }, !(o && ss())) {
      var I = $t();
      if (I && (w = ne(w)), !!j(w)) {
        var W = rp(w);
        if (W) {
          if (!I && !W.sessionStoreStrategyType) {
            H.warn("No storage available for session. We will not send any data.");
            return;
          }
          if (!W.trackViewsManually)
            M(w, W);
          else {
            var me = m;
            m = new wo(), S = function(ke) {
              M(w, W, ke);
            }, me.drain();
          }
          i = !0;
        }
      }
    }
  }
  function M(w, I, W) {
    if (w.storeContextsAcrossPages) {
      var me = s.getContext();
      s = Eo(
        I,
        Io,
        2
        /* CustomerDataType.GlobalContext */
      ), s.setContext(Ge(s.getContext(), me));
      var ke = c.getContext();
      c = Eo(
        I,
        Io,
        1
        /* CustomerDataType.User */
      ), c.setContext(Ge(c.getContext(), ke));
    }
    var y = e(w, I, t, s, c, W);
    p = function() {
      return t.getSessionReplayLink(I, y.session, y.viewContexts);
    }, S = y.startView, x = y.addAction, P = y.addError, g = y.addTiming, T = y.addFeatureFlagEvaluation, u = y.getInternalContext, f = y.stopSession, m.drain(), t.onRumStart(y.lifeCycle, I, y.session, y.viewContexts);
  }
  var R = D(function(w) {
    var I = typeof w == "object" ? w : { name: w };
    S(I);
  }), L = Fd({
    init: D(F),
    /** @deprecated: use setGlobalContextProperty instead */
    addRumGlobalContext: D(function(w, I) {
      return s.add(w, I);
    }),
    setGlobalContextProperty: D(function(w, I) {
      return s.setContextProperty(w, I);
    }),
    /** @deprecated: use removeGlobalContextProperty instead */
    removeRumGlobalContext: D(function(w) {
      return s.remove(w);
    }),
    removeGlobalContextProperty: D(function(w) {
      return s.removeContextProperty(w);
    }),
    /** @deprecated: use getGlobalContext instead */
    getRumGlobalContext: D(function() {
      return s.get();
    }),
    getGlobalContext: D(function() {
      return s.getContext();
    }),
    /** @deprecated: use setGlobalContext instead */
    setRumGlobalContext: D(function(w) {
      return s.set(w);
    }),
    setGlobalContext: D(function(w) {
      return s.setContext(w);
    }),
    clearGlobalContext: D(function() {
      return s.clearContext();
    }),
    getInternalContext: D(function(w) {
      return u(w);
    }),
    getInitConfiguration: D(function() {
      return l();
    }),
    addAction: D(function(w, I) {
      x({
        name: Ce(w),
        context: Ce(I),
        startClocks: Re(),
        type: "custom"
      });
    }),
    addError: function(w, I) {
      var W = Yi();
      ft(function() {
        P({
          error: w,
          handlingStack: W,
          context: Ce(I),
          startClocks: Re()
        });
      });
    },
    addTiming: D(function(w, I) {
      g(Ce(w), I);
    }),
    setUser: D(function(w) {
      Xf(w) && c.setContext(To(w));
    }),
    getUser: D(function() {
      return c.getContext();
    }),
    setUserProperty: D(function(w, I) {
      var W, me = To((W = {}, W[w] = I, W))[w];
      c.setContextProperty(w, me);
    }),
    removeUserProperty: D(function(w) {
      return c.removeContextProperty(w);
    }),
    /** @deprecated: renamed to clearUser */
    removeUser: D(function() {
      return c.clearContext();
    }),
    clearUser: D(function() {
      return c.clearContext();
    }),
    startView: R,
    stopSession: D(function() {
      f();
    }),
    startSessionReplayRecording: D(t.start),
    stopSessionReplayRecording: D(t.stop),
    /**
     * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
     */
    addFeatureFlagEvaluation: D(function(w, I) {
      T(Ce(w), Ce(I));
    }),
    getSessionReplayLink: D(function() {
      return p();
    })
  });
  return L;
  function j(w) {
    return i ? (w.silentMultipleInit || H.error("DD_RUM is already initialized."), !1) : !0;
  }
  function ne(w) {
    return B({}, w, {
      applicationId: "00000000-aaaa-0000-aaaa-000000000000",
      clientToken: "empty",
      sessionSampleRate: 100
    });
  }
}
function cp() {
  var e = ls(), t = new te(function() {
    if (e) {
      var r = new e(D(function() {
        return t.notify();
      }));
      return r.observe(document, {
        attributes: !0,
        characterData: !0,
        childList: !0,
        subtree: !0
      }), function() {
        return r.disconnect();
      };
    }
  });
  return t;
}
function ls() {
  var e, t = window;
  if (t.Zone && (e = dt(t, "MutationObserver"), t.MutationObserver && e === t.MutationObserver)) {
    var r = new t.MutationObserver(Q), n = dt(r, "originalInstance");
    e = n && n.constructor;
  }
  return e || (e = t.MutationObserver), e;
}
var ds = "initial_document", up = [
  ["document", function(e) {
    return ds === e;
  }],
  ["xhr", function(e) {
    return e === "xmlhttprequest";
  }],
  ["fetch", function(e) {
    return e === "fetch";
  }],
  ["beacon", function(e) {
    return e === "beacon";
  }],
  ["css", function(e, t) {
    return /\.css$/i.test(t);
  }],
  ["js", function(e, t) {
    return /\.js$/i.test(t);
  }],
  [
    "image",
    function(e, t) {
      return Qe(["image", "img", "icon"], e) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(t) !== null;
    }
  ],
  ["font", function(e, t) {
    return /\.(woff|eot|woff2|ttf)$/i.exec(t) !== null;
  }],
  [
    "media",
    function(e, t) {
      return Qe(["audio", "video"], e) || /\.(mp3|mp4)$/i.exec(t) !== null;
    }
  ]
];
function lp(e) {
  var t = e.name;
  if (!Kl(t))
    return Tt('Failed to construct URL for "'.concat(e.name, '"')), "other";
  for (var r = Wl(t), n = 0, a = up; n < a.length; n++) {
    var o = a[n], i = o[0], s = o[1];
    if (s(e.initiatorType, r))
      return i;
  }
  return "other";
}
function ea() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = 1; r < e.length; r += 1)
    if (e[r - 1] > e[r])
      return !1;
  return !0;
}
function dp(e) {
  return e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch";
}
function fp(e) {
  var t = e.duration, r = e.startTime, n = e.responseEnd;
  return t === 0 && r < n ? X(ye(r, n)) : X(t);
}
function pp(e) {
  var t = fs(e);
  if (t) {
    var r = t.startTime, n = t.fetchStart, a = t.redirectStart, o = t.redirectEnd, i = t.domainLookupStart, s = t.domainLookupEnd, c = t.connectStart, u = t.secureConnectionStart, l = t.connectEnd, f = t.requestStart, p = t.responseStart, m = t.responseEnd, g = {
      download: Nt(r, p, m),
      first_byte: Nt(r, f, p)
    };
    return l !== n && (g.connect = Nt(r, c, l), ea(c, u, l) && (g.ssl = Nt(r, u, l))), s !== n && (g.dns = Nt(r, i, s)), ps(e) && (g.redirect = Nt(r, a, o)), g;
  }
}
function fs(e) {
  if (ea(e.startTime, e.fetchStart, e.domainLookupStart, e.domainLookupEnd, e.connectStart, e.connectEnd, e.requestStart, e.responseStart, e.responseEnd)) {
    if (!ps(e))
      return e;
    var t = e.redirectStart, r = e.redirectEnd;
    if (t < e.startTime && (t = e.startTime), r < e.startTime && (r = e.fetchStart), !!ea(e.startTime, t, r, e.fetchStart))
      return B({}, e, {
        redirectEnd: r,
        redirectStart: t
      });
  }
}
function ps(e) {
  return e.fetchStart !== e.startTime;
}
function Nt(e, t, r) {
  return {
    duration: X(ye(t, r)),
    start: X(ye(e, t))
  };
}
function vp(e) {
  if (e.startTime < e.responseStart)
    return e.decodedBodySize;
}
function Oa(e, t) {
  return t && !e.isIntakeUrl(t);
}
function vs(e) {
  return e.nodeType === Node.TEXT_NODE;
}
function mp(e) {
  return e.nodeType === Node.COMMENT_NODE;
}
function Qt(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function Qr(e) {
  return Qt(e) && !!e.shadowRoot;
}
function xa(e) {
  var t = e;
  return !!t.host && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && Qt(t.host);
}
function hp(e) {
  return e.childNodes.length > 0 || Qr(e);
}
function ms(e, t) {
  e.childNodes.forEach(t), Qr(e) && t(e.shadowRoot);
}
function en(e) {
  return xa(e) ? e.host : e.parentNode;
}
var gp = 2 * we;
function _p(e) {
  var t = yp(e) || Sp(e);
  if (!(!t || t.traceTime <= Ve() - gp))
    return t.traceId;
}
function yp(e) {
  var t = e.querySelector("meta[name=dd-trace-id]"), r = e.querySelector("meta[name=dd-trace-time]");
  return hs(t && t.content, r && r.content);
}
function Sp(e) {
  var t = bp(e);
  if (t)
    return hs(Wn(t, "trace-id"), Wn(t, "trace-time"));
}
function hs(e, t) {
  var r = t && Number(t);
  if (!(!e || !r))
    return {
      traceId: e,
      traceTime: r
    };
}
function bp(e) {
  for (var t = 0; t < e.childNodes.length; t += 1) {
    var r = Oo(e.childNodes[t]);
    if (r)
      return r;
  }
  if (e.body)
    for (var t = e.body.childNodes.length - 1; t >= 0; t -= 1) {
      var n = e.body.childNodes[t], r = Oo(n);
      if (r)
        return r;
      if (!vs(n))
        break;
    }
}
function Oo(e) {
  if (e && mp(e)) {
    var t = /^\s*DATADOG;(.*?)\s*$/.exec(e.data);
    if (t)
      return t[1];
  }
}
var G;
(function(e) {
  e.EVENT = "event", e.FIRST_INPUT = "first-input", e.LARGEST_CONTENTFUL_PAINT = "largest-contentful-paint", e.LAYOUT_SHIFT = "layout-shift", e.LONG_TASK = "longtask", e.NAVIGATION = "navigation", e.PAINT = "paint", e.RESOURCE = "resource";
})(G || (G = {}));
function xo() {
  return window.performance !== void 0 && "getEntries" in performance;
}
function mr(e) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== void 0 && PerformanceObserver.supportedEntryTypes.includes(e);
}
function wp(e, t) {
  if (Ap(t, function(s) {
    ar(e, t, [s]);
  }), xo()) {
    var r = performance.getEntries();
    pe(function() {
      return ar(e, t, r);
    });
  }
  if (window.PerformanceObserver) {
    var n = D(function(s) {
      return ar(e, t, s.getEntries());
    }), a = [
      G.RESOURCE,
      G.NAVIGATION,
      G.LONG_TASK,
      G.PAINT
    ], o = [
      G.LARGEST_CONTENTFUL_PAINT,
      G.FIRST_INPUT,
      G.LAYOUT_SHIFT,
      G.EVENT
    ];
    try {
      o.forEach(function(s) {
        var c = new window.PerformanceObserver(n);
        c.observe({
          type: s,
          buffered: !0,
          // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
          // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
          durationThreshold: 40
        });
      });
    } catch {
      a.push.apply(a, o);
    }
    var i = new PerformanceObserver(n);
    i.observe({ entryTypes: a }), xo() && "addEventListener" in performance && oe(t, performance, "resourcetimingbufferfull", function() {
      performance.clearResourceTimings();
    });
  }
  mr(G.NAVIGATION) || Ep(t, function(s) {
    ar(e, t, [s]);
  }), mr(G.FIRST_INPUT) || Tp(t, function(s) {
    ar(e, t, [s]);
  });
}
function Ap(e, t) {
  Ra(e, "interactive", function() {
    var r, n = {
      entryType: G.RESOURCE,
      initiatorType: ds,
      traceId: _p(document),
      toJSON: function() {
        return B({}, r, { toJSON: void 0 });
      }
    };
    if (mr(G.NAVIGATION) && performance.getEntriesByType(G.NAVIGATION).length > 0) {
      var a = performance.getEntriesByType(G.NAVIGATION)[0];
      r = B(a.toJSON(), n);
    } else {
      var o = gs();
      r = B(o, {
        decodedBodySize: 0,
        duration: o.responseEnd,
        name: window.location.href,
        startTime: 0
      }, n);
    }
    t(r);
  });
}
function Ep(e, t) {
  function r() {
    t(B(gs(), {
      entryType: G.NAVIGATION
    }));
  }
  Ra(e, "complete", function() {
    pe(r);
  });
}
function Tp(e, t) {
  var r = Ve(), n = !1, a = Se(e, window, [
    "click",
    "mousedown",
    "keydown",
    "touchstart",
    "pointerdown"
    /* DOM_EVENT.POINTER_DOWN */
  ], function(s) {
    if (s.cancelable) {
      var c = {
        entryType: G.FIRST_INPUT,
        processingStart: Oe(),
        processingEnd: Oe(),
        startTime: s.timeStamp,
        duration: 0,
        name: ""
      };
      s.type === "pointerdown" ? o(e, c) : i(c);
    }
  }, { passive: !0, capture: !0 }).stop;
  function o(s, c) {
    Se(s, window, [
      "pointerup",
      "pointercancel"
      /* DOM_EVENT.POINTER_CANCEL */
    ], function(u) {
      u.type === "pointerup" && i(c);
    }, { once: !0 });
  }
  function i(s) {
    if (!n) {
      n = !0, a();
      var c = s.processingStart - s.startTime;
      c >= 0 && c < Ve() - r && t(s);
    }
  }
}
function gs() {
  var e = {}, t = performance.timing;
  for (var r in t)
    if (qt(t[r])) {
      var n = r, a = t[n];
      e[n] = a === 0 ? 0 : Oi(a);
    }
  return e;
}
function ar(e, t, r) {
  var n = r.filter(function(o) {
    return ga(G, o.entryType);
  }), a = n.filter(function(o) {
    return !Rp(o) && !Cp(t, o);
  });
  a.length && e.notify(0, a);
}
function Rp(e) {
  return e.entryType === G.NAVIGATION && e.loadEventEnd <= 0;
}
function Cp(e, t) {
  return t.entryType === G.RESOURCE && !Oa(e, t.name);
}
function Ip() {
  var e = Wf(), t = Yf();
  if (e && t)
    return {
      test_id: e,
      result_id: t,
      injected: ss()
    };
}
function Op() {
  var e, t = (e = window.Cypress) === null || e === void 0 ? void 0 : e.env("traceId");
  if (typeof t == "string")
    return {
      test_execution_id: t
    };
}
function xp(e, t, r) {
  var n = wa(e), a = r(n);
  return ha(t).forEach(function(o) {
    var i = o[0], s = o[1], c = kp(n, i), u = mt(c);
    u === s ? ko(e, i, Ce(c)) : s === "object" && (u === "undefined" || u === "null") && ko(e, i, {});
  }), a;
}
function kp(e, t) {
  for (var r = e, n = 0, a = t.split("."); n < a.length; n++) {
    var o = a[n];
    if (!Pp(r, o))
      return;
    r = r[o];
  }
  return r;
}
function ko(e, t, r) {
  for (var n = e, a = t.split("."), o = 0; o < a.length; o += 1) {
    var i = a[o];
    if (!_s(n))
      return;
    o !== a.length - 1 ? n = n[i] : n[i] = r;
  }
}
function _s(e) {
  return mt(e) === "object";
}
function Pp(e, t) {
  return _s(e) && Object.prototype.hasOwnProperty.call(e, t);
}
var or = {
  "view.name": "string",
  "view.url": "string",
  "view.referrer": "string"
}, Pr = {
  context: "object"
}, ys;
function Np(e, t, r, n, a, o, i, s, c) {
  var u, l;
  ys = (u = {}, u.view = or, u.error = B({
    "error.message": "string",
    "error.stack": "string",
    "error.resource.url": "string",
    "error.fingerprint": "string"
  }, Pr, or), u.resource = B({
    "resource.url": "string"
  }, Pr, or), u.action = B({
    "action.target.name": "string"
  }, Pr, or), u.long_task = B({}, Pr, or), u);
  var f = (l = {}, l.error = bo("error", e.eventRateLimiterThreshold, c), l.action = bo("action", e.eventRateLimiterThreshold, c), l), p = Ip(), m = Op();
  t.subscribe(10, function(g) {
    var S = g.startTime, x = g.rawRumEvent, P = g.domainContext, T = g.savedCommonContext, F = g.customerContext, M = n.findView(S), R = a.findUrl(S), L = r.findTrackedSession(S);
    if (L && M && R) {
      var j = T || s(), ne = o.findActionId(S), w = {
        _dd: {
          format_version: 2,
          drift: il(),
          session: {
            plan: L.plan
          },
          configuration: {
            session_sample_rate: jr(e.sessionSampleRate, 3),
            session_replay_sample_rate: jr(e.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: $t() ? "4.50.1" : void 0
        },
        application: {
          id: e.applicationId
        },
        date: ue(),
        service: M.service || e.service,
        version: M.version || e.version,
        source: "browser",
        session: {
          id: L.id,
          type: p ? "synthetics" : m ? "ci_test" : "user"
        },
        view: {
          id: M.id,
          name: M.name,
          url: R.url,
          referrer: R.referrer
        },
        action: Dp(x) && ne ? { id: ne } : void 0,
        synthetics: p,
        ci_test: m,
        display: i.get()
      }, I = Ge(w, x);
      I.context = Ge(j.context, F), "has_replay" in I.session || (I.session.has_replay = j.hasReplay), Je(j.user) || (I.usr = j.user), Lp(I, e.beforeSend, P, f) && (Je(I.context) && delete I.context, t.notify(11, I));
    }
  });
}
function Lp(e, t, r, n) {
  var a;
  if (t) {
    var o = xp(e, ys[e.type], function(s) {
      return t(s, r);
    });
    if (o === !1 && e.type !== "view")
      return !1;
    o === !1 && H.warn("Can't dismiss view events using beforeSend!");
  }
  var i = (a = n[e.type]) === null || a === void 0 ? void 0 : a.isLimitReached();
  return !i;
}
function Dp(e) {
  return [
    "error",
    "resource",
    "long_task"
    /* RumEventType.LONG_TASK */
  ].indexOf(e.type) !== -1;
}
function Mp(e, t, r, n, a) {
  return {
    get: function(o) {
      var i = r.findView(o), s = a.findUrl(o), c = t.findTrackedSession(o);
      if (c && i && s) {
        var u = n.findActionId(o);
        return {
          application_id: e,
          session_id: c.id,
          user_action: u ? { id: u } : void 0,
          view: { id: i.id, name: i.name, referrer: s.referrer, url: s.url }
        };
      }
    }
  };
}
var Up = Ef, Fp = Yt;
function jp(e) {
  var t = new Zt(Fp);
  e.subscribe(2, function(n) {
    t.add(r(n), n.startClocks.relative);
  }), e.subscribe(4, function(n) {
    var a = n.endClocks;
    t.closeActive(a.relative);
  }), e.subscribe(8, function() {
    t.reset();
  });
  function r(n) {
    return {
      service: n.service,
      version: n.version,
      id: n.id,
      name: n.name,
      startClocks: n.startClocks
    };
  }
  return {
    findView: function(n) {
      return t.find(n);
    },
    stop: function() {
      t.stop();
    }
  };
}
var Po = 1;
function Bp(e, t, r) {
  var n = Qf(t, r);
  Vp(e, t, n), zp(e, t, n);
}
function Vp(e, t, r) {
  var n = Tf(t).subscribe(function(a) {
    var o = a;
    if (Oa(t, o.url))
      switch (o.state) {
        case "start":
          r.traceXhr(o, o.xhr), o.requestIndex = Ss(), e.notify(5, {
            requestIndex: o.requestIndex,
            url: o.url
          });
          break;
        case "complete":
          r.clearTracingIfNeeded(o), e.notify(6, {
            duration: o.duration,
            method: o.method,
            requestIndex: o.requestIndex,
            spanId: o.spanId,
            startClocks: o.startClocks,
            status: o.status,
            traceId: o.traceId,
            traceSampled: o.traceSampled,
            type: "xhr",
            url: o.url,
            xhr: o.xhr
          });
          break;
      }
  });
  return { stop: function() {
    return n.unsubscribe();
  } };
}
function zp(e, t, r) {
  var n = xf().subscribe(function(a) {
    var o = a;
    if (Oa(t, o.url))
      switch (o.state) {
        case "start":
          r.traceFetch(o), o.requestIndex = Ss(), e.notify(5, {
            requestIndex: o.requestIndex,
            url: o.url
          });
          break;
        case "resolve":
          Hp(o, function(i) {
            r.clearTracingIfNeeded(o), e.notify(6, {
              duration: i,
              method: o.method,
              requestIndex: o.requestIndex,
              responseType: o.responseType,
              spanId: o.spanId,
              startClocks: o.startClocks,
              status: o.status,
              traceId: o.traceId,
              traceSampled: o.traceSampled,
              type: "fetch",
              url: o.url,
              response: o.response,
              init: o.init,
              input: o.input
            });
          });
          break;
      }
  });
  return { stop: function() {
    return n.unsubscribe();
  } };
}
function Ss() {
  var e = Po;
  return Po += 1, e;
}
function Hp(e, t) {
  var r = e.response && cf(e.response);
  !r || !r.body ? t(ye(e.startClocks.timeStamp, ue())) : Gf(r.body, function() {
    t(ye(e.startClocks.timeStamp, ue()));
  }, {
    bytesLimit: Number.POSITIVE_INFINITY,
    collectStreamBody: !1
  });
}
function bs(e) {
  var t = e.lifeCycle, r = e.isChildEvent, n = e.onChange, a = n === void 0 ? Q : n, o = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  }, i = t.subscribe(11, function(s) {
    var c;
    if (!(s.type === "view" || !r(s)))
      switch (s.type) {
        case "error":
          o.errorCount += 1, a();
          break;
        case "action":
          o.actionCount += 1, s.action.frustration && (o.frustrationCount += s.action.frustration.type.length), a();
          break;
        case "long_task":
          o.longTaskCount += 1, a();
          break;
        case "resource":
          !((c = s._dd) === null || c === void 0) && c.discarded || (o.resourceCount += 1, a());
          break;
      }
  });
  return {
    stop: function() {
      i.unsubscribe();
    },
    eventCounts: o
  };
}
var ws = 100, Gp = 100;
function ka(e, t, r, n, a) {
  var o = qp(e, t, r);
  return $p(o, n, a);
}
function $p(e, t, r) {
  var n, a = !1, o = pe(D(function() {
    return u({ hadActivity: !1 });
  }), ws), i = r !== void 0 ? pe(D(function() {
    return u({ hadActivity: !0, end: ue() });
  }), r) : void 0, s = e.subscribe(function(l) {
    var f = l.isBusy;
    je(o), je(n);
    var p = ue();
    f || (n = pe(D(function() {
      return u({ hadActivity: !0, end: p });
    }), Gp));
  }), c = function() {
    a = !0, je(o), je(n), je(i), s.unsubscribe();
  };
  function u(l) {
    a || (c(), t(l));
  }
  return { stop: c };
}
function qp(e, t, r) {
  var n = new te(function() {
    var a = [], o, i = 0;
    a.push(t.subscribe(c), e.subscribe(0, function(u) {
      u.some(function(l) {
        return l.entryType === G.RESOURCE && !xn(r, l.name);
      }) && c();
    }), e.subscribe(5, function(u) {
      xn(r, u.url) || (o === void 0 && (o = u.requestIndex), i += 1, c());
    }), e.subscribe(6, function(u) {
      xn(r, u.url) || o === void 0 || // If the request started before the tracking start, ignore it
      u.requestIndex < o || (i -= 1, c());
    }));
    var s = Kp(c).stop;
    return function() {
      s(), a.forEach(function(u) {
        return u.unsubscribe();
      });
    };
    function c() {
      n.notify({ isBusy: i > 0 });
    }
  });
  return n;
}
function xn(e, t) {
  return cs(e.excludedActivityUrls, t);
}
function Kp(e) {
  return Te(window, "open", { before: e });
}
var Pa = "data-dd-action-name";
function Wp(e, t) {
  return No(e, Pa) || t && No(e, t) || Lo(e, t, Yp) || Lo(e, t, Xp) || "";
}
function No(e, t) {
  var r;
  if (tv())
    r = e.closest("[".concat(t, "]"));
  else
    for (var n = e; n; ) {
      if (n.hasAttribute(t)) {
        r = n;
        break;
      }
      n = n.parentElement;
    }
  if (r) {
    var a = r.getAttribute(t);
    return Es(As(a.trim()));
  }
}
var Yp = [
  // associated LABEL text
  function(e, t) {
    if (ev()) {
      if ("labels" in e && e.labels && e.labels.length > 0)
        return Mt(e.labels[0], t);
    } else if (e.id) {
      var r = e.ownerDocument && Wt(e.ownerDocument.querySelectorAll("label"), function(n) {
        return n.htmlFor === e.id;
      });
      return r && Mt(r, t);
    }
  },
  // INPUT button (and associated) value
  function(e) {
    if (e.nodeName === "INPUT") {
      var t = e, r = t.getAttribute("type");
      if (r === "button" || r === "submit" || r === "reset")
        return t.value;
    }
  },
  // BUTTON, LABEL or button-like element text
  function(e, t) {
    if (e.nodeName === "BUTTON" || e.nodeName === "LABEL" || e.getAttribute("role") === "button")
      return Mt(e, t);
  },
  function(e) {
    return e.getAttribute("aria-label");
  },
  // associated element text designated by the aria-labelledby attribute
  function(e, t) {
    var r = e.getAttribute("aria-labelledby");
    if (r)
      return r.split(/\s+/).map(function(n) {
        return Zp(e, n);
      }).filter(function(n) {
        return !!n;
      }).map(function(n) {
        return Mt(n, t);
      }).join(" ");
  },
  function(e) {
    return e.getAttribute("alt");
  },
  function(e) {
    return e.getAttribute("name");
  },
  function(e) {
    return e.getAttribute("title");
  },
  function(e) {
    return e.getAttribute("placeholder");
  },
  // SELECT first OPTION text
  function(e, t) {
    if ("options" in e && e.options.length > 0)
      return Mt(e.options[0], t);
  }
], Xp = [
  function(e, t) {
    return Mt(e, t);
  }
], Jp = 10;
function Lo(e, t, r) {
  for (var n = e, a = 0; a <= Jp && n && n.nodeName !== "BODY" && n.nodeName !== "HTML" && n.nodeName !== "HEAD"; ) {
    for (var o = 0, i = r; o < i.length; o++) {
      var s = i[o], c = s(n, t);
      if (typeof c == "string") {
        var u = c.trim();
        if (u)
          return Es(As(u));
      }
    }
    if (n.nodeName === "FORM")
      break;
    n = n.parentElement, a += 1;
  }
}
function As(e) {
  return e.replace(/\s+/g, " ");
}
function Es(e) {
  return e.length > 100 ? "".concat(Li(e, 100), " [...]") : e;
}
function Zp(e, t) {
  return e.ownerDocument ? e.ownerDocument.getElementById(t) : null;
}
function Mt(e, t) {
  if (!e.isContentEditable) {
    if ("innerText" in e) {
      var r = e.innerText, n = function(a) {
        for (var o = e.querySelectorAll(a), i = 0; i < o.length; i += 1) {
          var s = o[i];
          if ("innerText" in s) {
            var c = s.innerText;
            c && c.trim().length > 0 && (r = r.replace(c, ""));
          }
        }
      };
      return Qp() || n("script, style"), n("[".concat(Pa, "]")), t && n("[".concat(t, "]")), r;
    }
    return e.textContent;
  }
}
function Qp() {
  return !yl();
}
var kn;
function ev() {
  return kn === void 0 && (kn = "labels" in HTMLInputElement.prototype), kn;
}
var Pn;
function tv() {
  return Pn === void 0 && (Pn = "closest" in HTMLElement.prototype), Pn;
}
var Ts = [
  Pa,
  // Common test attributes (list provided by google recorder)
  "data-testid",
  "data-test",
  "data-qa",
  "data-cy",
  "data-test-id",
  "data-qa-id",
  "data-testing",
  // FullStory decorator attributes:
  "data-component",
  "data-element",
  "data-source-file"
], rv = [Cs, av], nv = [
  Cs,
  ov,
  iv
];
function br(e, t) {
  for (var r = "", n = e; n && n.nodeName !== "HTML"; ) {
    var a = Do(n, rv, cv, t, r);
    if (a)
      return a;
    var o = Do(n, nv, uv, t, r);
    r = o || Na(sv(n), r), n = n.parentElement;
  }
  return r;
}
function Rs(e) {
  return /[0-9]/.test(e);
}
function av(e) {
  if (e.id && !Rs(e.id))
    return "#".concat(lt(e.id));
}
function ov(e) {
  if (e.tagName !== "BODY" && e.classList.length > 0)
    for (var t = 0; t < e.classList.length; t += 1) {
      var r = e.classList[t];
      if (!Rs(r))
        return "".concat(lt(e.tagName), ".").concat(lt(r));
    }
}
function iv(e) {
  return lt(e.tagName);
}
function Cs(e, t) {
  if (t) {
    var r = i(t);
    if (r)
      return r;
  }
  for (var n = 0, a = Ts; n < a.length; n++) {
    var o = a[n], r = i(o);
    if (r)
      return r;
  }
  function i(s) {
    if (e.hasAttribute(s))
      return "".concat(lt(e.tagName), "[").concat(s, '="').concat(lt(e.getAttribute(s)), '"]');
  }
}
function sv(e) {
  for (var t = e.parentElement.firstElementChild, r = 1; t && t !== e; )
    t.tagName === e.tagName && (r += 1), t = t.nextElementSibling;
  return "".concat(lt(e.tagName), ":nth-of-type(").concat(r, ")");
}
function Do(e, t, r, n, a) {
  for (var o = 0, i = t; o < i.length; o++) {
    var s = i[o], c = s(e, n);
    if (c) {
      var u = Na(c, a);
      if (r(e, u))
        return u;
    }
  }
}
function cv(e, t) {
  return e.ownerDocument.querySelectorAll(t).length === 1;
}
function uv(e, t) {
  return e.parentElement.querySelectorAll(lv() ? Na(":scope", t) : t).length === 1;
}
function Na(e, t) {
  return t ? "".concat(e, ">").concat(t) : e;
}
var Nr;
function lv() {
  if (Nr === void 0)
    try {
      document.querySelector(":scope"), Nr = !0;
    } catch {
      Nr = !1;
    }
  return Nr;
}
var Is = _e, dv = 100;
function fv(e, t) {
  var r = [], n = 0, a;
  o(e);
  function o(c) {
    c.stopObservable.subscribe(i), r.push(c), je(a), a = pe(s, Is);
  }
  function i() {
    n === 1 && r.every(function(c) {
      return c.isStopped();
    }) && (n = 2, t(r));
  }
  function s() {
    je(a), n === 0 && (n = 1, i());
  }
  return {
    tryAppend: function(c) {
      return n !== 0 ? !1 : r.length > 0 && !pv(r[r.length - 1].event, c.event) ? (s(), !1) : (o(c), !0);
    },
    stop: function() {
      s();
    }
  };
}
function pv(e, t) {
  return e.target === t.target && vv(e, t) <= dv && e.timeStamp - t.timeStamp <= Is;
}
function vv(e, t) {
  return Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2));
}
function mv(e, t) {
  var r = t.onPointerDown, n = t.onPointerUp, a, o = {
    selection: !1,
    input: !1
  }, i, s = [
    oe(e, window, "pointerdown", function(c) {
      Uo(c) && (a = Mo(), o = {
        selection: !1,
        input: !1
      }, i = r(c));
    }, { capture: !0 }),
    oe(e, window, "selectionchange", function() {
      (!a || !Mo()) && (o.selection = !0);
    }, { capture: !0 }),
    oe(e, window, "pointerup", function(c) {
      if (Uo(c) && i) {
        var u = o;
        n(i, c, function() {
          return u;
        }), i = void 0;
      }
    }, { capture: !0 }),
    oe(e, window, "input", function() {
      o.input = !0;
    }, { capture: !0 })
  ];
  return {
    stop: function() {
      s.forEach(function(c) {
        return c.stop();
      });
    }
  };
}
function Mo() {
  var e = window.getSelection();
  return !e || e.isCollapsed;
}
function Uo(e) {
  return e.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  e.isPrimary !== !1;
}
var Fo = 3;
function hv(e, t) {
  if (gv(e))
    return t.addFrustration(
      "rage_click"
      /* FrustrationType.RAGE_CLICK */
    ), e.some(jo) && t.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    ), t.hasError && t.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), { isRage: !0 };
  var r = e.some(function(n) {
    return n.getUserActivity().selection;
  });
  return e.forEach(function(n) {
    n.hasError && n.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), jo(n) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !r && n.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    );
  }), { isRage: !1 };
}
function gv(e) {
  if (e.some(function(r) {
    return r.getUserActivity().selection;
  }))
    return !1;
  for (var t = 0; t < e.length - (Fo - 1); t += 1)
    if (e[t + Fo - 1].event.timeStamp - e[t].event.timeStamp <= _e)
      return !0;
  return !1;
}
var _v = (
  // inputs that don't trigger a meaningful event like "input" when clicked, including textual
  // inputs (using a negative selector is shorter here)
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *'
);
function jo(e) {
  return e.hasPageActivity || e.getUserActivity().input ? !1 : !vl(e.event.target, _v);
}
var yv = 10 * _e, Sv = 5 * we;
function bv(e, t, r) {
  var n = new Zt(Sv), a = new te(), o;
  e.subscribe(8, function() {
    n.reset();
  }), e.subscribe(4, u);
  var i = mv(r, {
    onPointerDown: function(l) {
      return wv(r, e, t, n, l);
    },
    onPointerUp: function(l, f, p) {
      var m = l.clickActionBase, g = l.hadActivityOnPointerDown;
      return Av(r, e, t, n, a, c, m, f, p, g);
    }
  }).stop, s = {
    findActionId: function(l) {
      return r.trackFrustrations ? n.findAll(l) : n.find(l);
    }
  };
  return {
    stop: function() {
      u(), a.notify(), i();
    },
    actionContexts: s
  };
  function c(l) {
    if (!o || !o.tryAppend(l)) {
      var f = l.clone();
      o = fv(l, function(p) {
        Tv(p, f);
      });
    }
  }
  function u() {
    o && o.stop();
  }
}
function wv(e, t, r, n, a) {
  if (!(!e.trackFrustrations && n.find())) {
    var o = Ev(a, e.actionNameAttribute);
    if (!(!e.trackFrustrations && !o.name)) {
      var i = !1;
      return ka(
        t,
        r,
        e,
        function(s) {
          i = s.hadActivity;
        },
        // We don't care about the activity duration, we just want to know whether an activity did happen
        // within the "validation delay" or not. Limit the duration so the callback is called sooner.
        ws
      ), { clickActionBase: o, hadActivityOnPointerDown: function() {
        return i;
      } };
    }
  }
}
function Av(e, t, r, n, a, o, i, s, c, u) {
  var l = Os(t, n, c, i, s);
  e.trackFrustrations && o(l);
  var f = ka(t, r, e, function(g) {
    g.hadActivity && g.end < l.startClocks.timeStamp ? l.discard() : (g.hadActivity ? l.stop(g.end) : u() ? l.stop(
      // using the click start as activity end, so the click will have some activity but its
      // duration will be 0 (as the activity started before the click start)
      l.startClocks.timeStamp
    ) : l.stop(), e.trackFrustrations || (g.hadActivity ? l.validate() : l.discard()));
  }, yv).stop, p = t.subscribe(4, function(g) {
    var S = g.endClocks;
    l.stop(S.timeStamp);
  }), m = a.subscribe(function() {
    l.stop();
  });
  l.stopObservable.subscribe(function() {
    p.unsubscribe(), f(), m.unsubscribe();
  });
}
function Ev(e, t) {
  var r = e.target.getBoundingClientRect();
  return {
    type: "click",
    target: {
      width: Math.round(r.width),
      height: Math.round(r.height),
      selector: br(e.target, t)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(e.clientX - r.left),
      y: Math.round(e.clientY - r.top)
    },
    name: Wp(e.target, t)
  };
}
function Os(e, t, r, n, a) {
  var o = Ae(), i = Re(), s = t.add(o, i.relative), c = bs({
    lifeCycle: e,
    isChildEvent: function(g) {
      return g.action !== void 0 && (Array.isArray(g.action.id) ? Qe(g.action.id, o) : g.action.id === o);
    }
  }), u = 0, l, f = [], p = new te();
  function m(g) {
    u === 0 && (l = g, u = 1, l ? s.close(Oi(l)) : s.remove(), c.stop(), p.notify());
  }
  return {
    event: a,
    stop: m,
    stopObservable: p,
    get hasError() {
      return c.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return l !== void 0;
    },
    getUserActivity: r,
    addFrustration: function(g) {
      f.push(g);
    },
    startClocks: i,
    isStopped: function() {
      return u === 1 || u === 2;
    },
    clone: function() {
      return Os(e, t, r, n, a);
    },
    validate: function(g) {
      if (m(), u === 1) {
        var S = c.eventCounts, x = S.resourceCount, P = S.errorCount, T = S.longTaskCount, F = B({
          type: "click",
          duration: l && ye(i.timeStamp, l),
          startClocks: i,
          id: o,
          frustrationTypes: f,
          counts: {
            resourceCount: x,
            errorCount: P,
            longTaskCount: T
          },
          events: g ?? [a],
          event: a
        }, n);
        e.notify(1, F), u = 2;
      }
    },
    discard: function() {
      m(), u = 2;
    }
  };
}
function Tv(e, t) {
  var r = hv(e, t).isRage;
  r ? (e.forEach(function(n) {
    return n.discard();
  }), t.stop(ue()), t.validate(e.map(function(n) {
    return n.event;
  }))) : (t.discard(), e.forEach(function(n) {
    return n.validate();
  }));
}
function Rv(e, t, r, n) {
  e.subscribe(1, function(o) {
    return e.notify(10, Bo(o, n));
  });
  var a = { findActionId: Q };
  return r.trackUserInteractions && (a = bv(e, t, r).actionContexts), {
    addAction: function(o, i) {
      e.notify(10, B({
        savedCommonContext: i
      }, Bo(o, n)));
    },
    actionContexts: a
  };
}
function Bo(e, t) {
  var r = Nn(e) ? {
    action: {
      id: e.id,
      loading_time: X(e.duration),
      frustration: {
        type: e.frustrationTypes
      },
      error: {
        count: e.counts.errorCount
      },
      long_task: {
        count: e.counts.longTaskCount
      },
      resource: {
        count: e.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: e.target,
        position: e.position
      }
    }
  } : void 0, n = Nn(e) ? void 0 : e.context, a = Ge({
    action: {
      id: Ae(),
      target: {
        name: e.name
      },
      type: e.type
    },
    date: e.startClocks.timeStamp,
    type: "action",
    view: { in_foreground: t.isInActivePageStateAt(e.startClocks.relative) }
  }, r);
  return {
    customerContext: n,
    rawRumEvent: a,
    startTime: e.startClocks.relative,
    domainContext: Nn(e) ? { event: e.event, events: e.events } : {}
  };
}
function Nn(e) {
  return e.type !== "custom";
}
function Cv(e) {
  var t = Lf([Yr.error]).subscribe(function(r) {
    return e.notify({
      startClocks: Re(),
      message: r.message,
      stack: r.stack,
      fingerprint: r.fingerprint,
      source: Jt.CONSOLE,
      handling: "handled",
      handlingStack: r.handlingStack
    });
  });
  return {
    stop: function() {
      t.unsubscribe();
    }
  };
}
function Iv(e, t) {
  var r = Bd(e, [
    Gt.cspViolation,
    Gt.intervention
  ]).subscribe(function(n) {
    return t.notify({
      startClocks: Re(),
      message: n.message,
      stack: n.stack,
      type: n.subtype,
      source: Jt.REPORT,
      handling: "unhandled"
    });
  });
  return {
    stop: function() {
      r.unsubscribe();
    }
  };
}
function Ov(e, t, r, n) {
  var a = new te();
  return Cv(a), Ud(a), Iv(t, a), a.subscribe(function(o) {
    return e.notify(12, { error: o });
  }), xv(e, r, n);
}
function xv(e, t, r) {
  return e.subscribe(12, function(n) {
    var a = n.error, o = n.customerContext, i = n.savedCommonContext;
    e.notify(10, B({
      customerContext: o,
      savedCommonContext: i
    }, kv(a, t, r)));
  }), {
    addError: function(n, a) {
      var o = n.error, i = n.handlingStack, s = n.startClocks, c = n.context, u = o instanceof Error ? vt(o) : void 0, l = qi({
        stackTrace: u,
        originalError: o,
        handlingStack: i,
        startClocks: s,
        nonErrorPrefix: "Provided",
        source: Jt.CUSTOM,
        handling: "handled"
      });
      e.notify(12, {
        customerContext: c,
        savedCommonContext: a,
        error: l
      });
    }
  };
}
function kv(e, t, r) {
  var n = {
    date: e.startClocks.timeStamp,
    error: {
      id: Ae(),
      message: e.message,
      source: e.source,
      stack: e.stack,
      handling_stack: e.handlingStack,
      type: e.type,
      handling: e.handling,
      causes: e.causes,
      source_type: "browser",
      fingerprint: e.fingerprint
    },
    type: "error",
    view: { in_foreground: t.isInActivePageStateAt(e.startClocks.relative) }
  }, a = r.findFeatureFlagEvaluations(e.startClocks.relative);
  return a && !Je(a) && (n.feature_flags = a), {
    rawRumEvent: n,
    startTime: e.startClocks.relative,
    domainContext: {
      error: e.originalError
    }
  };
}
function Pv(e, t) {
  e.subscribe(0, function(r) {
    for (var n = 0, a = r; n < a.length; n++) {
      var o = a[n];
      if (o.entryType !== G.LONG_TASK)
        break;
      var i = t.findTrackedSession(o.startTime);
      if (!i || !i.longTaskAllowed)
        break;
      var s = ma(o.startTime), c = {
        date: s.timeStamp,
        long_task: {
          id: Ae(),
          duration: X(o.duration)
        },
        type: "long_task",
        _dd: {
          discarded: !1
        }
      };
      e.notify(10, {
        rawRumEvent: c,
        startTime: s.relative,
        domainContext: { performanceEntry: o.toJSON() }
      });
    }
  });
}
function Nv(e) {
  if (!(!performance || !("getEntriesByName" in performance))) {
    var t = performance.getEntriesByName(e.url, "resource");
    if (!(!t.length || !("toJSON" in t[0]))) {
      var r = t.map(function(n) {
        return n.toJSON();
      }).filter(fs).filter(function(n) {
        return Lv(n, e.startClocks.relative, xs({ startTime: e.startClocks.relative, duration: e.duration }));
      });
      if (r.length === 1)
        return r[0];
    }
  }
}
function xs(e) {
  return Kt(e.startTime, e.duration);
}
function Lv(e, t, r) {
  var n = 1;
  return e.startTime >= t - n && xs(e) <= Kt(r, n);
}
function Dv(e, t, r, n) {
  e.subscribe(6, function(a) {
    e.notify(10, Mv(a, t, r, n));
  }), e.subscribe(0, function(a) {
    for (var o = 0, i = a; o < i.length; o++) {
      var s = i[o];
      s.entryType === G.RESOURCE && !dp(s) && e.notify(10, Uv(s, t, r, n));
    }
  });
}
function Mv(e, t, r, n) {
  var a, o = e.type === "xhr" ? "xhr" : "fetch", i = Nv(e), s = i ? ma(i.startTime) : e.startClocks, c = i ? ks(i) : void 0, u = Fv(e, t), l = Ns(r, s), f = Bv(n, s, e.duration), p = Ls(n, s, (a = i == null ? void 0 : i.duration) !== null && a !== void 0 ? a : e.duration), m = Ge({
    date: s.timeStamp,
    resource: {
      id: Ae(),
      type: o,
      duration: f,
      method: e.method,
      status_code: e.status,
      url: e.url
    },
    type: "resource"
  }, u, c, l, p);
  return {
    startTime: s.relative,
    rawRumEvent: m,
    domainContext: {
      performanceEntry: i && i,
      xhr: e.xhr,
      response: e.response,
      requestInput: e.input,
      requestInit: e.init,
      error: e.error
    }
  };
}
function Uv(e, t, r, n) {
  var a = lp(e), o = ks(e), i = ma(e.startTime), s = jv(e, t), c = Ns(r, i), u = Ls(n, i, e.duration), l = Ge({
    date: i.timeStamp,
    resource: {
      id: Ae(),
      type: a,
      url: e.name
    },
    type: "resource"
  }, s, o, c, u);
  return {
    startTime: i.relative,
    rawRumEvent: l,
    domainContext: {
      performanceEntry: e
    }
  };
}
function ks(e) {
  return {
    resource: B({
      duration: fp(e),
      size: vp(e)
    }, pp(e))
  };
}
function Fv(e, t) {
  var r = e.traceSampled && e.traceId && e.spanId;
  if (r)
    return {
      _dd: {
        span_id: e.spanId.toDecimalString(),
        trace_id: e.traceId.toDecimalString(),
        rule_psr: Ps(t)
      }
    };
}
function jv(e, t) {
  var r = e.traceId;
  if (r)
    return {
      _dd: {
        trace_id: e.traceId,
        rule_psr: Ps(t)
      }
    };
}
function Ps(e) {
  return qt(e.traceSampleRate) ? e.traceSampleRate / 100 : void 0;
}
function Ns(e, t) {
  var r = e.findTrackedSession(t.relative);
  return {
    _dd: {
      discarded: !r || !r.resourceAllowed
    }
  };
}
function Ls(e, t, r) {
  if (Ie(ve.RESOURCE_PAGE_STATES))
    return {
      _dd: {
        page_states: e.findAll(t.relative, r),
        page_was_discarded: String(document.wasDiscarded)
      }
    };
}
function Bv(e, t, r) {
  var n;
  if (!Ie(ve.NO_RESOURCE_DURATION_FROZEN_STATE))
    return X(r);
  var a = (n = e.findAll(t.relative, r)) === null || n === void 0 ? void 0 : n.some(function(o) {
    return o.state === "frozen";
  });
  return a ? void 0 : X(r);
}
function Vv(e, t) {
  for (var r = [], n = 0; n < e.length; n++) {
    var a = e[n], o = e[n + 1];
    if (a.state === "active") {
      var i = a.start >= 0 ? a.start : 0, s = o ? o.start : X(t);
      r.push({
        start: i,
        duration: s - i
      });
    }
  }
  return r;
}
function zv(e, t, r) {
  var n = bs({
    lifeCycle: e,
    isChildEvent: function(i) {
      return i.view.id === t;
    },
    onChange: r
  }), a = n.stop, o = n.eventCounts;
  return {
    stop: a,
    eventCounts: o
  };
}
var Hv = 10 * we;
function Gv(e, t, r) {
  var n = e.subscribe(0, function(a) {
    var o = Wt(a, function(i) {
      return i.entryType === G.PAINT && i.name === "first-contentful-paint" && i.startTime < t.timeStamp && i.startTime < Hv;
    });
    o && r(o.startTime);
  }).unsubscribe;
  return {
    stop: n
  };
}
function $v(e, t, r, n) {
  var a = e.subscribe(0, function(o) {
    var i = Wt(o, function(u) {
      return u.entryType === G.FIRST_INPUT && u.startTime < r.timeStamp;
    });
    if (i) {
      var s = ye(i.startTime, i.processingStart), c = void 0;
      Ie(ve.WEB_VITALS_ATTRIBUTION) && i.target && Qt(i.target) && (c = br(i.target, t.actionNameAttribute)), n({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: s >= 0 ? s : 0,
        time: i.startTime,
        targetSelector: c
      });
    }
  }).unsubscribe;
  return {
    stop: a
  };
}
function qv(e, t) {
  var r = e.subscribe(0, function(n) {
    for (var a = 0, o = n; a < o.length; a++) {
      var i = o[a];
      i.entryType === G.NAVIGATION && t({
        domComplete: i.domComplete,
        domContentLoaded: i.domContentLoadedEventEnd,
        domInteractive: i.domInteractive,
        loadEvent: i.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: i.responseStart >= 0 && i.responseStart <= Oe() ? i.responseStart : void 0
      });
    }
  }).unsubscribe;
  return { stop: r };
}
var Kv = 10 * we;
function Wv(e, t, r, n, a) {
  var o = 1 / 0, i = Se(t, n, [
    "pointerdown",
    "keydown"
    /* DOM_EVENT.KEY_DOWN */
  ], function(c) {
    o = c.timeStamp;
  }, { capture: !0, once: !0 }).stop, s = e.subscribe(0, function(c) {
    var u = dl(c, function(f) {
      return f.entryType === G.LARGEST_CONTENTFUL_PAINT && f.startTime < o && f.startTime < r.timeStamp && f.startTime < Kv;
    });
    if (u) {
      var l = void 0;
      Ie(ve.WEB_VITALS_ATTRIBUTION) && u.element && (l = br(u.element, t.actionNameAttribute)), a({
        value: u.startTime,
        targetSelector: l
      });
    }
  }).unsubscribe;
  return {
    stop: function() {
      i(), s();
    }
  };
}
function Yv(e, t) {
  t === void 0 && (t = window);
  var r, n;
  return document.visibilityState === "hidden" ? r = 0 : (r = 1 / 0, n = Se(e, t, [
    "pagehide",
    "visibilitychange"
    /* DOM_EVENT.VISIBILITY_CHANGE */
  ], function(a) {
    (a.type === "pagehide" || document.visibilityState === "hidden") && (r = a.timeStamp, n());
  }, { capture: !0 }).stop), {
    get timeStamp() {
      return r;
    },
    stop: function() {
      n == null || n();
    }
  };
}
function Xv(e, t, r, n) {
  var a = {}, o = qv(e, function(f) {
    r(f.loadEvent), a.navigationTimings = f, n();
  }).stop, i = Yv(t), s = Gv(e, i, function(f) {
    a.firstContentfulPaint = f, n();
  }).stop, c = Wv(e, t, i, window, function(f) {
    a.largestContentfulPaint = f, n();
  }).stop, u = $v(e, t, i, function(f) {
    a.firstInput = f, n();
  }).stop;
  function l() {
    o(), s(), c(), u(), i.stop();
  }
  return {
    stop: l,
    initialViewMetrics: a
  };
}
function Jv(e, t, r) {
  if (!Qv())
    return {
      stop: Q
    };
  var n = 0;
  r({
    value: 0
  });
  var a = Zv(), o = t.subscribe(0, function(i) {
    for (var s = 0, c = i; s < c.length; s++) {
      var u = c[s];
      if (u.entryType === G.LAYOUT_SHIFT && !u.hadRecentInput && (a.update(u), a.value() > n)) {
        n = a.value();
        var l = jr(n, 4), f = a.largestLayoutShiftTarget(), p = void 0;
        Ie(ve.WEB_VITALS_ATTRIBUTION) && f && (p = br(f, e.actionNameAttribute)), r({
          value: l,
          targetSelector: p
        });
      }
    }
  }).unsubscribe;
  return {
    stop: o
  };
}
function Zv() {
  var e = 0, t, r, n = 0, a, o;
  return {
    update: function(i) {
      var s, c, u = t === void 0 || i.startTime - r >= _e || i.startTime - t >= 5 * _e;
      u ? (t = r = i.startTime, e = i.value, n = 0, a = void 0) : (e += i.value, r = i.startTime), i.value > n && (n = i.value, o = i.startTime, !((s = i.sources) === null || s === void 0) && s.length ? a = (c = Wt(i.sources, function(l) {
        return !!l.node && Qt(l.node);
      })) === null || c === void 0 ? void 0 : c.node : a = void 0);
    },
    value: function() {
      return e;
    },
    largestLayoutShiftTarget: function() {
      return a;
    },
    largestLayoutShiftTime: function() {
      return o;
    }
  };
}
function Qv() {
  return mr(G.LAYOUT_SHIFT);
}
var Mr, Ds = 0, Ln = 1 / 0, Dn = 0;
function em() {
  "interactionCount" in performance || Mr || (Mr = new window.PerformanceObserver(D(function(e) {
    e.getEntries().forEach(function(t) {
      var r = t;
      r.interactionId && (Ln = Math.min(Ln, r.interactionId), Dn = Math.max(Dn, r.interactionId), Ds = (Dn - Ln) / 7 + 1);
    });
  })), Mr.observe({ type: "event", buffered: !0, durationThreshold: 0 }));
}
var Vo = function() {
  return Mr ? Ds : window.performance.interactionCount || 0;
}, zo = 10;
function tm(e, t, r, n) {
  if (!am() || !Ie(ve.INTERACTION_TO_NEXT_PAINT))
    return {
      getInteractionToNextPaint: function() {
      },
      stop: Q
    };
  var a = nm(r).getViewInteractionCount, o = rm(a), i = -1, s, c = !1, u = n.subscribe(0, function(l) {
    for (var f, p = 0, m = l; p < m.length; p++) {
      var g = m[p];
      (g.entryType === G.EVENT || g.entryType === G.FIRST_INPUT) && g.interactionId && o.process(g);
    }
    var S = o.estimateP98Interaction();
    S && (i = S.duration, i > 10 * we && !c && (c = !0, Tt("INP outlier", {
      inp: i,
      interaction: {
        timeFromViewStart: ye(t.relative, S.startTime),
        duration: S.duration,
        startTime: S.startTime,
        processingStart: S.processingStart,
        processingEnd: S.processingEnd,
        interactionId: S.interactionId,
        name: S.name,
        targetNodeName: (f = S.target) === null || f === void 0 ? void 0 : f.nodeName
      }
    })), Ie(ve.WEB_VITALS_ATTRIBUTION) && S.target && Qt(S.target) ? s = br(S.target, e.actionNameAttribute) : s = void 0);
  }).unsubscribe;
  return {
    getInteractionToNextPaint: function() {
      if (i >= 0)
        return {
          value: i,
          targetSelector: s
        };
      if (a())
        return {
          value: 0
        };
    },
    stop: u
  };
}
function rm(e) {
  var t = [];
  function r() {
    t.sort(function(n, a) {
      return a.duration - n.duration;
    }).splice(zo);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function(n) {
      var a = t.findIndex(function(i) {
        return n.interactionId === i.interactionId;
      }), o = t[t.length - 1];
      a !== -1 ? n.duration > t[a].duration && (t[a] = n, r()) : (t.length < zo || n.duration > o.duration) && (t.push(n), r());
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function() {
      var n = Math.min(t.length - 1, Math.floor(e() / 50));
      return t[n];
    }
  };
}
function nm(e) {
  em();
  var t = e === "initial_load" ? 0 : Vo();
  return {
    getViewInteractionCount: function() {
      return Vo() - t;
    }
  };
}
function am() {
  return mr(G.EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function om(e, t, r, n, a, o) {
  var i = n === "initial_load", s = !0, c = [];
  function u() {
    !s && !i && c.length > 0 && o(Math.max.apply(Math, c));
  }
  var l = ka(e, t, r, function(f) {
    s && (s = !1, f.hadActivity && c.push(ye(a.timeStamp, f.end)), u());
  }).stop;
  return {
    stop: l,
    setLoadEvent: function(f) {
      i && (i = !1, c.push(f), u());
    }
  };
}
function Ms() {
  var e, t = window.visualViewport;
  return t ? e = t.pageLeft - t.offsetLeft : window.scrollX !== void 0 ? e = window.scrollX : e = window.pageXOffset || 0, Math.round(e);
}
function La() {
  var e, t = window.visualViewport;
  return t ? e = t.pageTop - t.offsetTop : window.scrollY !== void 0 ? e = window.scrollY : e = window.pageYOffset || 0, Math.round(e);
}
var Mn;
function Us(e) {
  return Mn || (Mn = im(e)), Mn;
}
function im(e) {
  var t = new te(function() {
    var r = tt(function() {
      t.notify(tn());
    }, 200).throttled;
    return oe(e, window, "resize", r, { capture: !0, passive: !0 }).stop;
  });
  return t;
}
function tn() {
  var e = window.visualViewport;
  return e ? {
    width: Number(e.width * e.scale),
    height: Number(e.height * e.scale)
  } : {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}
var sm = _e;
function cm(e, t, r, n) {
  n === void 0 && (n = lm(e));
  var a = 0, o = 0, i = 0, s = n.subscribe(function(c) {
    var u = c.scrollDepth, l = c.scrollTop, f = c.scrollHeight, p = !1;
    if (u > a && (a = u, p = !0), f > o) {
      o = f;
      var m = Oe();
      i = ye(t.relative, m), p = !0;
    }
    p && r({
      maxDepth: Math.min(a, o),
      maxDepthScrollTop: l,
      maxScrollHeight: o,
      maxScrollHeightTime: i
    });
  });
  return {
    stop: function() {
      return s.unsubscribe();
    }
  };
}
function um() {
  var e = La(), t = tn().height, r = Math.round((document.scrollingElement || document.documentElement).scrollHeight), n = Math.round(t + e);
  return {
    scrollHeight: r,
    scrollDepth: n,
    scrollTop: e
  };
}
function lm(e, t) {
  t === void 0 && (t = sm);
  var r = new te(function() {
    function n() {
      r.notify(um());
    }
    if (window.ResizeObserver) {
      var a = tt(n, t, {
        leading: !1,
        trailing: !0
      }), o = document.scrollingElement || document.documentElement, i = new ResizeObserver(D(a.throttled));
      i.observe(o);
      var s = oe(e, window, "scroll", a.throttled, {
        passive: !0
      });
      return function() {
        a.cancel(), i.unobserve(o), s.stop();
      };
    }
  });
  return r;
}
function dm(e, t, r, n, a, o) {
  var i = {}, s = om(e, t, r, a, o, function(S) {
    i.loadingTime = S, n();
  }), c = s.stop, u = s.setLoadEvent, l = cm(r, o, function(S) {
    i.scroll = S;
  }).stop, f = Jv(r, e, function(S) {
    i.cumulativeLayoutShift = S, n();
  }).stop, p = tm(r, o, a, e), m = p.stop, g = p.getInteractionToNextPaint;
  return {
    stop: function() {
      c(), f(), l(), m();
    },
    setLoadEvent: u,
    getCommonViewMetrics: function() {
      return i.interactionToNextPaint = g(), i;
    }
  };
}
var fm = 3e3, pm = 5 * we, vm = 5 * we;
function mm(e, t, r, n, a, o, i) {
  var s = /* @__PURE__ */ new Set(), c = l("initial_load", Ii(), i);
  f();
  var u;
  o && (u = p(a));
  function l(m, g, S) {
    var x = hm(t, r, n, e, m, g, S);
    return s.add(x), x.stopObservable.subscribe(function() {
      s.delete(x);
    }), x;
  }
  function f() {
    t.subscribe(8, function() {
      c = l("route_change", void 0, {
        name: c.name,
        service: c.service,
        version: c.version
      });
    }), t.subscribe(7, function() {
      c.end({ sessionIsActive: !1 });
    }), t.subscribe(9, function(m) {
      (m.reason === _t.UNLOADING || m.reason === _t.PAGEHIDE) && c.end();
    });
  }
  function p(m) {
    return m.subscribe(function(g) {
      var S = g.oldLocation, x = g.newLocation;
      _m(S, x) && (c.end(), c = l(
        "route_change"
        /* ViewLoadingType.ROUTE_CHANGE */
      ));
    });
  }
  return {
    addTiming: function(m, g) {
      g === void 0 && (g = ue()), c.addTiming(m, g);
    },
    startView: function(m, g) {
      c.end({ endClocks: g }), c = l("route_change", g, m);
    },
    stop: function() {
      u == null || u.unsubscribe(), c.end(), s.forEach(function(m) {
        return m.stop();
      });
    }
  };
}
function hm(e, t, r, n, a, o, i) {
  o === void 0 && (o = Re());
  var s = Ae(), c = new te(), u = {}, l = 0, f, p = vr(n), m = !0, g, S, x;
  i && (g = i.name, S = i.service, x = i.version), e.notify(2, {
    id: s,
    name: g,
    startClocks: o,
    service: S,
    version: x
  });
  var P = tt(h, fm, {
    leading: !1
  }), T = P.throttled, F = P.cancel, M = dm(e, t, r, T, a, o), R = M.setLoadEvent, L = M.stop, j = M.getCommonViewMetrics, ne = a === "initial_load" ? Xv(e, r, R, T) : { stop: Q, initialViewMetrics: {} }, w = ne.stop, I = ne.initialViewMetrics, W = zv(e, s, T), me = W.stop, ke = W.eventCounts, y = _r(h, pm);
  h();
  function h() {
    F(), l += 1;
    var _ = f === void 0 ? ue() : f.timeStamp;
    e.notify(3, {
      customTimings: u,
      documentVersion: l,
      id: s,
      name: g,
      service: S,
      version: x,
      loadingType: a,
      location: p,
      startClocks: o,
      commonViewMetrics: j(),
      initialViewMetrics: I,
      duration: ye(o.timeStamp, _),
      isActive: f === void 0,
      sessionIsActive: m,
      eventCounts: ke
    });
  }
  return {
    name: g,
    service: S,
    version: x,
    stopObservable: c,
    end: function(_) {
      var b = this, A, C;
      _ === void 0 && (_ = {}), !f && (f = (A = _.endClocks) !== null && A !== void 0 ? A : Re(), m = (C = _.sessionIsActive) !== null && C !== void 0 ? C : !0, e.notify(4, { endClocks: f }), _a(y), L(), h(), pe(function() {
        b.stop();
      }, vm));
    },
    stop: function() {
      w(), me(), c.notify();
    },
    addTiming: function(_, b) {
      if (!f) {
        var A = cl(b) ? b : ye(o.timeStamp, b);
        u[gm(_)] = A, T();
      }
    }
  };
}
function gm(e) {
  var t = e.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
  return t !== e && H.warn("Invalid timing name: ".concat(e, ", sanitized to: ").concat(t)), t;
}
function _m(e, t) {
  return e.pathname !== t.pathname || !ym(t.hash) && Ho(t.hash) !== Ho(e.hash);
}
function ym(e) {
  var t = e.substr(1);
  return !!document.getElementById(t);
}
function Ho(e) {
  var t = e.indexOf("?");
  return t < 0 ? e : e.slice(0, t);
}
function Sm(e, t, r, n, a, o, i, s, c) {
  return e.subscribe(3, function(u) {
    return e.notify(10, bm(u, t, o, s, i));
  }), mm(r, e, n, t, a, !t.trackViewsManually, c);
}
function bm(e, t, r, n, a) {
  var o, i, s, c, u, l, f, p, m, g, S, x, P, T, F = n.getReplayStats(e.id), M = r.findFeatureFlagEvaluations(e.startClocks.relative), R = Ie(ve.PAGE_STATES), L = a.findAll(e.startClocks.relative, e.duration), j = {
    _dd: {
      document_version: e.documentVersion,
      replay_stats: F,
      page_states: R ? L : void 0
    },
    date: e.startClocks.timeStamp,
    type: "view",
    view: {
      action: {
        count: e.eventCounts.actionCount
      },
      frustration: {
        count: e.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (o = e.commonViewMetrics.cumulativeLayoutShift) === null || o === void 0 ? void 0 : o.value,
      cumulative_layout_shift_target_selector: (i = e.commonViewMetrics.cumulativeLayoutShift) === null || i === void 0 ? void 0 : i.targetSelector,
      first_byte: X((s = e.initialViewMetrics.navigationTimings) === null || s === void 0 ? void 0 : s.firstByte),
      dom_complete: X((c = e.initialViewMetrics.navigationTimings) === null || c === void 0 ? void 0 : c.domComplete),
      dom_content_loaded: X((u = e.initialViewMetrics.navigationTimings) === null || u === void 0 ? void 0 : u.domContentLoaded),
      dom_interactive: X((l = e.initialViewMetrics.navigationTimings) === null || l === void 0 ? void 0 : l.domInteractive),
      error: {
        count: e.eventCounts.errorCount
      },
      first_contentful_paint: X(e.initialViewMetrics.firstContentfulPaint),
      first_input_delay: X((f = e.initialViewMetrics.firstInput) === null || f === void 0 ? void 0 : f.delay),
      first_input_time: X((p = e.initialViewMetrics.firstInput) === null || p === void 0 ? void 0 : p.time),
      first_input_target_selector: (m = e.initialViewMetrics.firstInput) === null || m === void 0 ? void 0 : m.targetSelector,
      interaction_to_next_paint: X((g = e.commonViewMetrics.interactionToNextPaint) === null || g === void 0 ? void 0 : g.value),
      interaction_to_next_paint_target_selector: (S = e.commonViewMetrics.interactionToNextPaint) === null || S === void 0 ? void 0 : S.targetSelector,
      is_active: e.isActive,
      name: e.name,
      largest_contentful_paint: X((x = e.initialViewMetrics.largestContentfulPaint) === null || x === void 0 ? void 0 : x.value),
      largest_contentful_paint_target_selector: (P = e.initialViewMetrics.largestContentfulPaint) === null || P === void 0 ? void 0 : P.targetSelector,
      load_event: X((T = e.initialViewMetrics.navigationTimings) === null || T === void 0 ? void 0 : T.loadEvent),
      loading_time: wm(X(e.commonViewMetrics.loadingTime)),
      loading_type: e.loadingType,
      long_task: {
        count: e.eventCounts.longTaskCount
      },
      resource: {
        count: e.eventCounts.resourceCount
      },
      time_spent: X(e.duration),
      in_foreground_periods: !R && L ? Vv(L, e.duration) : void 0
      // Todo: Remove in the next major release
    },
    feature_flags: M && !Je(M) ? M : void 0,
    display: e.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: e.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: e.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: e.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: X(e.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : void 0,
    session: {
      has_replay: F ? !0 : void 0,
      is_active: e.sessionIsActive ? void 0 : !1
    },
    privacy: {
      replay_level: t.defaultPrivacyLevel
    }
  };
  return Je(e.customTimings) || (j.view.custom_timings = ml(e.customTimings, X)), {
    rawRumEvent: j,
    startTime: e.startClocks.relative,
    domainContext: {
      location: e.location
    }
  };
}
function wm(e) {
  return qt(e) && e < 0 ? void 0 : e;
}
var Am = "rum";
function Em(e, t) {
  var r = nf(e, Am, function(n) {
    return Rm(e, n);
  });
  return r.expireObservable.subscribe(function() {
    t.notify(
      7
      /* LifeCycleEventType.SESSION_EXPIRED */
    );
  }), r.renewObservable.subscribe(function() {
    t.notify(
      8
      /* LifeCycleEventType.SESSION_RENEWED */
    );
  }), {
    findTrackedSession: function(n) {
      var a = r.findActiveSession(n);
      if (!(!a || !Fs(a.trackingType))) {
        var o = a.trackingType === "1" ? 2 : 1;
        return {
          id: a.id,
          plan: o,
          sessionReplayAllowed: o === 2,
          longTaskAllowed: e.trackLongTasks !== void 0 ? e.trackLongTasks : e.oldPlansBehavior && o === 2,
          resourceAllowed: e.trackResources !== void 0 ? e.trackResources : e.oldPlansBehavior && o === 2
        };
      }
    },
    expire: r.expire,
    expireObservable: r.expireObservable
  };
}
function Tm() {
  var e = {
    id: "00000000-aaaa-0000-aaaa-000000000000",
    plan: 1,
    sessionReplayAllowed: !1,
    longTaskAllowed: !0,
    resourceAllowed: !0
  };
  return {
    findTrackedSession: function() {
      return e;
    },
    expire: Q,
    expireObservable: new te()
  };
}
function Rm(e, t) {
  var r;
  return Cm(t) ? r = t : zt(e.sessionSampleRate) ? zt(e.sessionReplaySampleRate) ? r = "1" : r = "2" : r = "0", {
    trackingType: r,
    isTracked: Fs(r)
  };
}
function Cm(e) {
  return e === "0" || e === "1" || e === "2";
}
function Fs(e) {
  return e === "2" || e === "1";
}
function Im(e, t, r, n, a, o) {
  var i = e.replica, s = Af(e, {
    endpoint: e.rumEndpointBuilder
  }, i && {
    endpoint: i.rumEndpointBuilder,
    transformMessage: function(c) {
      return Ge(c, { application: { id: i.applicationId } });
    }
  }, n, a, o);
  return t.subscribe(11, function(c) {
    c.type === "view" ? s.upsert(c, c.view.id) : s.add(c);
  }), r.subscribe(function(c) {
    return s.add(c, Xd(e));
  }), s;
}
function Om(e) {
  var t = Ta();
  e.subscribe(11, function(r) {
    t.send("rum", r);
  });
}
var xm = Yt;
function km(e, t, r) {
  var n = new Zt(xm), a;
  e.subscribe(4, function(s) {
    var c = s.endClocks;
    n.closeActive(c.relative);
  }), e.subscribe(2, function(s) {
    var c = s.startClocks, u = r.href;
    n.add(i({
      url: u,
      referrer: a || document.referrer
    }), c.relative), a = u;
  });
  var o = t.subscribe(function(s) {
    var c = s.newLocation, u = n.find();
    if (u) {
      var l = Oe();
      n.closeActive(l), n.add(i({
        url: c.href,
        referrer: u.referrer
      }), l);
    }
  });
  function i(s) {
    var c = s.url, u = s.referrer;
    return {
      url: c,
      referrer: u
    };
  }
  return {
    findUrl: function(s) {
      return n.find(s);
    },
    stop: function() {
      o.unsubscribe(), n.stop();
    }
  };
}
function Pm(e, t) {
  var r = vr(t), n = new te(function() {
    var o = Nm(e, a).stop, i = Lm(e, a).stop;
    return function() {
      o(), i();
    };
  });
  function a() {
    if (r.href !== t.href) {
      var o = vr(t);
      n.notify({
        newLocation: o,
        oldLocation: r
      }), r = o;
    }
  }
  return n;
}
function Nm(e, t) {
  var r = Te(history, "pushState", {
    after: t
  }).stop, n = Te(history, "replaceState", {
    after: t
  }).stop, a = oe(e, window, "popstate", t).stop;
  return {
    stop: function() {
      r(), n(), a();
    }
  };
}
function Lm(e, t) {
  return oe(e, window, "hashchange", t);
}
var Dm = Yt, Mm = 200;
function Um(e, t) {
  if (t === void 0 && (t = pr), !Ie(ve.FEATURE_FLAGS))
    return {
      findFeatureFlagEvaluations: function() {
      },
      getFeatureFlagBytesCount: function() {
        return 0;
      },
      addFeatureFlagEvaluation: Q,
      stop: Q
    };
  var r = new Zt(Dm), n = 0, a = !1;
  e.subscribe(4, function(c) {
    var u = c.endClocks;
    r.closeActive(u.relative);
  }), e.subscribe(2, function(c) {
    var u = c.startClocks;
    r.add({}, u.relative), n = 0;
  });
  var o = tt(function(c) {
    n = t(Et(c)), a || (a = is(
      n,
      0
      /* CustomerDataType.FeatureFlag */
    ));
  }, Mm), i = o.throttled, s = o.cancel;
  return {
    findFeatureFlagEvaluations: function(c) {
      return r.find(c);
    },
    getFeatureFlagBytesCount: function() {
      var c = r.find();
      return c ? n : 0;
    },
    addFeatureFlagEvaluation: function(c, u) {
      var l = r.find();
      l && (l[c] = u, i(l));
    },
    stop: s
  };
}
var Fm = 10 * _e, We, ht, ta;
function jm(e, t, r, n, a, o, i) {
  var s = t.enabled && zt(e.customerDataTelemetrySampleRate);
  s && (js(), Go(), r.subscribe(11, function(c) {
    ta = !0, ir(ht.globalContextBytes, Je(n.get()) ? 0 : n.getBytesCount()), ir(ht.userContextBytes, Je(a.get()) ? 0 : a.getBytesCount());
    var u = o.findFeatureFlagEvaluations(), l = Qe([
      "view",
      "error"
      /* RumEventType.ERROR */
    ], c.type) && u && !Je(u);
    ir(ht.featureFlagBytes, l ? o.getFeatureFlagBytesCount() : 0);
  }), i.subscribe(function(c) {
    var u = c.bytesCount, l = c.messagesCount;
    ta && (We.batchCount += 1, ir(We.batchBytesCount, u), ir(We.batchMessagesCount, l), Un(We.globalContextBytes, ht.globalContextBytes), Un(We.userContextBytes, ht.userContextBytes), Un(We.featureFlagBytes, ht.featureFlagBytes), Go());
  }), _r(Bm, Fm));
}
function Bm() {
  We.batchCount !== 0 && (Tt("Customer data measures", We), js());
}
function ct() {
  return { min: 1 / 0, max: 0, sum: 0 };
}
function ir(e, t) {
  e.sum += t, e.min = Math.min(e.min, t), e.max = Math.max(e.max, t);
}
function Un(e, t) {
  e.sum += t.sum, e.min = Math.min(e.min, t.min), e.max = Math.max(e.max, t.max);
}
function js() {
  We = {
    batchCount: 0,
    batchBytesCount: ct(),
    batchMessagesCount: ct(),
    globalContextBytes: ct(),
    userContextBytes: ct(),
    featureFlagBytes: ct()
  };
}
function Go() {
  ta = !1, ht = {
    globalContextBytes: ct(),
    userContextBytes: ct(),
    featureFlagBytes: ct()
  };
}
var Vm = 4e3, zm = 500, Hm = Yt;
function Gm(e, t) {
  t === void 0 && (t = zm);
  var r = new Zt(Hm, Vm), n;
  o(Bs(), Oe());
  var a = Se(e, window, [
    "pageshow",
    "focus",
    "blur",
    "visibilitychange",
    "resume",
    "freeze",
    "pagehide"
  ], function(i) {
    i.isTrusted && o($m(i), i.timeStamp);
  }, { capture: !0 }).stop;
  function o(i, s) {
    s === void 0 && (s = Oe()), i !== n && (n = i, r.closeActive(s), r.add({ state: n, startTime: s }, s));
  }
  return {
    findAll: function(i, s) {
      var c = r.findAll(i, s);
      if (c.length !== 0) {
        for (var u = [], l = Math.max(0, c.length - t), f = c.length - 1; f >= l; f--) {
          var p = c[f], m = ye(i, p.startTime);
          u.push({
            state: p.state,
            start: X(m)
          });
        }
        return u;
      }
    },
    isInActivePageStateAt: function(i) {
      var s = r.find(i);
      return s !== void 0 && s.state === "active";
    },
    addPageState: o,
    stop: function() {
      a(), r.stop();
    }
  };
}
function $m(e) {
  return e.type === "freeze" ? "frozen" : e.type === "pagehide" ? e.persisted ? "frozen" : "terminated" : Bs();
}
function Bs() {
  return document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
function qm(e) {
  var t = tn(), r = Us(e).subscribe(function(n) {
    t = n;
  }).unsubscribe;
  return {
    get: function() {
      return { viewport: t };
    },
    stop: r
  };
}
function Km(e, t, r, n, a, o) {
  var i = [], s = new Up();
  s.subscribe(11, function(y) {
    return ba("rum", y);
  });
  var c = Wm(t);
  c.setContextProvider(function() {
    var y, h;
    return {
      application: {
        id: t.applicationId
      },
      session: {
        id: (y = m.findTrackedSession()) === null || y === void 0 ? void 0 : y.id
      },
      view: {
        id: (h = T.findView()) === null || h === void 0 ? void 0 : h.id
      },
      action: {
        id: R.findActionId()
      }
    };
  });
  var u = function(y) {
    s.notify(12, { error: y }), Tt("Error reported to customer", { "error.message": y.message });
  }, l = Um(s), f = Sf(t), p = f.subscribe(function(y) {
    s.notify(9, y);
  });
  i.push(function() {
    return p.unsubscribe();
  });
  var m = $t() ? Tm() : Em(t, s);
  if ($t())
    Om(s);
  else {
    var g = Im(t, s, c.observable, u, f, m.expireObservable);
    i.push(function() {
      return g.stop();
    }), jm(t, c, s, n, a, l, g.flushObservable);
  }
  var S = cp(), x = Pm(t, location), P = Ym(s, t, location, m, x, S, function() {
    return Qn(n, a, r);
  }, u), T = P.viewContexts, F = P.pageStateHistory, M = P.urlContexts, R = P.actionContexts, L = P.addAction, j = P.stop;
  i.push(j), Jd(ip(e)), Pv(s, m), Dv(s, t, m, F);
  var ne = Sm(s, t, location, S, x, l, F, r, o), w = ne.addTiming, I = ne.startView, W = ne.stop;
  i.push(W);
  var me = Ov(s, t, F, l).addError;
  Bp(s, t, m), wp(s, t);
  var ke = Mp(t.applicationId, m, T, R, M);
  return {
    addAction: L,
    addError: me,
    addTiming: w,
    addFeatureFlagEvaluation: l.addFeatureFlagEvaluation,
    startView: I,
    lifeCycle: s,
    viewContexts: T,
    session: m,
    stopSession: function() {
      return m.expire();
    },
    getInternalContext: ke.get,
    stop: function() {
      i.forEach(function(y) {
        return y();
      });
    }
  };
}
function Wm(e) {
  var t = Wd("browser-rum-sdk", e);
  if ($t()) {
    var r = Ta();
    t.observable.subscribe(function(n) {
      return r.send("internal_telemetry", n);
    });
  }
  return t;
}
function Ym(e, t, r, n, a, o, i, s) {
  var c = jp(e), u = km(e, a, r), l = Gm(t), f = Rv(e, o, t, l), p = f.addAction, m = f.actionContexts, g = qm(t);
  return Np(t, e, n, c, u, m, g, i, s), {
    viewContexts: c,
    pageStateHistory: l,
    urlContexts: u,
    addAction: p,
    actionContexts: m,
    stop: function() {
      g.stop(), l.stop(), u.stop(), c.stop(), l.stop();
    }
  };
}
function Xm(e, t) {
  var r = t.session, n = t.viewContext, a = t.errorType, o = r ? r.id : "no-session-id", i = [];
  a !== void 0 && i.push("error-type=".concat(a)), n && (i.push("seed=".concat(n.id)), i.push("from=".concat(n.startClocks.timeStamp)));
  var s = Jm(e), c = "/rum/replay/sessions/".concat(o);
  return "".concat(s).concat(c, "?").concat(i.join("&"));
}
function Jm(e) {
  var t = e.site, r = e.subdomain || Zm(e);
  return "https://".concat(r ? "".concat(r, ".") : "").concat(t);
}
function Zm(e) {
  switch (e.site) {
    case Vt:
    case Jl:
      return "app";
    case zi:
      return "dd";
    default:
      return;
  }
}
var Ue = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
}, wt = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
}, Ye = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
}, Ne = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
}, $o = {
  Play: 0,
  Pause: 1
};
function it(e, t) {
  return {
    data: B({
      source: e
    }, t),
    type: Ue.IncrementalSnapshot,
    timestamp: ue()
  };
}
var U = {
  IGNORE: "ignore",
  HIDDEN: "hidden",
  ALLOW: lr.ALLOW,
  MASK: lr.MASK,
  MASK_USER_INPUT: lr.MASK_USER_INPUT
}, Da = "data-dd-privacy", Qm = "allow", eh = "mask", th = "mask-user-input", Vs = "hidden", rh = "dd-privacy-allow", nh = "dd-privacy-mask", ah = "dd-privacy-mask-user-input", oh = "dd-privacy-hidden", yt = "***", ih = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==", sh = {
  INPUT: !0,
  OUTPUT: !0,
  TEXTAREA: !0,
  SELECT: !0,
  OPTION: !0,
  DATALIST: !0,
  OPTGROUP: !0
}, ch = 1e5, uh = "x";
function rt(e, t) {
  var r = en(e), n = r ? rt(r, t) : t, a = Hs(e);
  return zs(a, n);
}
function zs(e, t) {
  switch (t) {
    case U.HIDDEN:
    case U.IGNORE:
      return t;
  }
  switch (e) {
    case U.ALLOW:
    case U.MASK:
    case U.MASK_USER_INPUT:
    case U.HIDDEN:
    case U.IGNORE:
      return e;
    default:
      return t;
  }
}
function Hs(e) {
  if (Qt(e)) {
    var t = e.getAttribute(Da);
    if (e.tagName === "BASE")
      return U.ALLOW;
    if (e.tagName === "INPUT") {
      var r = e;
      if (r.type === "password" || r.type === "email" || r.type === "tel" || r.type === "hidden")
        return U.MASK;
      var n = r.getAttribute("autocomplete");
      if (n && n.indexOf("cc-") === 0)
        return U.MASK;
    }
    if (t === Vs || e.classList.contains(oh))
      return U.HIDDEN;
    if (t === eh || e.classList.contains(nh))
      return U.MASK;
    if (t === th || e.classList.contains(ah))
      return U.MASK_USER_INPUT;
    if (t === Qm || e.classList.contains(rh))
      return U.ALLOW;
    if (dh(e))
      return U.IGNORE;
  }
}
function rn(e, t) {
  switch (t) {
    case U.MASK:
    case U.HIDDEN:
    case U.IGNORE:
      return !0;
    case U.MASK_USER_INPUT:
      return vs(e) ? qo(e.parentNode) : qo(e);
    default:
      return !1;
  }
}
function qo(e) {
  if (!e || e.nodeType !== e.ELEMENT_NODE)
    return !1;
  var t = e;
  if (t.tagName === "INPUT")
    switch (t.type) {
      case "button":
      case "color":
      case "reset":
      case "submit":
        return !1;
    }
  return !!sh[t.tagName];
}
var lh = function(e) {
  return e.replace(/\S/g, uh);
};
function Gs(e, t, r) {
  var n, a = (n = e.parentElement) === null || n === void 0 ? void 0 : n.tagName, o = e.textContent || "";
  if (!(t && !o.trim())) {
    var i = r, s = a === "SCRIPT";
    if (s)
      o = yt;
    else if (i === U.HIDDEN)
      o = yt;
    else if (rn(e, i))
      if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        a === "DATALIST" || a === "SELECT" || a === "OPTGROUP"
      ) {
        if (!o.trim())
          return;
      } else
        a === "OPTION" ? o = yt : o = lh(o);
    return o;
  }
}
function dh(e) {
  if (e.nodeName === "SCRIPT")
    return !0;
  if (e.nodeName === "LINK") {
    var t = a("rel");
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(t) && a("as") === "script" || // Favicons
      t === "shortcut icon" || t === "icon"
    );
  }
  if (e.nodeName === "META") {
    var r = a("name"), t = a("rel"), n = a("property");
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(r) || r === "application-name" || t === "icon" || t === "apple-touch-icon" || t === "shortcut icon" || // Description
      r === "keywords" || r === "description" || // Social
      /^(og|twitter|fb):/.test(n) || /^(og|twitter):/.test(r) || r === "pinterest" || // Robots
      r === "robots" || r === "googlebot" || r === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      e.hasAttribute("http-equiv") || // Authorship
      r === "author" || r === "generator" || r === "framework" || r === "publisher" || r === "progid" || /^article:/.test(n) || /^product:/.test(n) || // Verification
      r === "google-site-verification" || r === "yandex-verification" || r === "csrf-token" || r === "p:domain_verify" || r === "verify-v1" || r === "verification" || r === "shopify-checkout-api-token"
    );
  }
  function a(o) {
    return (e.getAttribute(o) || "").toLowerCase();
  }
  return !1;
}
var Ma = /* @__PURE__ */ new WeakMap();
function ze(e) {
  return Ma.has(e);
}
function fh(e) {
  for (var t = e; t; ) {
    if (!ze(t) && !xa(t))
      return !1;
    t = en(t);
  }
  return !0;
}
function ge(e) {
  return Ma.get(e);
}
function ph(e, t) {
  Ma.set(e, t);
}
function Ua(e, t) {
  var r = e.tagName, n = e.value;
  if (rn(e, t)) {
    var a = e.type;
    return r === "INPUT" && (a === "button" || a === "submit" || a === "reset") ? n : !n || r === "OPTION" ? void 0 : yt;
  }
  if (r === "OPTION" || r === "SELECT")
    return e.value;
  if (!(r !== "INPUT" && r !== "TEXTAREA"))
    return n;
}
var vh = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm, mh = /^[A-Za-z]+:|^\/\//, hh = /^data:.*,/i;
function gh(e, t) {
  return e.replace(vh, function(r, n, a, o, i, s) {
    var c = a || i || s;
    if (!t || !c || mh.test(c) || hh.test(c))
      return r;
    var u = n || o || "";
    return "url(".concat(u).concat(_h(c, t)).concat(u, ")");
  });
}
function _h(e, t) {
  try {
    return yr(e, t).href;
  } catch {
    return e;
  }
}
var yh = /[^a-z1-6-_]/;
function $s(e) {
  var t = e.toLowerCase().trim();
  return yh.test(t) ? "div" : t;
}
function qs(e) {
  if (!(e === void 0 || e.length === 0))
    return e.map(function(t) {
      var r = t.cssRules || t.rules, n = Array.from(r, function(o) {
        return o.cssText;
      }), a = {
        cssRules: n,
        disabled: t.disabled || void 0,
        media: t.media.length > 0 ? Array.from(t.media) : void 0
      };
      return a;
    });
}
function Ks(e, t, r, n) {
  if (t === U.HIDDEN)
    return null;
  var a = e.getAttribute(r);
  if (t === U.MASK && r !== Da && !Ts.includes(r) && r !== n.actionNameAttribute) {
    var o = e.tagName;
    switch (r) {
      case "title":
      case "alt":
      case "placeholder":
        return yt;
    }
    if ((o === "IMG" || o === "SOURCE") && (r === "src" || r === "srcset"))
      return ih;
    if (o === "A" && r === "href" || a && Jr(r, "data-"))
      return yt;
  }
  return !a || typeof a != "string" ? a : a.length > ch && a.slice(0, 5) === "data:" ? "data:truncated" : a;
}
function Sh(e, t, r) {
  var n;
  if (t === U.HIDDEN)
    return {};
  for (var a = {}, o = $s(e.tagName), i = e.ownerDocument, s = 0; s < e.attributes.length; s += 1) {
    var c = e.attributes.item(s), u = c.name, l = Ks(e, t, u, r.configuration);
    l !== null && (a[u] = l);
  }
  if (e.value && (o === "textarea" || o === "select" || o === "option" || o === "input")) {
    var f = Ua(e, t);
    f !== void 0 && (a.value = f);
  }
  if (o === "option" && t === U.ALLOW) {
    var p = e;
    p.selected && (a.selected = p.selected);
  }
  if (o === "link") {
    var m = Array.from(i.styleSheets).find(function(M) {
      return M.href === e.href;
    }), g = ra(m);
    g && m && !Ie(ve.DISABLE_REPLAY_INLINE_CSS) && (a._cssText = g);
  }
  if (o === "style" && e.sheet) {
    var g = ra(e.sheet);
    g && (a._cssText = g);
  }
  var S = e;
  if (o === "input" && (S.type === "radio" || S.type === "checkbox") && (t === U.ALLOW ? a.checked = !!S.checked : rn(S, t) && delete a.checked), o === "audio" || o === "video") {
    var x = e;
    a.rr_mediaState = x.paused ? "paused" : "played";
  }
  var P, T, F = r.serializationContext;
  switch (F.status) {
    case 0:
      P = Math.round(e.scrollTop), T = Math.round(e.scrollLeft), (P || T) && F.elementsScrollPositions.set(e, { scrollTop: P, scrollLeft: T });
      break;
    case 1:
      F.elementsScrollPositions.has(e) && (n = F.elementsScrollPositions.get(e), P = n.scrollTop, T = n.scrollLeft);
      break;
  }
  return T && (a.rr_scrollLeft = T), P && (a.rr_scrollTop = P), a;
}
function ra(e) {
  if (!e)
    return null;
  var t;
  try {
    t = e.rules || e.cssRules;
  } catch {
  }
  if (!t)
    return null;
  var r = Array.from(t, bl() ? bh : Ws).join("");
  return gh(r, e.href);
}
function bh(e) {
  if (Ah(e) && e.selectorText.includes(":")) {
    var t = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return e.cssText.replace(t, "$1\\$2");
  }
  return Ws(e);
}
function Ws(e) {
  return wh(e) && ra(e.styleSheet) || e.cssText;
}
function wh(e) {
  return "styleSheet" in e;
}
function Ah(e) {
  return "selectorText" in e;
}
function Fa(e, t) {
  var r = Rh(e, t);
  if (!r)
    return null;
  var n = ge(e) || Th(), a = r;
  return a.id = n, ph(e, n), t.serializedNodeIds && t.serializedNodeIds.add(n), a;
}
var Eh = 1;
function Th() {
  return Eh++;
}
function ja(e, t) {
  var r = [];
  return ms(e, function(n) {
    var a = Fa(n, t);
    a && r.push(a);
  }), r;
}
function Rh(e, t) {
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return Ch(e, t);
    case e.DOCUMENT_FRAGMENT_NODE:
      return Ih(e, t);
    case e.DOCUMENT_TYPE_NODE:
      return Oh(e);
    case e.ELEMENT_NODE:
      return xh(e, t);
    case e.TEXT_NODE:
      return Ph(e, t);
    case e.CDATA_SECTION_NODE:
      return Nh();
  }
}
function Ch(e, t) {
  return {
    type: wt.Document,
    childNodes: ja(e, t),
    adoptedStyleSheets: qs(e.adoptedStyleSheets)
  };
}
function Ih(e, t) {
  var r = xa(e);
  return r && t.serializationContext.shadowRootsController.addShadowRoot(e), {
    type: wt.DocumentFragment,
    childNodes: ja(e, t),
    isShadowRoot: r,
    adoptedStyleSheets: r ? qs(e.adoptedStyleSheets) : void 0
  };
}
function Oh(e) {
  return {
    type: wt.DocumentType,
    name: e.name,
    publicId: e.publicId,
    systemId: e.systemId
  };
}
function xh(e, t) {
  var r, n = $s(e.tagName), a = kh(e) || void 0, o = zs(Hs(e), t.parentNodePrivacyLevel);
  if (o === U.HIDDEN) {
    var i = e.getBoundingClientRect(), s = i.width, c = i.height;
    return {
      type: wt.Element,
      tagName: n,
      attributes: (r = {
        rr_width: "".concat(s, "px"),
        rr_height: "".concat(c, "px")
      }, r[Da] = Vs, r),
      childNodes: [],
      isSVG: a
    };
  }
  if (o !== U.IGNORE) {
    var u = Sh(e, o, t), l = [];
    if (hp(e) && // Do not serialize style children as the css rules are already in the _cssText attribute
    n !== "style") {
      var f = void 0;
      t.parentNodePrivacyLevel === o && t.ignoreWhiteSpace === (n === "head") ? f = t : f = B({}, t, {
        parentNodePrivacyLevel: o,
        ignoreWhiteSpace: n === "head"
      }), l = ja(e, f);
    }
    return {
      type: wt.Element,
      tagName: n,
      attributes: u,
      childNodes: l,
      isSVG: a
    };
  }
}
function kh(e) {
  return e.tagName === "svg" || e instanceof SVGElement;
}
function Ph(e, t) {
  var r = Gs(e, t.ignoreWhiteSpace || !1, t.parentNodePrivacyLevel);
  if (r !== void 0)
    return {
      type: wt.Text,
      textContent: r
    };
}
function Nh() {
  return {
    type: wt.CDATA,
    textContent: ""
  };
}
function Lh(e, t, r) {
  return Fa(e, {
    serializationContext: r,
    parentNodePrivacyLevel: t.defaultPrivacyLevel,
    configuration: t
  });
}
function Ys(e) {
  return !!e.changedTouches;
}
function wr(e) {
  return e.composed === !0 && Qr(e.target) ? e.composedPath()[0] : e.target;
}
var Ko = 25;
function Dh(e) {
  return Math.abs(e.pageTop - e.offsetTop - window.scrollY) > Ko || Math.abs(e.pageLeft - e.offsetLeft - window.scrollX) > Ko;
}
var Mh = function(e, t) {
  var r = window.visualViewport, n = {
    layoutViewportX: e,
    layoutViewportY: t,
    visualViewportX: e,
    visualViewportY: t
  };
  if (r)
    Dh(r) ? (n.layoutViewportX = Math.round(e + r.offsetLeft), n.layoutViewportY = Math.round(t + r.offsetTop)) : (n.visualViewportX = Math.round(e - r.offsetLeft), n.visualViewportY = Math.round(t - r.offsetTop));
  else
    return n;
  return n;
}, Xs = function(e) {
  return {
    scale: e.scale,
    offsetLeft: e.offsetLeft,
    offsetTop: e.offsetTop,
    pageLeft: e.pageLeft,
    pageTop: e.pageTop,
    height: e.height,
    width: e.width
  };
}, Uh = 50;
function Fh(e, t) {
  var r = tt(function(n) {
    var a = wr(n);
    if (ze(a)) {
      var o = Js(n);
      if (!o)
        return;
      var i = {
        id: ge(a),
        timeOffset: 0,
        x: o.x,
        y: o.y
      };
      t([i], Ys(n) ? Ye.TouchMove : Ye.MouseMove);
    }
  }, Uh, {
    trailing: !1
  }).throttled;
  return Se(e, document, [
    "mousemove",
    "touchmove"
    /* DOM_EVENT.TOUCH_MOVE */
  ], r, {
    capture: !0,
    passive: !0
  }).stop;
}
function Js(e) {
  var t = Ys(e) ? e.changedTouches[0] : e, r = t.clientX, n = t.clientY;
  if (window.visualViewport) {
    var a = Mh(r, n), o = a.visualViewportX, i = a.visualViewportY;
    r = o, n = i;
  }
  if (!Number.isFinite(r) || !Number.isFinite(n)) {
    e.isTrusted && Tt("mouse/touch event without x/y");
    return;
  }
  return { x: r, y: n };
}
var jh = 100;
function Bh(e, t, r, n) {
  var a = tt(function(o) {
    var i = wr(o);
    if (!(!i || rt(i, r) === U.HIDDEN || !ze(i))) {
      var s = ge(i), c = i === document ? {
        scrollTop: La(),
        scrollLeft: Ms()
      } : {
        scrollTop: Math.round(i.scrollTop),
        scrollLeft: Math.round(i.scrollLeft)
      };
      n.set(i, c), t({
        id: s,
        x: c.scrollLeft,
        y: c.scrollTop
      });
    }
  }, jh).throttled;
  return oe(e, document, "scroll", a, { capture: !0, passive: !0 }).stop;
}
var Pe, Wo = (Pe = {}, // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
Pe.pointerup = Ne.MouseUp, Pe.mousedown = Ne.MouseDown, Pe.click = Ne.Click, Pe.contextmenu = Ne.ContextMenu, Pe.dblclick = Ne.DblClick, Pe.focus = Ne.Focus, Pe.blur = Ne.Blur, Pe.touchstart = Ne.TouchStart, Pe.touchend = Ne.TouchEnd, Pe);
function Vh(e, t, r) {
  var n = function(a) {
    var o = wr(a);
    if (!(rt(o, e.defaultPrivacyLevel) === U.HIDDEN || !ze(o))) {
      var i = ge(o), s = Wo[a.type], c;
      if (s !== Ne.Blur && s !== Ne.Focus) {
        var u = Js(a);
        if (!u)
          return;
        c = { id: i, type: s, x: u.x, y: u.y };
      } else
        c = { id: i, type: s };
      var l = B({ id: r.getIdForEvent(a) }, it(Ye.MouseInteraction, c));
      t(l);
    }
  };
  return Se(e, document, Object.keys(Wo), n, {
    capture: !0,
    passive: !0
  }).stop;
}
function Zs(e, t, r) {
  r === void 0 && (r = document);
  var n = e.defaultPrivacyLevel, a = /* @__PURE__ */ new WeakMap(), o = r !== document, i = Se(
    e,
    r,
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    o ? [
      "change"
      /* DOM_EVENT.CHANGE */
    ] : [
      "input",
      "change"
      /* DOM_EVENT.CHANGE */
    ],
    function(f) {
      var p = wr(f);
      (p instanceof HTMLInputElement || p instanceof HTMLTextAreaElement || p instanceof HTMLSelectElement) && u(p);
    },
    {
      capture: !0,
      passive: !0
    }
  ).stop, s;
  if (o)
    s = Q;
  else {
    var c = [
      nr(HTMLInputElement.prototype, "value", u),
      nr(HTMLInputElement.prototype, "checked", u),
      nr(HTMLSelectElement.prototype, "value", u),
      nr(HTMLTextAreaElement.prototype, "value", u),
      nr(HTMLSelectElement.prototype, "selectedIndex", u)
    ];
    s = function() {
      c.forEach(function(f) {
        return f.stop();
      });
    };
  }
  return function() {
    s(), i();
  };
  function u(f) {
    var p = rt(f, n);
    if (p !== U.HIDDEN) {
      var m = f.type, g;
      if (m === "radio" || m === "checkbox") {
        if (rn(f, p))
          return;
        g = { isChecked: f.checked };
      } else {
        var S = Ua(f, p);
        if (S === void 0)
          return;
        g = { text: S };
      }
      l(f, g);
      var x = f.name;
      m === "radio" && x && f.checked && fl(document.querySelectorAll('input[type="radio"][name="'.concat(lt(x), '"]')), function(P) {
        P !== f && l(P, { isChecked: !1 });
      });
    }
  }
  function l(f, p) {
    if (ze(f)) {
      var m = a.get(f);
      (!m || m.text !== p.text || m.isChecked !== p.isChecked) && (a.set(f, p), t(B({
        id: ge(f)
      }, p)));
    }
  }
}
function zh(e) {
  function t(a, o) {
    a && ze(a.ownerNode) && o(ge(a.ownerNode));
  }
  var r = [
    Te(CSSStyleSheet.prototype, "insertRule", {
      before: function(a, o) {
        t(this, function(i) {
          return e({ id: i, adds: [{ rule: a, index: o }] });
        });
      }
    }),
    Te(CSSStyleSheet.prototype, "deleteRule", {
      before: function(a) {
        t(this, function(o) {
          return e({ id: o, removes: [{ index: a }] });
        });
      }
    })
  ];
  typeof CSSGroupingRule < "u" ? n(CSSGroupingRule) : (n(CSSMediaRule), n(CSSSupportsRule));
  function n(a) {
    r.push(Te(a.prototype, "insertRule", {
      before: function(o, i) {
        var s = this;
        t(this.parentStyleSheet, function(c) {
          var u = Yo(s);
          u && (u.push(i || 0), e({ id: c, adds: [{ rule: o, index: u }] }));
        });
      }
    }), Te(a.prototype, "deleteRule", {
      before: function(o) {
        var i = this;
        t(this.parentStyleSheet, function(s) {
          var c = Yo(i);
          c && (c.push(o), e({ id: s, removes: [{ index: c }] }));
        });
      }
    }));
  }
  return function() {
    return r.forEach(function(a) {
      return a.stop();
    });
  };
}
function Yo(e) {
  for (var t = [], r = e; r.parentRule; ) {
    var n = Array.from(r.parentRule.cssRules), a = n.indexOf(r);
    t.unshift(a), r = r.parentRule;
  }
  if (r.parentStyleSheet) {
    var o = Array.from(r.parentStyleSheet.cssRules), i = o.indexOf(r);
    return t.unshift(i), t;
  }
}
function Hh(e, t, r) {
  return Se(e, document, [
    "play",
    "pause"
    /* DOM_EVENT.PAUSE */
  ], function(n) {
    var a = wr(n);
    !a || rt(a, r) === U.HIDDEN || !ze(a) || t({
      id: ge(a),
      type: n.type === "play" ? $o.Play : $o.Pause
    });
  }, {
    capture: !0,
    passive: !0
  }).stop;
}
function Gh(e, t, r) {
  return e.subscribe(10, function(n) {
    var a, o, i;
    n.rawRumEvent.type === "action" && n.rawRumEvent.action.type === "click" && (!((o = (a = n.rawRumEvent.action.frustration) === null || a === void 0 ? void 0 : a.type) === null || o === void 0) && o.length) && "events" in n.domainContext && (!((i = n.domainContext.events) === null || i === void 0) && i.length) && t({
      timestamp: n.rawRumEvent.date,
      type: Ue.FrustrationRecord,
      data: {
        frustrationTypes: n.rawRumEvent.action.frustration.type,
        recordIds: n.domainContext.events.map(function(s) {
          return r.getIdForEvent(s);
        })
      }
    });
  }).unsubscribe;
}
var $h = 200;
function qh(e, t) {
  return Us(e).subscribe(t).unsubscribe;
}
function Kh(e, t) {
  var r = window.visualViewport;
  if (!r)
    return Q;
  var n = tt(function() {
    t(Xs(r));
  }, $h, {
    trailing: !1
  }), a = n.throttled, o = n.cancel, i = Se(e, r, [
    "resize",
    "scroll"
    /* DOM_EVENT.SCROLL */
  ], a, {
    capture: !0,
    passive: !0
  }).stop;
  return function() {
    i(), o();
  };
}
var Wh = 100;
function Yh(e) {
  var t = Q, r = [];
  function n() {
    t(), e(r), r = [];
  }
  return {
    addMutations: function(a) {
      r.length === 0 && (t = Xh(n, { timeout: Wh })), r.push.apply(r, a);
    },
    flush: n,
    stop: function() {
      t();
    }
  };
}
function Xh(e, t) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var r = window.requestIdleCallback(D(e), t);
    return function() {
      return window.cancelIdleCallback(r);
    };
  }
  var n = window.requestAnimationFrame(D(e));
  return function() {
    return window.cancelAnimationFrame(n);
  };
}
function Qs(e, t, r, n) {
  var a = ls();
  if (!a)
    return { stop: Q, flush: Q };
  var o = Yh(function(s) {
    Jh(s.concat(i.takeRecords()), e, t, r);
  }), i = new a(D(o.addMutations));
  return i.observe(n, {
    attributeOldValue: !0,
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), {
    stop: function() {
      i.disconnect(), o.stop();
    },
    flush: function() {
      o.flush();
    }
  };
}
function Jh(e, t, r, n) {
  e.filter(function(f) {
    return f.type === "childList";
  }).forEach(function(f) {
    f.removedNodes.forEach(function(p) {
      ec(p, n.removeShadowRoot);
    });
  });
  var a = e.filter(function(f) {
    return f.target.isConnected && fh(f.target) && rt(f.target, r.defaultPrivacyLevel) !== U.HIDDEN;
  }), o = Zh(a.filter(function(f) {
    return f.type === "childList";
  }), r, n), i = o.adds, s = o.removes, c = o.hasBeenSerialized, u = Qh(a.filter(function(f) {
    return f.type === "characterData" && !c(f.target);
  }), r), l = eg(a.filter(function(f) {
    return f.type === "attributes" && !c(f.target);
  }), r);
  !u.length && !l.length && !s.length && !i.length || t({
    adds: i,
    removes: s,
    texts: u,
    attributes: l
  });
}
function Zh(e, t, r) {
  for (var n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map(), o = function(R) {
    R.addedNodes.forEach(function(L) {
      n.add(L);
    }), R.removedNodes.forEach(function(L) {
      n.has(L) || a.set(L, R.target), n.delete(L);
    });
  }, i = 0, s = e; i < s.length; i++) {
    var c = s[i];
    o(c);
  }
  var u = Array.from(n);
  tg(u);
  for (var l = /* @__PURE__ */ new Set(), f = [], p = 0, m = u; p < m.length; p++) {
    var g = m[p];
    if (!F(g)) {
      var S = rt(g.parentNode, t.defaultPrivacyLevel);
      if (!(S === U.HIDDEN || S === U.IGNORE)) {
        var x = Fa(g, {
          serializedNodeIds: l,
          parentNodePrivacyLevel: S,
          serializationContext: { status: 2, shadowRootsController: r },
          configuration: t
        });
        if (x) {
          var P = en(g);
          f.push({
            nextId: M(g),
            parentId: ge(P),
            node: x
          });
        }
      }
    }
  }
  var T = [];
  return a.forEach(function(R, L) {
    ze(L) && T.push({
      parentId: ge(R),
      id: ge(L)
    });
  }), { adds: f, removes: T, hasBeenSerialized: F };
  function F(R) {
    return ze(R) && l.has(ge(R));
  }
  function M(R) {
    for (var L = R.nextSibling; L; ) {
      if (ze(L))
        return ge(L);
      L = L.nextSibling;
    }
    return null;
  }
}
function Qh(e, t) {
  for (var r, n = [], a = /* @__PURE__ */ new Set(), o = e.filter(function(f) {
    return a.has(f.target) ? !1 : (a.add(f.target), !0);
  }), i = 0, s = o; i < s.length; i++) {
    var c = s[i], u = c.target.textContent;
    if (u !== c.oldValue) {
      var l = rt(en(c.target), t.defaultPrivacyLevel);
      l === U.HIDDEN || l === U.IGNORE || n.push({
        id: ge(c.target),
        // TODO: pass a valid "ignoreWhiteSpace" argument
        value: (r = Gs(c.target, !1, l)) !== null && r !== void 0 ? r : null
      });
    }
  }
  return n;
}
function eg(e, t) {
  for (var r = [], n = /* @__PURE__ */ new Map(), a = e.filter(function(S) {
    var x = n.get(S.target);
    return x != null && x.has(S.attributeName) ? !1 : (x ? x.add(S.attributeName) : n.set(S.target, /* @__PURE__ */ new Set([S.attributeName])), !0);
  }), o = /* @__PURE__ */ new Map(), i = 0, s = a; i < s.length; i++) {
    var c = s[i], u = c.target.getAttribute(c.attributeName);
    if (u !== c.oldValue) {
      var l = rt(c.target, t.defaultPrivacyLevel), f = Ks(c.target, l, c.attributeName, t), p = void 0;
      if (c.attributeName === "value") {
        var m = Ua(c.target, l);
        if (m === void 0)
          continue;
        p = m;
      } else
        typeof f == "string" ? p = f : p = null;
      var g = o.get(c.target);
      g || (g = {
        id: ge(c.target),
        attributes: {}
      }, r.push(g), o.set(c.target, g)), g.attributes[c.attributeName] = p;
    }
  }
  return r;
}
function tg(e) {
  e.sort(function(t, r) {
    var n = t.compareDocumentPosition(r);
    return n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_CONTAINS || n & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : n & Node.DOCUMENT_POSITION_PRECEDING ? -1 : 0;
  });
}
function ec(e, t) {
  Qr(e) && t(e.shadowRoot), ms(e, function(r) {
    return ec(r, t);
  });
}
function rg(e, t) {
  return Se(e, window, [
    "focus",
    "blur"
    /* DOM_EVENT.BLUR */
  ], function() {
    t({ has_focus: document.hasFocus() });
  }).stop;
}
function ng() {
  var e = /* @__PURE__ */ new WeakMap(), t = 1;
  return {
    getIdForEvent: function(r) {
      return e.has(r) || e.set(r, t++), e.get(r);
    }
  };
}
function ag(e, t) {
  var r = ng(), n = Qs(t.mutationCb, t.configuration, t.shadowRootsController, document), a = Fh(e, t.mousemoveCb), o = Vh(e, t.mouseInteractionCb, r), i = Bh(e, t.scrollCb, t.configuration.defaultPrivacyLevel, t.elementsScrollPositions), s = qh(e, t.viewportResizeCb), c = Zs(e, t.inputCb), u = Hh(e, t.mediaInteractionCb, t.configuration.defaultPrivacyLevel), l = zh(t.styleSheetCb), f = rg(e, t.focusCb), p = Kh(e, t.visualViewportResizeCb), m = Gh(t.lifeCycle, t.frustrationCb, r);
  return {
    flush: function() {
      n.flush();
    },
    stop: function() {
      n.stop(), a(), o(), i(), s(), c(), u(), l(), f(), p(), m();
    }
  };
}
function og() {
  var e = /* @__PURE__ */ new WeakMap();
  return {
    set: function(t, r) {
      t === document && !document.scrollingElement || e.set(t === document ? document.scrollingElement : t, r);
    },
    get: function(t) {
      return e.get(t);
    },
    has: function(t) {
      return e.has(t);
    }
  };
}
var ig = function(e, t) {
  var r = t.mutationCb, n = t.inputCb, a = /* @__PURE__ */ new Map(), o = {
    addShadowRoot: function(i) {
      var s = Qs(r, e, o, i), c = s.stop, u = s.flush, l = Zs(e, n, i);
      a.set(i, {
        flush: u,
        stop: function() {
          c(), l();
        }
      });
    },
    removeShadowRoot: function(i) {
      var s = a.get(i);
      s && (s.stop(), a.delete(i));
    },
    stop: function() {
      a.forEach(function(i) {
        var s = i.stop;
        return s();
      });
    },
    flush: function() {
      a.forEach(function(i) {
        var s = i.flush;
        return s();
      });
    }
  };
  return o;
};
function sg(e) {
  var t = e.emit, r = e.configuration;
  if (!t)
    throw new Error("emit function is required");
  var n = og(), a = function(p) {
    t(it(Ye.Mutation, p));
  }, o = function(p) {
    return t(it(Ye.Input, p));
  }, i = ig(r, { mutationCb: a, inputCb: o }), s = function(p, m) {
    p === void 0 && (p = ue()), m === void 0 && (m = {
      status: 0,
      elementsScrollPositions: n,
      shadowRootsController: i
    });
    var g = tn(), S = g.width, x = g.height;
    t({
      data: {
        height: x,
        href: window.location.href,
        width: S
      },
      type: Ue.Meta,
      timestamp: p
    }), t({
      data: {
        has_focus: document.hasFocus()
      },
      type: Ue.Focus,
      timestamp: p
    }), t({
      data: {
        node: Lh(document, r, m),
        initialOffset: {
          left: Ms(),
          top: La()
        }
      },
      type: Ue.FullSnapshot,
      timestamp: p
    }), window.visualViewport && t({
      data: Xs(window.visualViewport),
      type: Ue.VisualViewport,
      timestamp: p
    });
  };
  s();
  var c = ag(r, {
    lifeCycle: e.lifeCycle,
    configuration: r,
    elementsScrollPositions: n,
    inputCb: o,
    mediaInteractionCb: function(p) {
      return t(it(Ye.MediaInteraction, p));
    },
    mouseInteractionCb: function(p) {
      return t(p);
    },
    mousemoveCb: function(p, m) {
      return t(it(m, { positions: p }));
    },
    mutationCb: a,
    scrollCb: function(p) {
      return t(it(Ye.Scroll, p));
    },
    styleSheetCb: function(p) {
      return t(it(Ye.StyleSheetRule, p));
    },
    viewportResizeCb: function(p) {
      return t(it(Ye.ViewportResize, p));
    },
    frustrationCb: function(p) {
      return t(p);
    },
    focusCb: function(p) {
      return t({
        data: p,
        type: Ue.Focus,
        timestamp: ue()
      });
    },
    visualViewportResizeCb: function(p) {
      t({
        data: p,
        type: Ue.VisualViewport,
        timestamp: ue()
      });
    },
    shadowRootsController: i
  }), u = c.stop, l = c.flush;
  function f() {
    i.flush(), l();
  }
  return {
    stop: function() {
      i.stop(), u();
    },
    takeSubsequentFullSnapshot: function(p) {
      f(), s(p, {
        shadowRootsController: i,
        status: 1,
        elementsScrollPositions: n
      });
    },
    flushMutations: f,
    shadowRootsController: i
  };
}
function cg(e, t, r) {
  var n = new FormData();
  n.append("segment", new Blob([e], {
    type: "application/octet-stream"
  }), "".concat(t.session.id, "-").concat(t.start));
  var a = B({
    raw_segment_size: r,
    compressed_segment_size: e.byteLength
  }, t), o = JSON.stringify(a);
  return n.append("event", new Blob([o], { type: "application/json" })), { data: n, bytesCount: e.byteLength };
}
var ug = 10, fe;
function lg(e) {
  return nn(e).segments_count;
}
function dg(e) {
  nn(e).segments_count += 1;
}
function fg(e) {
  nn(e).records_count += 1;
}
function pg(e, t) {
  nn(e).segments_total_raw_size += t;
}
function vg(e) {
  return fe == null ? void 0 : fe.get(e);
}
function nn(e) {
  fe || (fe = /* @__PURE__ */ new Map());
  var t;
  return fe.has(e) ? t = fe.get(e) : (t = {
    records_count: 0,
    segments_count: 0,
    segments_total_raw_size: 0
  }, fe.set(e, t), fe.size > ug && mg()), t;
}
function mg() {
  if (fe)
    if (fe.keys)
      fe.delete(fe.keys().next().value);
    else {
      var e = !0;
      fe.forEach(function(t, r) {
        e && (fe.delete(r), e = !1);
      });
    }
}
var hg = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.encoder = t;
      var a = r.view.id;
      this.metadata = B({
        start: 1 / 0,
        end: -1 / 0,
        creation_reason: n,
        records_count: 0,
        has_full_snapshot: !1,
        index_in_view: lg(a),
        source: "browser"
      }, r), dg(a);
    }
    return e.prototype.addRecord = function(t, r) {
      var n;
      this.metadata.start = Math.min(this.metadata.start, t.timestamp), this.metadata.end = Math.max(this.metadata.end, t.timestamp), this.metadata.records_count += 1, (n = this.metadata).has_full_snapshot || (n.has_full_snapshot = t.type === Ue.FullSnapshot), ba("record", { record: t, segment: this.metadata }), fg(this.metadata.view.id);
      var a = this.metadata.records_count === 1 ? '{"records":[' : ",";
      this.encoder.write(a + JSON.stringify(t), r);
    }, e.prototype.flush = function(t) {
      var r = this;
      if (this.metadata.records_count === 0)
        throw new Error("Empty segment flushed");
      this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), `
`), function() {
        pg(r.metadata.view.id, r.encoder.rawBytesCount), t(r.metadata);
      }), this.encoder.reset();
    }, e;
  }()
), gg = 30 * _e, tc = 6e4;
function _g(e, t, r, n, a, o) {
  return yg(e, function() {
    return Sg(t.applicationId, r, n);
  }, a, o);
}
function yg(e, t, r, n) {
  var a = {
    status: 0,
    nextSegmentCreationReason: "init"
  }, o = e.subscribe(2, function() {
    s("view_change");
  }).unsubscribe, i = e.subscribe(9, function(c) {
    s(c.reason);
  }).unsubscribe;
  function s(c) {
    a.status === 1 && (a.segment.flush(function(u) {
      var l = cg(n.encodedBytes, u, n.rawBytesCount);
      os(c) ? r.sendOnExit(l) : r.send(l);
    }), je(a.expirationTimeoutId)), c !== "stop" ? a = {
      status: 0,
      nextSegmentCreationReason: c
    } : a = {
      status: 2
    };
  }
  return {
    addRecord: function(c) {
      if (a.status !== 2) {
        if (a.status === 0) {
          var u = t();
          if (!u)
            return;
          a = {
            status: 1,
            segment: new hg(n, u, a.nextSegmentCreationReason),
            expirationTimeoutId: pe(function() {
              s("segment_duration_limit");
            }, gg)
          };
        }
        var l = a.segment;
        l.addRecord(c, function() {
          // the written segment is still pending
          a.status === 1 && a.segment === l && n.encodedBytesCount > tc && s("segment_bytes_limit");
        });
      }
    },
    stop: function() {
      s("stop"), o(), i();
    }
  };
}
function Sg(e, t, r) {
  var n = t.findTrackedSession(), a = r.findView();
  if (!(!n || !a))
    return {
      application: {
        id: e
      },
      session: {
        id: n.id
      },
      view: {
        id: a.id
      }
    };
}
function bg(e, t, r, n, a, o) {
  var i = function(P) {
    e.notify(12, { error: P }), Tt("Error reported to customer", { "error.message": P.message });
  }, s = o || as(t, t.sessionReplayEndpointBuilder, tc, i), c = _g(e, t, r, n, s, a), u = c.addRecord, l = c.stop, f = sg({
    emit: u,
    configuration: t,
    lifeCycle: e
  }), p = f.stop, m = f.takeSubsequentFullSnapshot, g = f.flushMutations, S = e.subscribe(4, function() {
    g(), u({
      timestamp: ue(),
      type: Ue.ViewEnd
    });
  }).unsubscribe, x = e.subscribe(2, function(P) {
    m(P.startClocks.timeStamp);
  }).unsubscribe;
  return {
    stop: function() {
      S(), x(), p(), l();
    }
  };
}
function rc() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from == "function" && typeof CSSSupportsRule == "function" && typeof URL.createObjectURL == "function" && "forEach" in NodeList.prototype
  );
}
function wg(e, t, r, n) {
  var a = t.findTrackedSession(), o = Ag(a, n), i = r.findView();
  return Xm(e, {
    viewContext: i,
    errorType: o,
    session: a
  });
}
function Ag(e, t) {
  if (!rc())
    return "browser-not-supported";
  if (!e)
    return "rum-not-tracked";
  if (!e.sessionReplayAllowed)
    return "incorrect-session-plan";
  if (!t)
    return "replay-not-started";
}
function Eg(e, t, r) {
  var n = 0, a = [], o, i = 0, s = [], c = oe(e, t, "message", function(u) {
    var l = u.data;
    if (!(l.type !== "wrote" || l.streamId !== r)) {
      var f = s.shift();
      f && f.id === l.id ? (l.id === 0 ? (n = l.additionalBytesCount, a = [l.result]) : (n += l.additionalBytesCount, a.push(l.result)), o = l.trailer, f.callback()) : (c(), Tt("Worker responses received out of order."));
    }
  }).stop;
  return {
    get encodedBytes() {
      return a.length ? ll(a.concat(o)) : new Uint8Array(0);
    },
    get encodedBytesCount() {
      return a.length ? a.reduce(function(u, l) {
        return u + l.length;
      }, 0) + o.length : 0;
    },
    get rawBytesCount() {
      return n;
    },
    write: function(u, l) {
      t.postMessage({
        action: "write",
        id: i,
        data: u,
        streamId: r
      }), s.push({
        id: i,
        callback: l
      }), i += 1;
    },
    reset: function() {
      t.postMessage({
        action: "reset",
        streamId: r
      }), i = 0;
    },
    stop: function() {
      c();
    }
  };
}
var Tg = 10 * _e;
function nc(e) {
  return new Worker(e.workerUrl || URL.createObjectURL(new Blob(['!function(){"use strict";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:"pako deflate (from Nodeca project)"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a="[object ArrayBuffer]"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,"[object ArrayBuffer]"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener("message",(function(n){try{var r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"4.50.1"};case"write":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();'])));
}
var re = {
  status: 0
  /* DeflateWorkerStatus.Nil */
};
function Rg(e, t, r, n) {
  switch (n === void 0 && (n = nc), re.status === 0 && Cg(e, t, n), re.status) {
    case 1:
      return re.initializationFailureCallbacks.push(r), re.worker;
    case 3:
      return re.worker;
  }
}
function Xo() {
  return re.status;
}
function Cg(e, t, r) {
  r === void 0 && (r = nc);
  try {
    var n = r(e), a = oe(e, n, "error", function(s) {
      Fn(e, t, s);
    }).stop, o = oe(e, n, "message", function(s) {
      var c = s.data;
      c.type === "errored" ? Fn(e, t, c.error, c.streamId) : c.type === "initialized" && Og(c.version);
    }).stop;
    n.postMessage({ action: "init" }), pe(function() {
      return Ig(t);
    }, Tg);
    var i = function() {
      a(), o();
    };
    re = { status: 1, worker: n, stop: i, initializationFailureCallbacks: [] };
  } catch (s) {
    Fn(e, t, s);
  }
}
function Ig(e) {
  re.status === 1 && (H.error("".concat(e, " failed to start: a timeout occurred while initializing the Worker")), re.initializationFailureCallbacks.forEach(function(t) {
    return t();
  }), re = {
    status: 2
    /* DeflateWorkerStatus.Error */
  });
}
function Og(e) {
  re.status === 1 && (re = { status: 3, worker: re.worker, stop: re.stop, version: e });
}
function Fn(e, t, r, n) {
  if (re.status === 1 || re.status === 0) {
    if (H.error("".concat(t, " failed to start: an error occurred while creating the Worker:"), r), r instanceof Event || r instanceof Error && xg(r.message)) {
      var a = void 0;
      e.workerUrl ? a = "Please make sure the Worker URL ".concat(e.workerUrl, " is correct and CSP is correctly configured.") : a = "Please make sure CSP is correctly configured.", H.error("".concat(a, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else
      zr(r);
    re.status === 1 && re.initializationFailureCallbacks.forEach(function(o) {
      return o();
    }), re = {
      status: 2
      /* DeflateWorkerStatus.Error */
    };
  } else
    zr(r, {
      worker_version: re.status === 3 && re.version,
      stream_id: n
    });
}
function xg(e) {
  return Qe(e, "Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  Qe(e, "requires 'TrustedScriptURL'");
}
function kg(e, t) {
  if ($t() || !rc())
    return {
      start: Q,
      stop: Q,
      getReplayStats: function() {
      },
      onRumStart: Q,
      isRecording: function() {
        return !1;
      },
      getSessionReplayLink: function() {
      }
    };
  var r = {
    status: 0
  }, n = function() {
    r = {
      status: 1
      /* RecorderStatus.IntentToStart */
    };
  }, a = function() {
    r = {
      status: 0
      /* RecorderStatus.Stopped */
    };
  };
  return {
    start: function() {
      return n();
    },
    stop: function() {
      return a();
    },
    getSessionReplayLink: function(o, i, s) {
      return wg(
        o,
        i,
        s,
        r.status !== 0
        /* RecorderStatus.Stopped */
      );
    },
    onRumStart: function(o, i, s, c) {
      o.subscribe(7, function() {
        (r.status === 2 || r.status === 3) && (a(), r = {
          status: 1
          /* RecorderStatus.IntentToStart */
        });
      }), o.subscribe(8, function() {
        r.status === 1 && n();
      }), n = function() {
        var u = s.findTrackedSession();
        if (!u || !u.sessionReplayAllowed) {
          r = {
            status: 1
            /* RecorderStatus.IntentToStart */
          };
          return;
        }
        r.status === 2 || r.status === 3 || (r = {
          status: 2
          /* RecorderStatus.Starting */
        }, Ra(i, "interactive", function() {
          if (r.status === 2) {
            var l = Rg(i, "Datadog Session Replay", function() {
              a();
            }, t);
            if (!l) {
              r = {
                status: 0
              };
              return;
            }
            var f = e(o, i, s, c, Eg(
              i,
              l,
              1
              /* DeflateEncoderStreamId.REPLAY */
            )).stop;
            r = {
              status: 3,
              stopRecording: f
            };
          }
        }));
      }, a = function() {
        r.status !== 0 && (r.status === 3 && r.stopRecording(), r = {
          status: 0
        });
      }, r.status === 1 && n();
    },
    isRecording: function() {
      return Xo() === 3 && r.status === 3;
    },
    getReplayStats: function(o) {
      return Xo() === 3 ? vg(o) : void 0;
    }
  };
}
var Pg = kg(bg), Ze = sp(Km, Pg);
jd(pt(), "DD_RUM", Ze);
var ac = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const Jo = pa("SSO_ENDPOINT"), oc = pa("REDSEA_CLIENT_ID"), an = ac.VITE_APP_USE_LOCAL === "true" ? Jo.replace("https", "http") : Jo, jn = `${an}/redsea/oauth2/authorize`, Zo = `${an}/redsea/oauth2/token`, Ng = `${an}/redsea/logout`, Lg = `${an}/signout`;
let De = `${ac.VITE_APP_USE_LOCAL === "true" ? "http" : "https"}://${window.location.host}/auth-callback`;
function ic(e) {
  return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function Dg() {
  const r = Fr.lib.WordArray.random(32).toString(Fr.enc.Base64);
  return ic(r);
}
function Mg(e) {
  const r = Fr.SHA256(e).toString(Fr.enc.Base64);
  return ic(r);
}
function Ug(e) {
  return e || fa.windowPathnameAndSearchString();
}
function sc(e, t = !0) {
  let r = sessionStorage.getItem("codeVerifier");
  t && r ? console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] codeVerifier already exists; prevented duplicate codeVerifier generation ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ) : (console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] generating code verifier ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ), window.codeVerifierCount > 1 && console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] window.codeVerifierCount is over 1 ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ), console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] before generating code verifier ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  ), r = Dg(), console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] after generating code verifier ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  ), window.codeVerifierCount === void 0 ? (window.codeVerifierCount = 1, console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] window.codeVerifierCount is not defined, setting to 1  ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  )) : (window.codeVerifierCount += 1, console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] window.codeVerifierCount adding to count window.codeVerifierCount: ${window.codeVerifierCount}  ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ))), console.error(
    `[DEBUG-AUTH (volt-amc-container) - generateOauthParams] setting codeVerifier value in sessionStorage ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  ), sessionStorage.setItem("codeVerifier", r);
  const n = Mg(r);
  return {
    client_id: oc,
    code_challenge: n,
    code_challenge_method: "S256",
    redirect_uri: De,
    response_type: "code",
    state: Ug(e)
  };
}
let dr = 1e3;
function Fg(e) {
  dr = e;
}
function jg() {
  dr = 1e3;
}
let at = null;
function cc(e, t = "") {
  if (console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] authorized from ${t} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  ), at === null)
    at = /* @__PURE__ */ new Date(), console.error(
      `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] authorize function called for first time lastRunTimestamp:${at.toISOString()} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
    );
  else if (at instanceof Date) {
    const a = /* @__PURE__ */ new Date();
    if (a - at < dr) {
      console.error(
        `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] authorize function called within waitPeriodInMs waitPeriodInMs:${dr} lastRunTimestamp:${at.toISOString()} currentTs:${a.toISOString()} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
      );
      return;
    } else
      console.error(
        `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] authorize function called after waitPeriodInMs waitPeriodInMs:${dr} lastRunTimestamp:${at.toISOString()} currentTs:${a.toISOString()} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
      ), at = /* @__PURE__ */ new Date();
  }
  const r = sc(e), n = fa.convertObjectToSearch(r);
  window.localStorage.removeItem("webToken"), console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] before redirecting to redseaAuthBaseUrl: ${jn} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  ), window.location.href = jn + n, console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] after redirecting to redseaAuthBaseUrl: ${jn} ts: ${(/* @__PURE__ */ new Date()).toISOString()}`
  );
}
async function Bg(e) {
  const t = Du();
  Ze.addAction("starting exchangeAuthCode", {
    ts: (/* @__PURE__ */ new Date()).toISOString(),
    datadogTrackingUuid: t
  }), console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] starting exchangeAuthCode ts:${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}`
  );
  const r = sessionStorage.getItem("codeVerifier");
  if (r === null)
    return console.error(
      `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] codeVerifier is null ts: ${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}, redirectUri: ${De}`
    ), Ze.addError(new Error("codeVerifier is null in exchangeAuthCode"), {
      ts: (/* @__PURE__ */ new Date()).toISOString(),
      datadogTrackingUuid: t,
      redirectUri: De
    }), console.error(
      `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] codeVerifier is null, reauthorizing ts: ${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}, redirectUri: ${De}`
    ), cc("/", "exchange-auth-code-code-verifier-null"), !1;
  const n = {
    client_id: oc,
    code: e,
    code_verifier: r,
    grant_type: "authorization_code",
    redirect_uri: De
  }, a = fa.convertObjectToQuery(n), o = {
    "content-type": "application/x-www-form-urlencoded"
  };
  console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] starting request to exchange auth code for access token ts: ${(/* @__PURE__ */ new Date()).toISOString()} redseaTokenUrl:${Zo} datadogTrackingUuid: ${t}, redirectUri: ${De}`
  );
  let i, s;
  try {
    i = await window.fetch(Zo, {
      method: "POST",
      headers: o,
      body: a
    }), s = await i.json(), console.error(
      `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] successfully completed exchange for access token, removing codeVerifier from sessionStorage ts: ${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}, redirectUri: ${De}`
    ), sessionStorage.removeItem("codeVerifier");
  } catch (u) {
    throw console.error(
      `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] error completing exchange for access token ts: ${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}, redirectUri: ${De}, error: ${u} errorStr: ${u.toString()} errorStack: ${u.stack}`
    ), Ze.addError(
      new Error("error in exchanging code and code verifier request for access token"),
      {
        ts: (/* @__PURE__ */ new Date()).toISOString(),
        e: u,
        datadogTrackingUuid: t,
        redirectUri: De
      }
    ), new Error(u);
  }
  const c = s.id_token;
  return sessionStorage.setItem("id_token", c), console.error(
    `[DEBUG-AUTH (volt-amc-container) - exchangeAuthCode] setting idToken in sessionStorage ts: ${(/* @__PURE__ */ new Date()).toISOString()} datadogTrackingUuid: ${t}, redirectUri: ${De}`
  ), s.access_token;
}
async function Vg(e = "/", t = "") {
  console.error(
    `[DEBUG-AUTH (volt-amc-container) - logout] logging out source:${t} ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  );
  const r = Wr();
  if (r)
    try {
      console.error(
        `[DEBUG-AUTH (volt-amc-container) - logout] logging out redsea ts:${(/* @__PURE__ */ new Date()).toISOString()}`
      ), await window.fetch(Ng, {
        method: "POST",
        headers: r
      });
    } catch (n) {
      console.error(
        `[DEBUG-AUTH (volt-amc-container) - logout] failed to log out of redsea ts:${(/* @__PURE__ */ new Date()).toISOString()}, err:${n}`
      ), console.error("Failed to log out from Redsea", n);
    }
  console.error(
    `[DEBUG-AUTH (volt-amc-container) - logout] setting loggingOut to true ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ), localStorage.setItem("loggingOut", "true"), console.error(
    `[DEBUG-AUTH (volt-amc-container) - logout] clearing sessionStorage ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ), sessionStorage.clear(), ["lastAppActivity", "webToken", "loggingOut", Qu].forEach(
    (n) => localStorage.removeItem(n)
  ), console.error(
    `[DEBUG-AUTH (volt-amc-container) - logout] removing lastAppActivity, webToken, loggingOut from localStorage ts:${(/* @__PURE__ */ new Date()).toISOString()}`
  ), window.analytics && window.analytics.reset(), window.location.href = Lg;
}
const Hr = {
  authorize: cc,
  exchangeAuthCode: Bg,
  logout: Vg,
  generateOauthParams: sc,
  overrideWaitPeriodInMs: Fg,
  resetWaitPeriodInMs: jg
};
function zg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var na = { exports: {} }, Lt = {}, Qo;
function Hg() {
  if (Qo)
    return Lt;
  Qo = 1;
  /** @license React v16.14.0
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = ut, t = 60103;
  if (Lt.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), Lt.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, u) {
    var l, f = {}, p = null, m = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (l in c)
      a.call(c, l) && !o.hasOwnProperty(l) && (f[l] = c[l]);
    if (s && s.defaultProps)
      for (l in c = s.defaultProps, c)
        f[l] === void 0 && (f[l] = c[l]);
    return { $$typeof: t, type: s, key: p, ref: m, props: f, _owner: n.current };
  }
  return Lt.jsx = i, Lt.jsxs = i, Lt;
}
var Bn = {}, ei;
function Gg() {
  return ei || (ei = 1, function(e) {
    /** @license React v16.14.0
     * react-jsx-runtime.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    process.env.NODE_ENV !== "production" && function() {
      var t = ut, r = 60103, n = 60106;
      e.Fragment = 60107;
      var a = 60108, o = 60114, i = 60109, s = 60110, c = 60112, u = 60113, l = 60120, f = 60115, p = 60116, m = 60121, g = 60122, S = 60117, x = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var T = Symbol.for;
        r = T("react.element"), n = T("react.portal"), e.Fragment = T("react.fragment"), a = T("react.strict_mode"), o = T("react.profiler"), i = T("react.provider"), s = T("react.context"), c = T("react.forward_ref"), u = T("react.suspense"), l = T("react.suspense_list"), f = T("react.memo"), p = T("react.lazy"), m = T("react.block"), g = T("react.server.block"), S = T("react.fundamental"), T("react.scope"), T("react.opaque.id"), x = T("react.debug_trace_mode"), T("react.offscreen"), P = T("react.legacy_hidden");
      }
      var F = typeof Symbol == "function" && Symbol.iterator, M = "@@iterator";
      function R(v) {
        if (v === null || typeof v != "object")
          return null;
        var E = F && v[F] || v[M];
        return typeof E == "function" ? E : null;
      }
      var L = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function j(v) {
        {
          for (var E = arguments.length, O = new Array(E > 1 ? E - 1 : 0), V = 1; V < E; V++)
            O[V - 1] = arguments[V];
          ne("error", v, O);
        }
      }
      function ne(v, E, O) {
        {
          var V = L.ReactDebugCurrentFrame, Z = "";
          if (A) {
            var Y = _(A.type), $ = A._owner;
            Z += me(Y, A._source, $ && _($.type));
          }
          Z += V.getStackAddendum(), Z !== "" && (E += "%s", O = O.concat([Z]));
          var z = O.map(function(he) {
            return "" + he;
          });
          z.unshift("Warning: " + E), Function.prototype.apply.call(console[v], console, z);
        }
      }
      var w = !1;
      function I(v) {
        return !!(typeof v == "string" || typeof v == "function" || v === e.Fragment || v === o || v === x || v === a || v === u || v === l || v === P || w || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === f || v.$$typeof === i || v.$$typeof === s || v.$$typeof === c || v.$$typeof === S || v.$$typeof === m || v[0] === g));
      }
      var W = /^(.*)[\\\/]/;
      function me(v, E, O) {
        var V = "";
        if (E) {
          var Z = E.fileName, Y = Z.replace(W, "");
          if (/^index\./.test(Y)) {
            var $ = Z.match(W);
            if ($) {
              var z = $[1];
              if (z) {
                var he = z.replace(W, "");
                Y = he + "/" + Y;
              }
            }
          }
          V = " (at " + Y + ":" + E.lineNumber + ")";
        } else
          O && (V = " (created by " + O + ")");
        return `
    in ` + (v || "Unknown") + V;
      }
      var ke = 1;
      function y(v) {
        return v._status === ke ? v._result : null;
      }
      function h(v, E, O) {
        var V = E.displayName || E.name || "";
        return v.displayName || (V !== "" ? O + "(" + V + ")" : O);
      }
      function _(v) {
        if (v == null)
          return null;
        if (typeof v.tag == "number" && j("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof v == "function")
          return v.displayName || v.name || null;
        if (typeof v == "string")
          return v;
        switch (v) {
          case e.Fragment:
            return "Fragment";
          case n:
            return "Portal";
          case o:
            return "Profiler";
          case a:
            return "StrictMode";
          case u:
            return "Suspense";
          case l:
            return "SuspenseList";
        }
        if (typeof v == "object")
          switch (v.$$typeof) {
            case s:
              return "Context.Consumer";
            case i:
              return "Context.Provider";
            case c:
              return h(v, v.render, "ForwardRef");
            case f:
              return _(v.type);
            case m:
              return _(v.render);
            case p: {
              var E = v, O = y(E);
              if (O)
                return _(O);
              break;
            }
          }
        return null;
      }
      var b = {};
      L.ReactDebugCurrentFrame;
      var A = null;
      function C(v) {
        A = v;
      }
      function K(v, E, O, V, Z) {
        {
          var Y = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var $ in v)
            if (Y(v, $)) {
              var z = void 0;
              try {
                if (typeof v[$] != "function") {
                  var he = Error((V || "React class") + ": " + O + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw he.name = "Invariant Violation", he;
                }
                z = v[$](E, $, V, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Le) {
                z = Le;
              }
              z && !(z instanceof Error) && (C(Z), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", V || "React class", O, $, typeof z), C(null)), z instanceof Error && !(z.message in b) && (b[z.message] = !0, C(Z), j("Failed %s type: %s", O, z.message), C(null));
            }
        }
      }
      var q = L.ReactCurrentOwner, ee = Object.prototype.hasOwnProperty, ie = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ce, tr, It;
      It = {};
      function Ot(v) {
        if (ee.call(v, "ref")) {
          var E = Object.getOwnPropertyDescriptor(v, "ref").get;
          if (E && E.isReactWarning)
            return !1;
        }
        return v.ref !== void 0;
      }
      function Er(v) {
        if (ee.call(v, "key")) {
          var E = Object.getOwnPropertyDescriptor(v, "key").get;
          if (E && E.isReactWarning)
            return !1;
        }
        return v.key !== void 0;
      }
      function wu(v, E) {
        if (typeof v.ref == "string" && q.current && E && q.current.stateNode !== E) {
          var O = _(q.current.type);
          It[O] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(q.current.type), v.ref), It[O] = !0);
        }
      }
      function Au(v, E) {
        {
          var O = function() {
            ce || (ce = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
          };
          O.isReactWarning = !0, Object.defineProperty(v, "key", {
            get: O,
            configurable: !0
          });
        }
      }
      function Eu(v, E) {
        {
          var O = function() {
            tr || (tr = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
          };
          O.isReactWarning = !0, Object.defineProperty(v, "ref", {
            get: O,
            configurable: !0
          });
        }
      }
      var Tu = function(v, E, O, V, Z, Y, $) {
        var z = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: v,
          key: E,
          ref: O,
          props: $,
          // Record the component responsible for creating this element.
          _owner: Y
        };
        return z._store = {}, Object.defineProperty(z._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(z, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: V
        }), Object.defineProperty(z, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Z
        }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
      };
      function Ru(v, E, O, V, Z) {
        {
          var Y, $ = {}, z = null, he = null;
          O !== void 0 && (z = "" + O), Er(E) && (z = "" + E.key), Ot(E) && (he = E.ref, wu(E, Z));
          for (Y in E)
            ee.call(E, Y) && !ie.hasOwnProperty(Y) && ($[Y] = E[Y]);
          if (v && v.defaultProps) {
            var Le = v.defaultProps;
            for (Y in Le)
              $[Y] === void 0 && ($[Y] = Le[Y]);
          }
          if (z || he) {
            var nt = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
            z && Au($, nt), he && Eu($, nt);
          }
          return Tu(v, z, he, Z, V, q.current, $);
        }
      }
      var _n = L.ReactCurrentOwner;
      L.ReactDebugCurrentFrame;
      function xt(v) {
        A = v;
      }
      var yn;
      yn = !1;
      function Sn(v) {
        return typeof v == "object" && v !== null && v.$$typeof === r;
      }
      function so() {
        {
          if (_n.current) {
            var v = _(_n.current.type);
            if (v)
              return `

Check the render method of \`` + v + "`.";
          }
          return "";
        }
      }
      function Cu(v) {
        return "";
      }
      var co = {};
      function Iu(v) {
        {
          var E = so();
          if (!E) {
            var O = typeof v == "string" ? v : v.displayName || v.name;
            O && (E = `

Check the top-level render call using <` + O + ">.");
          }
          return E;
        }
      }
      function uo(v, E) {
        {
          if (!v._store || v._store.validated || v.key != null)
            return;
          v._store.validated = !0;
          var O = Iu(E);
          if (co[O])
            return;
          co[O] = !0;
          var V = "";
          v && v._owner && v._owner !== _n.current && (V = " It was passed a child from " + _(v._owner.type) + "."), xt(v), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, V), xt(null);
        }
      }
      function lo(v, E) {
        {
          if (typeof v != "object")
            return;
          if (Array.isArray(v))
            for (var O = 0; O < v.length; O++) {
              var V = v[O];
              Sn(V) && uo(V, E);
            }
          else if (Sn(v))
            v._store && (v._store.validated = !0);
          else if (v) {
            var Z = R(v);
            if (typeof Z == "function" && Z !== v.entries)
              for (var Y = Z.call(v), $; !($ = Y.next()).done; )
                Sn($.value) && uo($.value, E);
          }
        }
      }
      function Ou(v) {
        {
          var E = v.type;
          if (E == null || typeof E == "string")
            return;
          var O;
          if (typeof E == "function")
            O = E.propTypes;
          else if (typeof E == "object" && (E.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          E.$$typeof === f))
            O = E.propTypes;
          else
            return;
          if (O) {
            var V = _(E);
            K(O, v.props, "prop", V, v);
          } else if (E.PropTypes !== void 0 && !yn) {
            yn = !0;
            var Z = _(E);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z || "Unknown");
          }
          typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function xu(v) {
        {
          for (var E = Object.keys(v.props), O = 0; O < E.length; O++) {
            var V = E[O];
            if (V !== "children" && V !== "key") {
              xt(v), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", V), xt(null);
              break;
            }
          }
          v.ref !== null && (xt(v), j("Invalid attribute `ref` supplied to `React.Fragment`."), xt(null));
        }
      }
      function fo(v, E, O, V, Z, Y) {
        {
          var $ = I(v);
          if (!$) {
            var z = "";
            (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var he = Cu();
            he ? z += he : z += so();
            var Le;
            v === null ? Le = "null" : Array.isArray(v) ? Le = "array" : v !== void 0 && v.$$typeof === r ? (Le = "<" + (_(v.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : Le = typeof v, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Le, z);
          }
          var nt = Ru(v, E, O, Z, Y);
          if (nt == null)
            return nt;
          if ($) {
            var kt = E.children;
            if (kt !== void 0)
              if (V)
                if (Array.isArray(kt)) {
                  for (var bn = 0; bn < kt.length; bn++)
                    lo(kt[bn], v);
                  Object.freeze && Object.freeze(kt);
                } else
                  j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                lo(kt, v);
          }
          return v === e.Fragment ? xu(nt) : Ou(nt), nt;
        }
      }
      function ku(v, E, O) {
        return fo(v, E, O, !0);
      }
      function Pu(v, E, O) {
        return fo(v, E, O, !1);
      }
      var Nu = Pu, Lu = ku;
      e.jsx = Nu, e.jsxs = Lu;
    }();
  }(Bn)), Bn;
}
process.env.NODE_ENV === "production" ? na.exports = Hg() : na.exports = Gg();
var d = na.exports;
const { fragments: $g } = ui, qg = Kr`
  query currentUser {
    currentUser {
      ...userInfo
    }
  }
  ${$g.userInfo}
`, Gr = "TOGGLE_SHOW_ACTIVITY_MODAL", Ur = (e) => e * 60, aa = () => {
  const e = /* @__PURE__ */ new Date();
  localStorage.setItem("lastAppActivity", e);
}, uc = (e) => e.query({
  query: qg,
  fetchPolicy: "no-cache"
}), lc = () => {
  const e = /* @__PURE__ */ new Date();
  e.setSeconds(e.getSeconds() - 60), localStorage.setItem("lastAppActivity", e);
}, dc = () => {
  const e = localStorage.getItem("lastAppActivity");
  if (!e)
    return lc();
  try {
    const t = new Date(e);
    return (/* @__PURE__ */ new Date() - t) / 1e3;
  } catch {
    return null;
  }
};
function fc(e, t) {
  J(() => {
    const r = (n) => n.isTrusted && n.key === e && n.newValue && t();
    return window.addEventListener("storage", r), () => window.removeEventListener("storage", r);
  }, []);
}
const Ba = be({}), Va = be({}), za = () => xe(Ba), Rt = () => xe(Va), Lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApplicationDataDispatchContext: Va,
  ApplicationDataStateContext: Ba,
  useApplicationDataDispatchContext: Rt,
  useApplicationDataStateContext: za
}, Symbol.toStringTag, { value: "Module" })), on = "ERROR", Ar = "LOAD_APPLICATION_DATA", Ha = "LOADING_APPLICATION_DATA_FROM_API", pc = "FINISHED_LOADING_APPLICATION_DATA_FROM_API", vc = "LOADING_APPLICATION_DATA_FROM_LOCAL_STORAGE", mc = "FAILED_TO_LOAD_APPLICATION_DATA_FROM_LOCAL_STORAGE", sn = "applicationData", Ga = Kr`
  query getApplicationData {
    applicationData {
      json
    }
  }
`, hc = () => {
  const e = se.getItem(sn);
  if (e)
    try {
      return JSON.parse(e);
    } catch (t) {
      return console.error(`Could not read Application Data from localStorage: ${t}`), !1;
    }
  return !1;
}, cn = (e) => se.setItem(sn, JSON.stringify(e)), gc = () => se.removeItem(sn), Kg = (e) => e.split("").reduce((t, r) => (t << 5) - t + r.charCodeAt(0) | 0, 0), Db = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearApplicationDataLocalStorage: gc,
  hashString: Kg,
  loadApplicationDataFromLocalStorage: hc,
  saveApplicationDataInLocalStorage: cn
}, Symbol.toStringTag, { value: "Module" })), Wg = {
  error: !1,
  loaded: !1,
  loadingFromApi: !1,
  loadingFromLocalStorage: !0
};
function Yg(e, t) {
  const { type: r, payload: n } = t;
  switch (r) {
    case Ar:
      return cn(n), {
        ...e,
        data: n,
        loaded: !0,
        loadingFromApi: !1,
        loadingFromLocalStorage: !1,
        error: !1
      };
    case Ha:
      return {
        ...e,
        loadingFromApi: !0
      };
    case pc:
      return {
        ...e,
        loadingFromApi: !1
      };
    case vc:
      return {
        ...e,
        loadingFromLocalStorage: !0
      };
    case mc:
      return {
        ...e,
        loadingFromLocalStorage: !1
      };
    case on:
      return {
        ...e,
        error: n,
        loaded: !1
      };
    default:
      throw new Error(`Action of type: ${r} is not supported by Application Data reducer`);
  }
}
const _c = be({}), Xg = be(), er = () => xe(_c), Jg = () => {
  const e = Rt(), { redseaAccessTokenIsSet: t } = er();
  J(() => {
    if (t) {
      e({
        type: vc
      });
      const r = hc();
      e(r ? {
        type: Ar,
        payload: r
      } : {
        type: mc,
        payload: new Error("Failed to load application data from localStorage.")
      });
    }
  }, [t, e]);
}, Zg = () => {
  const { loaded: e, loadingFromLocalStorage: t } = za(), { redseaAccessTokenIsSet: r } = er(), n = !r || t || e, a = Rt(), { data: o, error: i, loading: s } = da(Ga, {
    skip: n
  });
  J(() => {
    if (o && o.applicationData)
      try {
        const c = JSON.parse(o.applicationData.json);
        cn(c), a({ type: Ar, payload: c });
      } catch (c) {
        console.error(`No Application Data for logged in user: ${c}`);
      }
  }, [o, a]), J(() => {
    s && a({ type: Ha });
  }, [s, a]), J(() => {
    i && (console.error(i), a({ type: on, payload: i }));
  }, [a, i]);
}, Qg = () => {
  Jg(), Zg();
  const e = Rt(), { redseaAccessTokenIsSet: t } = er();
  J(() => {
    t || e({ type: on, payload: "v2 auth cookie not set" });
  }, [t, e]);
};
function e_() {
  const e = localStorage.getItem("validFeatureFlags");
  try {
    typeof JSON.parse(e) != "object" && (console.log("encrypted localStorage cleared"), localStorage.clear());
  } catch {
    e != null && (console.log("encrypted localStorage cleared"), localStorage.clear());
  }
  return Promise.resolve();
}
const un = be({}), $a = be(), yc = () => xe(un), Sc = () => xe($a), Mb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FlipFlopDispatchContext: $a,
  FlipFlopStateContext: un,
  useFlipFlopDispatchContext: Sc,
  useFlipFlopStateContext: yc
}, Symbol.toStringTag, { value: "Module" })), oa = "LOAD_FLIP_FLOP", bc = "ERROR";
function wc(e, t) {
  const { type: r, payload: n } = t;
  switch (r) {
    case oa:
      return {
        ...e,
        loaded: !0,
        fromLocalStorage: n.fromLocalStorage
      };
    case bc:
      return {
        ...e,
        error: n,
        loaded: !1
      };
    default:
      throw new Error(`Action of type: ${r} is not supported by Janus reducer`);
  }
}
const Ub = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wc
}, Symbol.toStringTag, { value: "Module" })), de = new Fu({
  secureStorageEKey: "finefornow",
  environment: "production"
}), ln = be({}), qa = be({}), qe = () => xe(ln), dn = () => xe(qa), Fb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RedseaDispatchContext: qa,
  RedseaStateContext: ln,
  useRedseaDispatchContext: dn,
  useRedseaStateContext: qe
}, Symbol.toStringTag, { value: "Module" })), Ka = be({}), Wa = be(), Ke = () => xe(Ka), fn = () => xe(Wa), jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JanusDispatchContext: Wa,
  JanusStateContext: Ka,
  useJanusDispatchContext: fn,
  useJanusStateContext: Ke
}, Symbol.toStringTag, { value: "Module" })), t_ = () => {
  const { loadedFromLocalStorage: e } = qe(), { loadedFromLocalStorage: t } = Ke();
  return le(() => e || t, [
    e,
    t
  ]);
}, r_ = async (e) => {
  if (!e)
    throw new Error("Flip Flop: Invalid userData input.");
  const t = {
    application: "amc",
    email: e.redsea_email || null,
    environment: null,
    // send org as program short code to turn on unify beta based on org
    programShortCode: e.userOrgName || null,
    roles: e.redseaRoles || null
  };
  return await de.populate(t), !0;
}, n_ = () => {
  const e = Sc(), t = t_(), { redseaAccessTokenIsSet: r } = er(), { user: n, isLoggedIn: a } = qe(), {
    user: o,
    isLoggedIn: i,
    error: s
  } = Ke();
  J(() => {
    if (!t && a && (i || s)) {
      const c = {
        userOrgName: i && o.userOrgName,
        ...n
      };
      r_(c).then(
        () => e({
          type: oa,
          payload: { fromLocalStorage: !1 }
        })
      ).catch((u) => {
        console.error(`FlipFlop error: ${u}`), e({ type: bc, payload: u });
      });
    }
    r && t && e({ type: oa, payload: { fromLocalStorage: !0 } });
  }, [
    e,
    s,
    o,
    i,
    t,
    n,
    a,
    r
  ]);
}, a_ = () => !!sessionStorage.getItem("accessToken"), pn = "LOAD_JANUS_USER", Ac = "LOADING_JANUS_USER_FROM_API", Ec = "LOADING_JANUS_USER_FROM_LOCAL_STORAGE", Tc = "STOP_WEBTOKEN_REFRESH", $r = "ERROR", o_ = {
  stopWebtokenRefresh: !0,
  error: !1,
  isLoggedIn: !1,
  loadedFromLocalStorage: !1,
  loadingFromApi: !1,
  loadingFromLocalStorage: !1,
  user: {}
};
function i_(e, t) {
  const { type: r, payload: n } = t;
  switch (r) {
    case pn:
      return {
        ...e,
        user: {
          ...n
        },
        isLoggedIn: !!n.webToken,
        loadingFromApi: !1,
        loadingFromLocalStorage: !1,
        loadedFromLocalStorage: e.loadingFromLocalStorage
      };
    case Ac:
      return {
        ...e,
        loadingFromApi: !0,
        loadingFromLocalStorage: !1
      };
    case Ec:
      return {
        ...e,
        loadingFromLocalStorage: !0
      };
    case $r:
      return {
        ...e,
        error: n,
        loadingFromApi: !1
      };
    case Tc:
      return {
        ...e,
        stopWebtokenRefresh: !0
      };
    default:
      throw new Error(`Action of type: ${r} is not supported by Janus reducer`);
  }
}
const Rc = (e, t = "") => e.reduce(
  (r, { localStorageKey: n, attr: a, defaultVal: o, parse: i }) => {
    a || (a = n);
    let s;
    try {
      s = s_(
        t + n,
        i,
        o,
        a
      );
    } catch (c) {
      console.error(`Error loading ${a}`, c), r[a] = o;
    }
    return r[a] = s, r;
  },
  {}
), s_ = (e, t, r) => {
  try {
    const n = se.getItem(e);
    return t ? n ? JSON.parse(n) : r : n;
  } catch (n) {
    const a = `[DEBUG-AUTH] volt-amc-container encountered an error when parsing user info from local storage: ${n}`, o = new Error(a);
    console.warn(a), Ze.addError(o, { source: "parseUserInfoFromLocalStorage" });
  }
}, Cc = (e, t, r = "") => {
  Object.entries(e).forEach(([n, a]) => {
    let o = a;
    t.includes(n) && (o = JSON.stringify(a)), c_(n, o, r);
  });
}, c_ = (e, t, r = "") => se.setItem(r + e, t);
function u_() {
  Ze.init({
    applicationId: window.env.DATA_DOG_APPLICATION_ID,
    clientToken: window.env.DATA_DOG_CLIENT_KEY,
    site: "datadoghq.com",
    service: "volt-amc-container",
    env: window.env.DATA_DOG_ENVIRONMENT,
    sessionSampleRate: 100,
    trackInteractions: !0
  });
}
const Ic = [
  { localStorageKey: "userId" },
  { localStorageKey: "firstName" },
  { localStorageKey: "lastName" },
  { localStorageKey: "email" },
  { localStorageKey: "webToken" },
  { localStorageKey: "webTokenCreatedTime" },
  { localStorageKey: "userOrgName" },
  { localStorageKey: "userRole" },
  { localStorageKey: "persistApiUserId" },
  { localStorageKey: "activeProgram", parse: !0 },
  { localStorageKey: "departments", defaultVal: [], parse: !0 },
  { localStorageKey: "programs", defaultVal: [], parse: !0 },
  {
    localStorageKey: "userMetadata-programs",
    attr: "programsMetadata",
    defaultVal: [],
    parse: !0
  },
  { localStorageKey: "savedReports", defaultVal: [], parse: !0 },
  { localStorageKey: "defaultReport", defaultVal: {}, parse: !0 },
  { localStorageKey: "dataJournals", defaultVal: [], parse: !0 },
  { localStorageKey: "supplements", defaultVal: [], parse: !0 }
  // Remove ket from resetting
  // https://marqeta.atlassian.net/browse/PS-15839
  // { localStorageKey: 'favoritePrograms', defaultVal: [], parse: true },
];
function ia(e) {
  let t = se.getItem("janusAuthenticateResponses"), r = [];
  if (t)
    try {
      r = JSON.parse(t);
    } catch (n) {
      const a = `[DEBUG-AUTH] Janus Authentication failed with the following error: ${n}`;
      Ze.addError(a, { source: "Janus Authentication" }), console.warn(a);
    }
  r.push(JSON.stringify(e)), se.setItem("janusAuthenticateResponses", JSON.stringify(r));
}
const l_ = {
  id: "userId",
  first_name: "firstName",
  last_name: "lastName",
  json_web_token: "webToken",
  org_name: "userOrgName",
  role: "userRole"
}, Oc = (e) => Object.entries(e).reduce((t, [r, n]) => {
  const a = l_[r] || r;
  return t[a] = n, t;
}, {}), xc = () => Ic.forEach(({ localStorageKey: e }) => se.removeItem(e)), kc = () => {
  se.clearByMatch("actingAs-"), se.clearByMatch("actingAsUserPrefix"), se.clearByMatch("hideForActingAs-");
}, Pc = () => {
  window.sessionStorage.removeItem("transactionFilters");
}, Bb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearActingAsFromLocalStorage: kc,
  clearPersistedFiltersFromSessionStorage: Pc,
  mapApiKeysToHumanReadableKeys: Oc,
  recordJanusAuthenticateCall: ia,
  removeJanusUserKeysFromLocalStorage: xc
}, Symbol.toStringTag, { value: "Module" }));
function Nc() {
  const e = se.getItem("webToken");
  return `DIVA_APP:${se.getItem("actingAs-webToken") || e || ""}`;
}
function ti() {
  return pa("JANUS_API_PREFIX");
}
function Lc() {
  return de.get("app-api-proxy-beta", !1) && window.env.APP_API_URL || window.env.DATA_DOG_ENVIRONMENT !== "production" && window.env.APP_API_URL ? `${window.env.APP_API_URL}${ti()}` : `${ti()}`;
}
function Dc() {
  return process.env.REACT_APP_ENV === "test" ? p_() : f_();
}
function d_(e) {
  const { url: t, options: r = {} } = e, { headers: n = {} } = r, a = Dc();
  return {
    ...e,
    url: t,
    options: {
      ...r,
      headers: {
        ...a,
        ...n
      }
    }
  };
}
function f_() {
  return {
    Authorization: `Basic ${btoa(Nc())}`,
    actor: "DivaApp"
  };
}
function p_() {
  return {
    Authorization: `Basic ${btoa(Nc())}`,
    actor: "IntegrationTest",
    "actor-email": window.env.TEST_EMAIL
  };
}
function v_(e) {
  return d_(e);
}
function m_(e) {
  const { logOutIfTokenIsExpired: t, options: r, url: n } = e;
  return {
    url: `${Lc()}${n}`,
    options: r,
    logOutIfTokenIsExpired: t
  };
}
function h_(e) {
  return e && e.data && (e.data.code === 40101 || e.data.code === 440);
}
var Mc = {}, Uc = {}, Fc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function() {
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    if (typeof window < "u") {
      var s;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (s = window).gtag.apply(s, o);
    }
  }, r = t;
  e.default = r;
})(Fc);
var jc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var t = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function r(s) {
    return s.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(c, u, l) {
      return u > 0 && u + c.length !== l.length && c.search(t) > -1 && l.charAt(u - 2) !== ":" && (l.charAt(u + c.length) !== "-" || l.charAt(u - 1) === "-") && l.charAt(u - 1).search(/[^\s-]/) < 0 ? c.toLowerCase() : c.substr(1).search(/[A-Z]|\../) > -1 ? c : c.charAt(0).toUpperCase() + c.substr(1);
    });
  }
  function n(s) {
    return typeof s == "string" && s.indexOf("@") !== -1;
  }
  var a = "REDACTED (Potential Email Address)";
  function o(s) {
    return n(s) ? (console.warn("This arg looks like an email address, redacting."), a) : s;
  }
  function i() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, l = s || "";
    return c && (l = r(s)), u && (l = o(l)), l;
  }
})(jc);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.GA4 = void 0;
  var t = i(Fc), r = i(jc), n = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], a = ["title", "location"], o = ["page", "hitType"];
  function i(y) {
    return y && y.__esModule ? y : { default: y };
  }
  function s(y, h) {
    if (y == null)
      return {};
    var _ = c(y, h), b, A;
    if (Object.getOwnPropertySymbols) {
      var C = Object.getOwnPropertySymbols(y);
      for (A = 0; A < C.length; A++)
        b = C[A], !(h.indexOf(b) >= 0) && Object.prototype.propertyIsEnumerable.call(y, b) && (_[b] = y[b]);
    }
    return _;
  }
  function c(y, h) {
    if (y == null)
      return {};
    var _ = {}, b = Object.keys(y), A, C;
    for (C = 0; C < b.length; C++)
      A = b[C], !(h.indexOf(A) >= 0) && (_[A] = y[A]);
    return _;
  }
  function u(y) {
    "@babel/helpers - typeof";
    return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
      return typeof h;
    } : function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, u(y);
  }
  function l(y) {
    return m(y) || p(y) || T(y) || f();
  }
  function f() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function p(y) {
    if (typeof Symbol < "u" && y[Symbol.iterator] != null || y["@@iterator"] != null)
      return Array.from(y);
  }
  function m(y) {
    if (Array.isArray(y))
      return F(y);
  }
  function g(y, h) {
    var _ = Object.keys(y);
    if (Object.getOwnPropertySymbols) {
      var b = Object.getOwnPropertySymbols(y);
      h && (b = b.filter(function(A) {
        return Object.getOwnPropertyDescriptor(y, A).enumerable;
      })), _.push.apply(_, b);
    }
    return _;
  }
  function S(y) {
    for (var h = 1; h < arguments.length; h++) {
      var _ = arguments[h] != null ? arguments[h] : {};
      h % 2 ? g(Object(_), !0).forEach(function(b) {
        w(y, b, _[b]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(_)) : g(Object(_)).forEach(function(b) {
        Object.defineProperty(y, b, Object.getOwnPropertyDescriptor(_, b));
      });
    }
    return y;
  }
  function x(y, h) {
    return R(y) || M(y, h) || T(y, h) || P();
  }
  function P() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function T(y, h) {
    if (y) {
      if (typeof y == "string")
        return F(y, h);
      var _ = Object.prototype.toString.call(y).slice(8, -1);
      if (_ === "Object" && y.constructor && (_ = y.constructor.name), _ === "Map" || _ === "Set")
        return Array.from(y);
      if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
        return F(y, h);
    }
  }
  function F(y, h) {
    (h == null || h > y.length) && (h = y.length);
    for (var _ = 0, b = new Array(h); _ < h; _++)
      b[_] = y[_];
    return b;
  }
  function M(y, h) {
    var _ = y == null ? null : typeof Symbol < "u" && y[Symbol.iterator] || y["@@iterator"];
    if (_ != null) {
      var b, A, C, K, q = [], ee = !0, ie = !1;
      try {
        if (C = (_ = _.call(y)).next, h !== 0)
          for (; !(ee = (b = C.call(_)).done) && (q.push(b.value), q.length !== h); ee = !0)
            ;
      } catch (ce) {
        ie = !0, A = ce;
      } finally {
        try {
          if (!ee && _.return != null && (K = _.return(), Object(K) !== K))
            return;
        } finally {
          if (ie)
            throw A;
        }
      }
      return q;
    }
  }
  function R(y) {
    if (Array.isArray(y))
      return y;
  }
  function L(y, h) {
    if (!(y instanceof h))
      throw new TypeError("Cannot call a class as a function");
  }
  function j(y, h) {
    for (var _ = 0; _ < h.length; _++) {
      var b = h[_];
      b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(y, I(b.key), b);
    }
  }
  function ne(y, h, _) {
    return h && j(y.prototype, h), Object.defineProperty(y, "prototype", { writable: !1 }), y;
  }
  function w(y, h, _) {
    return h = I(h), h in y ? Object.defineProperty(y, h, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : y[h] = _, y;
  }
  function I(y) {
    var h = W(y, "string");
    return u(h) === "symbol" ? h : String(h);
  }
  function W(y, h) {
    if (u(y) !== "object" || y === null)
      return y;
    var _ = y[Symbol.toPrimitive];
    if (_ !== void 0) {
      var b = _.call(y, h || "default");
      if (u(b) !== "object")
        return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (h === "string" ? String : Number)(y);
  }
  var me = /* @__PURE__ */ function() {
    function y() {
      var h = this;
      L(this, y), w(this, "reset", function() {
        h.isInitialized = !1, h._testMode = !1, h._currentMeasurementId, h._hasLoadedGA = !1, h._isQueuing = !1, h._queueGtag = [];
      }), w(this, "_gtag", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        h._testMode || h._isQueuing ? h._queueGtag.push(b) : t.default.apply(void 0, b);
      }), w(this, "_loadGA", function(_, b) {
        var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !h._hasLoadedGA) {
          var C = document.createElement("script");
          C.async = !0, C.src = "".concat(A, "?id=").concat(_), b && C.setAttribute("nonce", b), document.body.appendChild(C), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, h._hasLoadedGA = !0;
        }
      }), w(this, "_toGtagOptions", function(_) {
        if (_) {
          var b = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, A = Object.entries(_).reduce(function(C, K) {
            var q = x(K, 2), ee = q[0], ie = q[1];
            return b[ee] ? C[b[ee]] = ie : C[ee] = ie, C;
          }, {});
          return A;
        }
      }), w(this, "initialize", function(_) {
        var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!_)
          throw new Error("Require GA_MEASUREMENT_ID");
        var A = typeof _ == "string" ? [{
          trackingId: _
        }] : _;
        h._currentMeasurementId = A[0].trackingId;
        var C = b.gaOptions, K = b.gtagOptions, q = b.nonce, ee = b.testMode, ie = ee === void 0 ? !1 : ee, ce = b.gtagUrl;
        if (h._testMode = ie, ie || h._loadGA(h._currentMeasurementId, q, ce), h.isInitialized || (h._gtag("js", /* @__PURE__ */ new Date()), A.forEach(function(Ot) {
          var Er = S(S(S({}, h._toGtagOptions(S(S({}, C), Ot.gaOptions))), K), Ot.gtagOptions);
          Object.keys(Er).length ? h._gtag("config", Ot.trackingId, Er) : h._gtag("config", Ot.trackingId);
        })), h.isInitialized = !0, !ie) {
          var tr = l(h._queueGtag);
          for (h._queueGtag = [], h._isQueuing = !1; tr.length; ) {
            var It = tr.shift();
            h._gtag.apply(h, l(It)), It[0] === "get" && (h._isQueuing = !0);
          }
        }
      }), w(this, "set", function(_) {
        if (!_) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (u(_) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(_).length === 0 && console.warn("empty `fieldsObject` given to .set()"), h._gaCommand("set", _);
      }), w(this, "_gaCommandSendEvent", function(_, b, A, C, K) {
        h._gtag("event", b, S(S({
          event_category: _,
          event_label: A,
          value: C
        }, K && {
          non_interaction: K.nonInteraction
        }), h._toGtagOptions(K)));
      }), w(this, "_gaCommandSendEventParameters", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        if (typeof b[0] == "string")
          h._gaCommandSendEvent.apply(h, l(b.slice(1)));
        else {
          var C = b[0], K = C.eventCategory, q = C.eventAction, ee = C.eventLabel, ie = C.eventValue;
          C.hitType;
          var ce = s(C, n);
          h._gaCommandSendEvent(K, q, ee, ie, ce);
        }
      }), w(this, "_gaCommandSendTiming", function(_, b, A, C) {
        h._gtag("event", "timing_complete", {
          name: b,
          value: A,
          event_category: _,
          event_label: C
        });
      }), w(this, "_gaCommandSendPageview", function(_, b) {
        if (b && Object.keys(b).length) {
          var A = h._toGtagOptions(b), C = A.title, K = A.location, q = s(A, a);
          h._gtag("event", "page_view", S(S(S(S({}, _ && {
            page_path: _
          }), C && {
            page_title: C
          }), K && {
            page_location: K
          }), q));
        } else
          _ ? h._gtag("event", "page_view", {
            page_path: _
          }) : h._gtag("event", "page_view");
      }), w(this, "_gaCommandSendPageviewParameters", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        if (typeof b[0] == "string")
          h._gaCommandSendPageview.apply(h, l(b.slice(1)));
        else {
          var C = b[0], K = C.page;
          C.hitType;
          var q = s(C, o);
          h._gaCommandSendPageview(K, q);
        }
      }), w(this, "_gaCommandSend", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        var C = typeof b[0] == "string" ? b[0] : b[0].hitType;
        switch (C) {
          case "event":
            h._gaCommandSendEventParameters.apply(h, b);
            break;
          case "pageview":
            h._gaCommandSendPageviewParameters.apply(h, b);
            break;
          case "timing":
            h._gaCommandSendTiming.apply(h, l(b.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(C));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(C));
        }
      }), w(this, "_gaCommandSet", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        typeof b[0] == "string" && (b[0] = w({}, b[0], b[1])), h._gtag("set", h._toGtagOptions(b[0]));
      }), w(this, "_gaCommand", function(_) {
        for (var b = arguments.length, A = new Array(b > 1 ? b - 1 : 0), C = 1; C < b; C++)
          A[C - 1] = arguments[C];
        switch (_) {
          case "send":
            h._gaCommandSend.apply(h, A);
            break;
          case "set":
            h._gaCommandSet.apply(h, A);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(_));
        }
      }), w(this, "ga", function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        if (typeof b[0] == "string")
          h._gaCommand.apply(h, b);
        else {
          var C = b[0];
          h._gtag("get", h._currentMeasurementId, "client_id", function(K) {
            h._isQueuing = !1;
            var q = h._queueGtag;
            for (C({
              get: function(ce) {
                return ce === "clientId" ? K : ce === "trackingId" ? h._currentMeasurementId : ce === "apiVersion" ? "1" : void 0;
              }
            }); q.length; ) {
              var ee = q.shift();
              h._gtag.apply(h, l(ee));
            }
          }), h._isQueuing = !0;
        }
        return h.ga;
      }), w(this, "event", function(_, b) {
        if (typeof _ == "string")
          h._gtag("event", _, h._toGtagOptions(b));
        else {
          var A = _.action, C = _.category, K = _.label, q = _.value, ee = _.nonInteraction, ie = _.transport;
          if (!C || !A) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var ce = {
            hitType: "event",
            eventCategory: (0, r.default)(C),
            eventAction: (0, r.default)(A)
          };
          K && (ce.eventLabel = (0, r.default)(K)), typeof q < "u" && (typeof q != "number" ? console.warn("Expected `args.value` arg to be a Number.") : ce.eventValue = q), typeof ee < "u" && (typeof ee != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : ce.nonInteraction = ee), typeof ie < "u" && (typeof ie != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(ie) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), ce.transport = ie)), h._gaCommand("send", ce);
        }
      }), w(this, "send", function(_) {
        h._gaCommand("send", _);
      }), this.reset();
    }
    return ne(y, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), y;
  }();
  e.GA4 = me;
  var ke = new me();
  e.default = ke;
})(Uc);
(function(e) {
  function t(s) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
      return typeof c;
    } : function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, t(s);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ReactGAImplementation = void 0;
  var r = a(Uc);
  function n(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap();
    return (n = function(f) {
      return f ? u : c;
    })(s);
  }
  function a(s, c) {
    if (s && s.__esModule)
      return s;
    if (s === null || t(s) !== "object" && typeof s != "function")
      return { default: s };
    var u = n(c);
    if (u && u.has(s))
      return u.get(s);
    var l = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in s)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(s, p)) {
        var m = f ? Object.getOwnPropertyDescriptor(s, p) : null;
        m && (m.get || m.set) ? Object.defineProperty(l, p, m) : l[p] = s[p];
      }
    return l.default = s, u && u.set(s, l), l;
  }
  var o = r.GA4;
  e.ReactGAImplementation = o;
  var i = r.default;
  e.default = i;
})(Mc);
const g_ = /* @__PURE__ */ zg(Mc);
let sa = g_, Bc, Vc;
window && window.env && (Bc = window.env.GOOGLE_ANALYTICS_UA_TOKEN, Vc = window.env.GOOGLE_ANALYTICS_LOGGING === "active");
try {
  sa.initialize(Bc, { debug: Vc });
} catch {
  sa = !1;
}
const ri = sa, Ya = "LOADING", zc = "STOP_LOADING", vn = be(), mn = be(), __ = () => xe(vn), Xa = () => xe(mn), Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IsLoadingDispatchContext: mn,
  IsLoadingStateContext: vn,
  useIsLoadingDispatchContext: Xa,
  useIsLoadingStateContext: __
}, Symbol.toStringTag, { value: "Module" }));
function Ct(e = "/") {
  const t = fn(), r = Xa();
  return $e(() => {
    (async () => {
      r({ type: Ya, payload: "Signing Out" }), await (async () => {
        t({ type: Tc });
        const i = Dc(), s = Object.assign({}, i, Wr()), c = Lc();
        try {
          await fetch(`${c}/diva/security/users/redsea/logout`, {
            method: "POST",
            headers: s
          });
        } catch (u) {
          console.error(u);
        }
        ri && ri.event({
          category: "Key User Events",
          action: "User Logged Out",
          label: "User Logged Out"
        });
      })(), xc(), Ti(), gc(), kc(), Pc(), Hr.logout(e, "useLogOut.js");
    })();
  }, [r, t]);
}
function y_() {
  const e = Ct(), t = async (n) => {
    const { url: a, options: o, logOutIfTokenIsExpired: i = !0 } = n;
    console.error("[DEBUG-AUTH (volt-amc-container) - useJanusApi] dispatching Janus API");
    const s = await window.fetch(a, o);
    let c;
    if (s.headers.get("Content-Type").includes("text") ? c = await s.text() : c = await s.json(), s.status === 500 || s.status === 400 || s.status === 403)
      throw console.error(
        `[DEBUG-AUTH (volt-amc-container) - useJanusApi] Janus API returned an error: ${s.statusText}`
      ), new Error(s.statusText);
    const u = {
      data: c,
      headers: {},
      ...s,
      status: s.status,
      statusText: s.statusText
    };
    return s.headers.forEach((l, f) => u.headers[f] = l), i && h_(u) && (console.error(
      "[DEBUG-AUTH (volt-amc-container) - useJanusApi] Auth token is expired; logging out user"
    ), e()), u;
  };
  return $e(di(t, m_, v_), [e]);
}
const S_ = () => {
  const e = fn(), { redseaAccessTokenIsSet: t } = er(), r = y_();
  J(() => {
    b_(e) || (t ? (e({ type: Ac }), A_(r).then((a) => {
      w_(a, e);
    })) : e({ type: $r, payload: "v2FlowAuthCookie not set" }));
  }, [e, t, r]);
};
function b_(e) {
  e({ type: Ec });
  const t = Rc(Ic);
  return t.webToken ? (e({
    type: pn,
    payload: t
  }), !0) : !1;
}
function w_(e = {}, t) {
  if (e.code === 500)
    t({
      type: $r,
      payload: `Janus authentication failed: ${e.message}`
    });
  else if (e.code === 400)
    t({
      type: $r,
      payload: `Janus authentication failed: ${e.message}`
    });
  else {
    const r = {
      ...e,
      webTokenCreatedTime: (/* @__PURE__ */ new Date()).toString()
    };
    r && r.email && Cc(r, ["departments", "programs", "supplements"]), t({
      type: pn,
      payload: r
    });
  }
}
async function A_(e) {
  let t = !1;
  const r = Wr();
  try {
    const n = await e({
      url: "/diva/security/users/redsea/authenticate",
      options: { method: "POST", headers: r }
    });
    t = Oc(n.data), ia(n);
  } catch (n) {
    return console.log(`👁 JANUS 👁 authentication failed: ${n}`), ia(n), { code: 500, message: n.message };
  }
  return t;
}
const ca = "ERROR", Ja = "LOAD_REDSEA_USER", Hc = "LOADING_REDSEA_USER_FROM_API", Gc = {
  error: !1,
  isLoggedIn: !1,
  loadedFromLocalStorage: !1,
  loadingFromApi: !1,
  loadingFromLocalStorage: !0,
  user: {}
};
function $c(e, t) {
  const { type: r, payload: n } = t;
  switch (r) {
    case Ja:
      return {
        ...e,
        user: n,
        isLoggedIn: !!n.redsea_email,
        loadingFromApi: !1,
        loadingFromLocalStorage: !1,
        loadedFromLocalStorage: e.loadingFromLocalStorage
      };
    case Hc:
      return {
        ...e,
        loadingFromLocalStorage: !1,
        loadingFromApi: !0
      };
    case ca:
      return {
        ...e,
        error: n,
        loadingFromLocalStorage: !1,
        loadingFromApi: !1
      };
    default:
      throw new Error(`Action of type: ${r} is not supported by Redsea reducer`);
  }
}
const zb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  initialState: Gc,
  reducer: $c
}, Symbol.toStringTag, { value: "Module" })), { fragments: qc } = ui, Za = Kr`
  query currentUser {
    currentUser {
      ...userInfo
    }
  }
  ${qc.userInfo}
`, Kc = Kr`
  mutation updateCurrentUser(
    $first_name: String
    $last_name: String
    $phone: String
    $active: Boolean
    $mfa_totp_enabled: Boolean
    $mfa_enabled: Boolean
    $mfa_totp_revealed: Boolean
  ) {
    updateCurrentUser(
      first_name: $first_name
      last_name: $last_name
      phone: $phone
      active: $active
      mfa_totp_enabled: $mfa_totp_enabled
      mfa_enabled: $mfa_enabled
      mfa_totp_revealed: $mfa_totp_revealed
    ) {
      ...userInfo
    }
  }
  ${qc.userInfo}
`, Hb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FETCH_REDSEA_CURRENT_USER: Za,
  UPDATE_REDSEA_CURRENT_USER: Kc
}, Symbol.toStringTag, { value: "Module" })), Wc = () => {
  const e = dn();
  return $e(
    (t) => {
      const r = Ei(t);
      Cc(r, [
        "redseaPrograms",
        "redseaRolesToProgramsMap",
        "redseaRolesToProgramsEnvironmentsMap",
        "redseaRoles"
      ]), e({
        type: Ja,
        payload: r
      });
    },
    [e]
  );
}, E_ = () => {
  const e = dn(), t = Rt();
  J(() => {
    const r = Rc(hi);
    r.redsea_email ? e({
      type: Ja,
      payload: r
    }) : e({ type: Hc });
  }, [t, e]);
}, T_ = () => {
  const { redseaAccessTokenIsSet: e } = er(), { loadingFromLocalStorage: t, isLoggedIn: r } = qe(), n = !e || t || r, { data: a, error: o } = da(Za, {
    skip: n,
    errorPolicy: "all"
  }), i = Ct(), s = dn(), c = Wc();
  J(() => {
    e || s({ type: ca, payload: "v2FlowAuthCookie not set" });
  }, [e, s]), J(() => {
    a && a.currentUser && c(a.currentUser);
  }, [a, c]), J(() => {
    a && a.currentUser && (a.currentUser || Hr.authorize(void 0, "use-fetch-and-load-redsea-user-data"));
  }, [a]), J(() => {
    o && (console.error(o), s({
      type: ca,
      payload: o
    }), i());
  }, [s, o, i]);
}, R_ = () => {
  E_(), T_();
}, C_ = "BOOTSTRAP_SESSION_COMPLETE";
function I_(e, t) {
  const { type: r } = t;
  switch (r) {
    case C_:
      return {
        ...e,
        bootstrapSessionComplete: !0
      };
    default:
      throw new Error(`Action of type: ${r} is not supported by BootstrapSession reducer`);
  }
}
const O_ = ({ children: e }) => (S_(), R_(), Qg(), n_(), e), x_ = ({ children: e }) => {
  const [t, r] = hr(!1), [n, a] = st(I_, {
    redseaAccessTokenIsSet: a_()
  }), [o, i] = st(
    $c,
    Gc
  ), [s, c] = st(i_, o_), [u, l] = st(
    Yg,
    Wg
  ), [f, p] = st(wc, {
    loaded: !1,
    error: !1
  }), { redseaAccessTokenIsSet: m } = n;
  return J(() => {
    m || Hr.authorize(void 0, "bootstrap-session-1");
  }, [m]), J(() => {
    u_(), e_().then(() => r(!0)), lc();
  }, []), fc(
    "loggingOut",
    () => Hr.logout(void 0, "BootstrapSession.js")
  ), /* @__PURE__ */ d.jsx(Xg.Provider, { value: a, children: /* @__PURE__ */ d.jsx(_c.Provider, { value: n, children: /* @__PURE__ */ d.jsx(qa.Provider, { value: i, children: /* @__PURE__ */ d.jsx(ln.Provider, { value: o, children: /* @__PURE__ */ d.jsx(Wa.Provider, { value: c, children: /* @__PURE__ */ d.jsx(Ka.Provider, { value: s, children: /* @__PURE__ */ d.jsx($a.Provider, { value: p, children: /* @__PURE__ */ d.jsx(un.Provider, { value: f, children: /* @__PURE__ */ d.jsx(Va.Provider, { value: l, children: /* @__PURE__ */ d.jsx(Ba.Provider, { value: u, children: m && t ? /* @__PURE__ */ d.jsx(O_, { children: e }) : null }) }) }) }) }) }) }) }) }) });
}, k_ = {
  ANALYTICS: "read-only",
  "BUSINESS DEVELOPMENT": "read-only",
  "COMPLIANCE - PROGRAM MANAGED": "compliance-program-managed",
  "COMPLIANCE - PROCESSOR ONLY": "compliance-processor-only",
  "CUSTOMER SERVICE": "cardholder-support",
  "CUSTOMER SUCCESS": "read-only",
  ENGINEERING: "developer",
  "FINANCE - OTHER": "read-only",
  "FINANCE - SETTLEMENT": "read-only",
  GENERAL: "read-only",
  "HUMAN RESOURCES": "read-only",
  LEGAL: "read-only",
  MARKETING: "read-only",
  OPERATIONS: "supplier-payments-manager",
  "PRODUCT MANAGEMENT": "read-only",
  "PROGRAM MANAGEMENT": "read-only",
  QA: "developer",
  SALES: "read-only",
  "COMPLIANCE (INTERNAL)": "compliance-internal",
  "RISK (INTERNAL)": "risk-internal",
  "DELIVERY (INTERNAL)": "delivery-internal",
  "FULFILLMENT (INTERNAL)": "fulfillment-internal",
  "SETTLEMENT (INTERNAL)": "settlement-internal",
  "PRODUCTION SUPPORT (INTERNAL)": "production-support-internal",
  "TOKEN MANAGER": "tokenization-token-manager"
}, P_ = {
  SUPERADMIN: "marqeta-admin-internal",
  MARQETA_ADMIN: "marqeta-admin-internal",
  // not a Janus role, used to map Admin in Marqeta org
  ADMIN: "program-admin",
  SUPPORT: "read-only",
  VIEWER: "read-only"
}, Yc = "View Reports", Xc = "View DiVA Api Access", Jc = "View Home", N_ = [
  Yc,
  Jc,
  Xc
], Zc = "Customer Support Swissquote", Qc = "Customer Support YUH", eu = "No Reports", L_ = [Zc, Qc, eu], D_ = "Granular permissions", M_ = "Private sandbox", U_ = {
  "CROSS BORDER FEES": null,
  "CURRENCY CONVERSION FEES": null,
  "DECISION MANAGER": null,
  DETAIL: null,
  FRAUDSTREAM: null,
  INTERCHANGE: null,
  PII: "aux-access-pii",
  STORIES: null,
  "NO REPORTS": "no-reports",
  "APPROVER (INTERNAL)": "aux-approver-internal",
  APPROVER: "aux-approver",
  "INVOKE COMMANDO MODE (INTERNAL)": "aux-invoke-commando-mode-internal",
  "INVOKE COMMANDO MODE": "aux-invoke-commando-mode",
  "SHOW PAN": "aux-show-pan",
  "ACH ORIGINATION": "aux-ach-origination",
  "CANCEL ACH TRANSFER": "aux-cancel-acho-transfer",
  "CREATE ACH TRANSFER": "aux-create-acho-transfer",
  "VIEW ACH TRANSFERS": "aux-view-acho-transfers",
  "CREDIT PRODUCT CREATOR": "aux-credit-product-creator-external",
  "CREDIT PRODUCT APPROVER": "aux-credit-product-approver-external",
  "CREDIT OFFER CREATOR": "aux-credit-offer-creator-external",
  "CREDIT OFFER APPROVER": "aux-credit-offer-approver-external",
  "CREDIT SUPPORT AGENT": "aux-credit-support-agent-external",
  "CREDIT PRODUCT VIEWER": "aux-credit-product-view-only-external",
  "INVENTORY ADMIN": "aux-inventory-admin",
  "INVENTORY MANAGEMENT": "aux-inventory-management",
  "RISK (EXTERNAL)": "aux-risk-external",
  "TRANSACTION REVIEW MANAGER": "manage-transaction-alerts-view-and-edit",
  "TOKEN MANAGER (EDIT)": "tokenization-token-manager-edit",
  "REPORT CARD STOLEN": "aux-report-card-lost-stolen",
  "SUSPEND CARD": "aux-card-suspend",
  "REPLACE CARD": "aux-card-replace",
  "CREATE CARD MANUALLY": "aux-manual-card-create",
  "CREDIT BRAND CONTRIBUTOR": "aux-credit-brand-contributor",
  "CREDIT BANK PROGRAM MANAGER CREATOR": "aux-credit-bank-program-manager-creator",
  "CREDIT BANK PROGRAM MANAGER APPROVER": "aux-credit-bank-program-manager-approver",
  "COMPLIANCE (INTERNAL)": "aux-compliance-internal",
  "RISK (INTERNAL)": "aux-risk-internal",
  "VIEW REPORTS": "aux-view-reports",
  "VIEW DIVA API ACCESS": "aux-view-diva-api-access",
  "VIEW HOME": "aux-view-home",
  "GRANULAR PERMISSIONS": "uam-granular-permissions",
  "PRIVATE SANDBOX": "private-sandbox",
  "HSM KEY MANAGER": "manage-hsm-key",
  "REVIEW BIN DATA (INTERNAL)": "review-bin-data-internal",
  "MANAGE BIN DATA (INTERNAL)": "manage-bin-data-internal",
  "VIEW BIN DATA (INTERNAL)": "view-bin-data-internal",
  "ISSUER WRITE OFF ACCESS": "issuer-write-off",
  "CUSTOMER SUPPORT SWISSQUOTE": "customer-support-swissquote",
  "CUSTOMER SUPPORT YUH": "customer-support-yuh",
  "REMOVE FUNDS": "aux-remove-cardholder-funds",
  "DISPUTES MANUAL TRANSITIONS": "disputes-manual-transitions"
}, tu = {
  "COMPLIANCE-PROGRAM-MANAGED": "Compliance - Program Managed",
  "COMPLIANCE-PROCESSOR-ONLY": "Compliance - Processor Only",
  "COMPLIANCE-INTERNAL": "Compliance (Internal)",
  "RISK-INTERNAL": "Risk (Internal)",
  "DELIVERY-INTERNAL": "Delivery (Internal)",
  "FULFILLMENT-INTERNAL": "Fulfillment (Internal)",
  "SETTLEMENT-INTERNAL": "Settlement (Internal)",
  "PRODUCTION-SUPPORT-INTERNAL": "Production Support (Internal)",
  "TOKENIZATION-TOKEN-MANAGER": "Token Manager"
}, ru = {
  "AUX-APPROVER-INTERNAL": "Approver (Internal)",
  "AUX-APPROVER": "Approver",
  "AUX-INVOKE-COMMANDO-MODE-INTERNAL": "Invoke Commando Mode (Internal)",
  "AUX-INVOKE-COMMANDO-MODE": "Invoke Commando Mode",
  "AUX-SHOW-PAN": "Show PAN",
  "AUX-ACH-ORIGINATION": "ACH Origination",
  "AUX-CANCEL-ACHO-TRANSFER": "Cancel ACH transfer",
  "AUX-CREATE-ACHO-TRANSFER": "Create ACH transfer",
  "AUX-VIEW-ACHO-TRANSFERS": "View ACH transfers",
  "AUX-ACCESS-PII": "PII",
  "AUX-CREDIT-PRODUCT-CREATOR-EXTERNAL": "Credit Product Creator",
  "AUX-CREDIT-PRODUCT-APPROVER-EXTERNAL": "Credit Product Approver",
  "AUX-CREDIT-OFFER-CREATOR-EXTERNAL": "Credit Offer Creator",
  "AUX-CREDIT-OFFER-APPROVER-EXTERNAL": "Credit Offer Approver",
  "AUX-CREDIT-SUPPORT-AGENT-EXTERNAL": "Credit Support Agent",
  "AUX-CREDIT-PRODUCT-VIEW-ONLY-EXTERNAL": "Credit Product Viewer",
  "AUX-INVENTORY-ADMIN": "Inventory Admin",
  "AUX-INVENTORY-MANAGEMENT": "Inventory Management",
  "AUX-RISK-EXTERNAL": "Risk (External)",
  "TOKENIZATION-TOKEN-MANAGER-EDIT": "Token Manager (Edit)",
  "AUX-REPORT-CARD-LOST-STOLEN": "Report Card Stolen",
  "AUX-CARD-SUSPEND": "Suspend Card",
  "AUX-CARD-REPLACE": "Replace Card",
  "AUX-MANUAL-CARD-CREATE": "Create Card Manually",
  "AUX-CREDIT-BRAND-CONTRIBUTOR": "Credit Brand Contributor",
  "AUX-CREDIT-BANK-PROGRAM-MANAGER-CREATOR": "Credit Bank Program Manager Creator",
  "AUX-CREDIT-BANK-PROGRAM-MANAGER-APPROVER": "Credit Bank Program Manager Approver",
  "AUX-COMPLIANCE-INTERNAL": "Compliance (Internal)",
  "AUX-RISK-INTERNAL": "Risk (Internal)",
  "AUX-VIEW-REPORTS": Yc,
  "AUX-VIEW-DIVA-API-ACCESS": Xc,
  "AUX-VIEW-HOME": Jc,
  "UAM-GRANULAR-PERMISSIONS": D_,
  "PRIVATE-SANDBOX": M_,
  "CUSTOMER-SUPPORT-SWISSQUOTE": Zc,
  "CUSTOMER-SUPPORT-YUH": Qc,
  "MANAGE-HSM-KEY": "HSM key manager",
  "REVIEW-BIN-DATA-INTERNAL": "Review BIN Data (Internal)",
  "MANAGE-BIN-DATA-INTERNAL": "Manage BIN Data (Internal)",
  "MANAGE-TRANSACTION-ALERTS-VIEW-AND-EDIT": "Transaction Review Manager",
  "VIEW-BIN-DATA-INTERNAL": "View BIN Data (Internal)",
  "ISSUER-WRITE-OFF": "Issuer Write Off Access",
  "NO-REPORTS": eu,
  "AUX-REMOVE-CARDHOLDER-FUNDS": "Remove funds",
  "DISPUTES-MANUAL-TRANSITIONS": "Disputes Manual Transitions"
}, Gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  departmentsToRedseaRoles: k_,
  redseaDepartmentsDisplayMapping: tu,
  redseaSupplementsDisplayMapping: ru,
  rolesToRedseaRoles: P_,
  supplementsToRedseaRoles: U_,
  swissquoteOnlySupplements: L_,
  upgradeOnlySupplements: N_
}, Symbol.toStringTag, { value: "Module" }));
function $b() {
  const {
    user: { departments: e }
  } = Ke(), {
    user: { redseaRoles: t }
  } = qe(), r = le(() => F_(t), [
    t
  ]);
  return le(
    () => [].concat(e, r).filter(Boolean),
    [r, e]
  );
}
const F_ = (e) => e.map((t) => tu[t && t.toUpperCase()]).filter(Boolean);
function qb() {
  const {
    user: { supplements: e }
  } = Ke(), {
    user: { redseaRoles: t }
  } = qe(), r = le(() => j_(t), [
    t
  ]);
  return le(
    () => [].concat(e, r).filter(Boolean),
    [r, e]
  );
}
const j_ = (e) => e.map((t) => ru[t && t.toUpperCase()]).filter(Boolean);
function B_() {
  const { user: { redsea_email: e } = {} } = qe(), { user: { email: t } = {} } = Ke();
  return le(() => e || t ? e || t : (console.error("No user email found."), ""), [e, t]);
}
function V_() {
  const { user: { redsea_first_name: e, redsea_last_name: t } = {} } = qe(), { user: { firstName: r, lastName: n } = {} } = Ke();
  return le(() => e || t ? [e, t].join(" ") : r || n ? [r, n].join(" ").trim() : (console.error("No user first/last name found."), ""), [e, t, r, n]);
}
const z_ = "_label_1wpok_1", H_ = "_wrap_1wpok_5", G_ = "_link_1wpok_15", $_ = "_active_1wpok_41", q_ = "_toggle_1wpok_49", K_ = "_linkText_1wpok_57", W_ = "_icon_1wpok_73", Y_ = "_toggled_1wpok_78", X_ = "_subLinks_1wpok_82", Fe = {
  label: z_,
  wrap: H_,
  link: G_,
  active: $_,
  toggle: q_,
  linkText: K_,
  icon: W_,
  toggled: Y_,
  subLinks: X_
}, ua = ({ config: e, leftNav: t }) => {
  const { id: r, text: n, route: a, active: o, isToggle: i, isElement: s, isAuthorized: c, onClick: u } = e, l = function(m) {
    s || m.preventDefault(), i ? t.setToggle(t.activeToggle === r ? null : r) : t.setToggle(null), s || (t.go && a && t.go(a), typeof u == "function" && u(m));
  };
  let f = "div";
  const p = {
    className: `${Fe.link} ${i ? Fe.toggle : ""} ${o ? Fe.active : ""} ${t.activeToggle === r ? Fe.toggled : ""}`,
    onClick: l,
    "data-testid": "left-nav-link"
  };
  return s || (p.href = a || null, f = "a"), c ? ut.createElement(
    f,
    p,
    /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx("span", { "data-testid": `${n}-link-text`, className: `${Fe.linkText}`, children: n }),
      i ? /* @__PURE__ */ d.jsx("span", { className: Fe.icon, children: /* @__PURE__ */ d.jsx(et, { type: "chevron-down", noHoverEffects: !0, factor: 0.5 }) }) : null
    ] })
  ) : null;
};
ua.defaultProps = {
  text: "",
  route: "",
  active: !1,
  id: null,
  onClick: null
};
const nu = (e) => {
  const t = { ...e.link }, {
    id: r,
    route: n = "",
    children: a = [],
    isToggle: o = !1,
    isAuthorized: i,
    visibleCount: s,
    onClick: c
  } = t, u = e.leftNav, l = (p) => {
    const g = (jt(p) && p.props ? p.props.links : p).find((S) => S.isAuthorized);
    if (g && g.route)
      return g;
    if (g && g.children)
      return l(g.children);
  };
  if (o && !n) {
    const p = l(a);
    if (p && p.route)
      t.route = p.route;
    else {
      const m = c;
      t.onClick = (g) => {
        p && p.onClick && p.onClick(g), m && m(g);
      };
    }
  }
  const f = () => {
    const p = (u.activeToggle === r ? s * 36 : 0) + "px";
    return jt(a) ? u.activeToggle === r && a : /* @__PURE__ */ d.jsx("div", { className: Fe.subLinks, style: { height: p + "px" }, children: a.map(
      (m, g) => jt(m) ? m : /* @__PURE__ */ d.jsx(ua, { config: m, leftNav: u }, g)
    ) });
  };
  return i ? /* @__PURE__ */ d.jsxs("div", { className: Fe.linkGroupWrap, children: [
    /* @__PURE__ */ d.jsx(ua, { config: t, leftNav: u }),
    o && (t.active || u.activeToggle === r) && /* @__PURE__ */ d.jsx(f, {})
  ] }) : null;
};
nu.defaultProps = {
  link: {},
  id: null
};
const ni = (e, t, r) => {
  if (jt(e) ? e = { text: e, isElement: !0 } : jt(e.text) && (e = { text: e.text, isElement: !0, children: e.children }), e.id = t, e = ou(e), e.visibleCount = 0, e.isAuthorized = cu(e, r), e.isToggle && (e = iu(e, r)), e.active === void 0) {
    const { pathname: n } = window.location, a = e.alsoActiveOn || [], o = [e.route, ...a];
    e.active = o.includes(n);
  }
  return e;
}, au = (e) => jt(e.children) && e.children.props ? e.children.props.links : e.children, ou = (e) => {
  const t = au(e), r = !!(t && t.length), n = { ...e, isToggle: r };
  return e.children && e.children.length && (e.children = t.map((a) => ou(a))), n;
}, iu = (e, t) => (au(e).map((n) => (n.children ? n = iu(n, t) : n.isAuthorized = cu(n, t), n.isAuthorized && (e.visibleCount += 1, e.isAuthorized = !0), n)), e), J_ = (e, t, r) => e.slice().map((n, a) => {
  const o = r ? [r, a].join("-") : a;
  return n.children && n.children.length && (n.children = n.children.map(
    (i, s) => ni(i, [o, s].join("-"), t)
  )), n = ni(n, a, t), n;
}), su = ({ links: e, label: t, baseId: r, go: n, verifier: a }) => {
  const [o, i] = hr(Z_(e)), s = {
    go: n,
    verifier: a,
    activeToggle: o,
    setToggle: i
  };
  return /* @__PURE__ */ d.jsxs("div", { className: Fe.wrap, children: [
    t ? /* @__PURE__ */ d.jsxs("div", { className: Fe.label, children: [
      /* @__PURE__ */ d.jsx(fr, { factor: 4 }),
      /* @__PURE__ */ d.jsx(ae, { type: "label", children: t }),
      /* @__PURE__ */ d.jsx(fr, { factor: 1.5 })
    ] }) : null,
    J_(e, a, r).map((c, u) => /* @__PURE__ */ d.jsx(nu, { link: c, leftNav: s }, u))
  ] });
};
su.propTypes = {
  // Label included here to support design consistency.
  label: N.string,
  /**
   * @name leftNavLinks
   * @type {Array.<leftNavLink>}
   * @description Configures links and (optionally) children links to be
   *    included in LeftNav. See examples below.
   *
   * ---
   *
   * @name leftNavLink
   * @type {(object|Symbol('react.element'))}
   * @description Link configuration which determines links, toggles, and
   *    sublinks in the LeftNav.
   *
   *    NOTE: Each leftNavLink can be either an object, as outlined below, or a
   *    react element (JSX). Same applies to children. Also, the `text` property
   *    can be either a string or react element (JSX). When a leftNavLink or its
   *    text property is a react element (JSX), most other properties are
   *    ignored, with the exception of `children`.
   *
   *    NOTE: You are in charge of updating the URL and loading the new view.
   *    You can do this by:
   *
   *      1. Setting LeftNavContext.go AND configuring a `route` for each link.
   *        This is the easiest way to handle it "globally".
   *      2. Using the `onClick` callback for each Link, with no `route`. This
   *        means you must update the URL and load the new view inside the
   *        `onClick` function.
   *
   *    NOTE: If both `onClick` and `route` exists in a link,
   *    `LeftNavContext.go` will be called if it is defined. This means you may
   *    load the new view with `route` and `LeftNavContext.go`, while still
   *    using the `onClick` callback to do something else.
   *
   *    NOTE: `LeftNavContext.verifier` is a function that verifies if the route
   *    is authorized to be viewed by the user. If the callback returns `false`,
   *    the link is hidden from the DOM.
   *
   *    NOTE: Design only wants to support 2 layers of nav. This means
   *    `link.children` only go one level deep.
   *
   * @property {(string|Symbol('react.element'))} text - Text label applied to
   *    the Link.
   * @property {string=} route - Route path. When defined, will call
   *    `LeftNavContext.go(route)` to load new view. Otherwise, when undefined,
   *    Link will rely on `onClick` callback to load new view.
   * @property {boolean=} active - Whether Link is currently active. Will be
   *    applied automatically, if undefined.
   * @property {Array.<string>=} alsoActiveOn - If `route` is defined, and
   *    `active` undefined, this can be set to automatically update the `active`
   *    property if current path matches a path here.
   * @callback {Function} onClick - On click callback, which is called after:
   *    1. `LeftNavContext.setToggle`, if link is a toggle.
   *    2. `LeftNavContext.go`, `link` or `link.text` is not a react element,
   *        (JSX), and `link.route` is defined.
   *
   * @property {Array.{Link}=} children - Child paths. When children exist,
   *    the parent becomes a toggle. Children have same properties as Link.
   *
   * @example <caption>Reload view with `route` and `LeftNavContext.go`
   *    callback.</caption>
   * const linkWithRoute = {
   *   text: 'Cardholders',
   *   route: '/program/users',
   *   alsoActiveOn: ['/program/user', 'program/card', '/program'],
   * }
   *
   * @example <caption>Reload view with `onClick`.</caption>
   * const linkWithOnClick = {
   *   text: 'Cardholders',
   *   active: activeRoute === '/active/route',
   *   onClick: (event) => {
   *     // Because no route is defined, LeftNavContext.go will not be called.
   *     // You must manually update URL and load a new view. Since no route
   *     // exists, you must also manually set this Link's `active` state.
   *   },
   * }
   *
   * @example <caption>Reload view with `route` and `LeftNavContext.go`, and
   *    also do something else `onClick` callback.</caption>
   * const linkWithRouteAndOnClick = {
   *   text: 'Cardholders',
   *   route: '/program/users',
   *   alsoActiveOn: ['/program/user', 'program/card', '/program'],
   *   onClick: (event) => {
   *     // Since route is defined, LeftNavContext.go(route) will be called, so
   *     // you don't need to update the URL and load a new view here.
   *     // But you can still use the onClick callback for something else :).
   *   },
   * }
   *
   * @example <caption>Link toggle with sublinks.</caption>
   * // As with any other Links, you can use route, onClick, or both.
   * // Children look just like parent links (but can't have another level
   * // of children).
   * const linkToggle = {
   *   text: 'Cardholders',
   *   route: '/program/users',
   *   alsoActiveOn: ['/program/user', 'program/card', '/program'],
   *   onClick: (event) => {...},
   *   children: [{...}, {...}]
   * }
   *
   * @example <caption>Link as a react element (JSX).</caption>
   * // When using JSX for a link, the `route` and `onClick` props are ignored.
   * // This also means neither `LeftNavContext.go` and `LeftNavContext.verifier`
   * // will be called for any link that is JSX, so the JSX would be responsible
   * // for updating the URL, loading the new view, and authorizating user.
   * const linkAsJSX = <a href="https://www.marqeta.com">Marqeta</a>
   * const linkAsJSXWithChildren = {
   *    text: <a href="https://www.marqeta.com">Site 1</a>,
   *    children: [
   *      <a href="https://www.marqeta.com">Site 2</a>,
   *      {
   *        text: 'Site 3',
   *        route: 'https://www.marqeta.com'
   *      },
   *      <a href="https://www.marqeta.com">Site 4</a>
   *    ]
   * }
   */
  links: N.arrayOf(
    N.shape({
      text: N.oneOfType([N.string, N.object]),
      route: N.string,
      alsoActiveOn: N.arrayOf(N.string),
      onClick: N.func,
      children: N.any
    })
  )
};
su.defaultProps = {
  label: null,
  links: []
};
function Z_(e) {
  const { pathname: t } = window.location;
  return e.findIndex(
    (r) => r.route === t || r.active || r.children && r.children.length && r.children.some((n) => n.route === t || n.active)
  );
}
function cu(e, t) {
  return e.isElement || e.route && t(e.route) || !e.route && typeof e.onClick == "function";
}
const Q_ = "_container_1ro7d_1", ey = {
  container: Q_
};
function ty({ children: e, currentPath: t, verifier: r, go: n }) {
  const a = (i) => ["LeftNavLink", "LeftNavSubLink"].includes(i), o = (i, s = []) => i ? ut.Children.toArray(i).map((u) => {
    const {
      path: l,
      kind: f,
      children: p,
      associatedPaths: m,
      nestedAssociatedPaths: g
    } = u.props || {};
    if (a(f)) {
      const S = [], x = o(p, S), P = t === l || g && g.some((w) => t.indexOf(w) === 0) || m && m.some((w) => t === w), T = r(l), F = {
        selected: P,
        authorized: T,
        path: l
      };
      s.push(F);
      const M = S.find(
        (w) => w.authorized
      ), R = S.some((w) => w.authorized), L = S.some((w) => w.selected), j = (w) => (w.preventDefault(), n(l && T ? l : M.path)), ne = window.location.origin + l && T ? l : M == null ? void 0 : M.path;
      return ut.cloneElement(u, {
        ...u.props,
        go: j,
        link: ne,
        selected: P || L,
        authorized: !!(T || R),
        children: x
      });
    } else
      return u;
  }) : null;
  return /* @__PURE__ */ d.jsx("div", { "data-testid": "left-nav-container", className: ey.container, children: o(e) });
}
const ry = "_Link_l2vco_1", ny = "_selected_l2vco_17", ai = {
  Link: ry,
  selected: ny
};
function Ee({
  title: e,
  icon: t,
  path: r,
  link: n,
  children: a,
  id: o,
  // This gets allocated by LeftNavContainer
  selected: i,
  authorized: s,
  go: c
}) {
  if (!s)
    return null;
  const u = i ? "active" : "inactive", l = i ? "#FFFFFF" : "#262631";
  return /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsxs(
      "a",
      {
        href: n,
        className: `${ai.Link} ${i ? ai.selected : ""}`,
        onClick: c,
        "data-testid": `left-nav-link_${o || r}`,
        children: [
          /* @__PURE__ */ d.jsx(et, { type: `${t}-${u}` }),
          /* @__PURE__ */ d.jsx(St, { factor: 1 }),
          /* @__PURE__ */ d.jsx(ae, { type: "h6", color: l, children: e })
        ]
      }
    ),
    i && /* @__PURE__ */ d.jsx("div", { "data-testid": `left-nav-link_${o || r}-children`, children: a })
  ] });
}
Ee.propTypes = {
  selected: N.bool,
  go: N.func,
  id: N.string,
  kind: N.string,
  path: N.string,
  link: N.string,
  authorized: N.bool,
  title: N.string.isRequired,
  icon: N.string.isRequired
};
Ee.defaultProps = {
  selected: !1,
  go: null,
  kind: "LeftNavLink",
  path: null,
  id: null,
  authorized: !0,
  title: null,
  icon: null
};
const ay = "_Link_eqbxr_1", oy = "_LinkText_eqbxr_8", iy = "_selected_eqbxr_12", Vn = {
  Link: ay,
  LinkText: oy,
  selected: iy
};
function k({
  associatedPaths: e,
  children: t,
  path: r,
  link: n,
  hidden: a,
  level: o,
  // This gets allocated by LeftNavContainer
  selected: i,
  authorized: s,
  go: c
}) {
  if (!s || a)
    return null;
  const u = o - 1, l = {
    paddingLeft: `${8 * u}px`,
    paddingTop: "4px",
    paddingBottom: "4px",
    marginTop: "0px",
    marginBottom: "0px",
    marginLeft: `${24 * u}px`,
    borderLeft: `1px solid ${$n.blackLighter6}`
  };
  return /* @__PURE__ */ d.jsx("div", { className: Vn.Link, style: o ? l : {}, children: /* @__PURE__ */ d.jsx("a", { href: n, onClick: c, "data-testid": `left-nav-sublink_${r}`, children: /* @__PURE__ */ d.jsx(ae, { className: `${Vn.LinkText} ${i ? Vn.selected : ""}`, children: t }) }) });
}
k.propTypes = {
  associatedPaths: N.array,
  go: N.func,
  kind: N.string,
  path: N.string.isRequired,
  link: N.string,
  hidden: N.bool,
  level: N.number,
  authorized: N.bool,
  selected: N.bool
};
k.defaultProps = {
  associatedPaths: [],
  go: null,
  kind: "LeftNavSubLink",
  authorized: !0,
  hidden: !1,
  level: null,
  path: null,
  selected: !1
};
const uu = de.get("reskin-lite", !1), lu = de.get("unify-beta", !1) || de.get("unify-beta-org", !1), sy = uu && lu, cy = de.get("active-issue-link", !1), uy = de.get("new-feature-link", !1), ly = de.get("developer", !1), dy = de.get("credit-portal-beta", !1), fy = de.get("risk-control-review-manager", !1), py = de.get("ach-program-funding-beta", !1), vy = de.get("bank-reporting", !1), my = de.get("data-marketplace", !1), zn = {
  reskinLite: uu,
  unifyBeta: lu,
  unifyBetaReskinLite: sy,
  activeIssueLink: cy,
  newFeatureLink: uy,
  developer: ly,
  creditPortalBeta: dy,
  riskControlReviewManager: fy,
  achProgramFundingBeta: py,
  bankReporting: vy,
  diDataCatalog: my
}, hy = "_L3Header_1d5ah_1", gy = "_L3HeaderText_1d5ah_5", _y = "_flexDiv_1d5ah_10", yy = {
  L3Header: hy,
  L3HeaderText: gy,
  flexDiv: _y
};
function Sy({ children: e }) {
  return /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsx(fr, { factor: 2 }),
    /* @__PURE__ */ d.jsxs("div", { className: yy.flexDiv, children: [
      /* @__PURE__ */ d.jsx(St, { factor: 2 }),
      /* @__PURE__ */ d.jsx(ae, { type: "label", children: "PROGRAM CONTROLS" })
    ] }),
    /* @__PURE__ */ d.jsx(fr, { factor: 2 })
  ] });
}
const by = [
  "/bin-management/bin",
  "/bin-management/range",
  "/bin-management/program"
], wy = [
  "/bin-data-management/range/create",
  "/bin-data-management/range/edit",
  "/bin-data-management/bin/create",
  "/bin-data-management/bin/edit",
  "/bin-data-management/bin",
  "/bin-data-management/range"
], Ay = [
  "/program/card-product",
  "/program/cards/new",
  "/program/card-products/bulk"
], Ey = [
  "/program/bulk-issuances",
  "/program/bulk-issuance/new",
  "/program/bulk-issuance"
], Ty = ["/program/card-order-and-shipment"], Ry = ["/program/providers"], Cy = ["/program/card-management-inventories"], Iy = ["/program/hsm-keys", "/program/hsm-keys/assign"], Oy = [
  "/bin-management",
  "/admin",
  "/admin/roles",
  "/admin/departments",
  "/program/ach-management",
  "/program/pin-reveal",
  "/program/3d-secure"
], xy = [
  "/program/user",
  "/program/card",
  "/program/digital-wallet-token",
  "/program/account"
], ky = [
  "/risk/dispute",
  "/risk/dispute/new",
  "/risk/disputes/bulk-upload"
], Py = [
  "/program/accountholder",
  "/program/accountholder/account",
  "/program/accountholder/cards",
  "/program/accountholder/card",
  "/program/accountholder/suspend",
  "/program/accountholder/terminate",
  "/program/accountholder/transaction",
  "/program/accountholder/activity",
  "/program/accountholder/account/activity",
  "/program/accountholder/card/activity"
], Ny = ["/settlement/approvals"], Ly = ["/settlement/exceptions"], Dy = [
  "/settlement/program-funding",
  "/settlement/program-funding/manual-entry",
  "/settlement/program-funding/bulk-entry"
], My = ["/program/commando-mode"], Uy = [
  "/credit/credit-products",
  "/credit/credit-product",
  "/credit/credit-products/create",
  "/credit/credit-products/rejected",
  "/credit/credit-products/history",
  "/credit/credit-products/activity"
], Fy = [
  "/credit",
  "/credit/policy-library",
  "/credit/policy-library/create",
  "/credit/policy-library/credit-products",
  "/credit/policy-library/credit-product",
  "/credit/policy-library/aprs",
  "/credit/policy-library/apr",
  "/credit/policy-library/fees",
  "/credit/policy-library/fee",
  "/credit/policy-library/rewards",
  "/credit/policy-library/offers"
], jy = ["/credit", "/credit/template-editor"], By = ["/credit/bundles", "/credit/bundles/create"], Vy = ["/credit/work-queue"], zy = ["/credit/approval-queue"], Hy = [
  "/credit/acquisition-offer",
  "/credit/acquisition-offers",
  "/credit/acquisition-offers/create",
  "/credit/acquisition-offers/history"
], Gy = [
  "/credit/account",
  "/credit/accounts",
  "/credit/account/card"
], $y = ["/credit/templates"], qy = [
  "/admin",
  "/admin/roles",
  "/admin/departments",
  "/admin/supplements"
], Ky = [
  "/accepted-countries",
  "/accepted-countries/new",
  "/accepted-countries/:token"
], Wy = [
  "/application-tokens",
  "/application-tokens/application",
  "/application-tokens/standard-token"
], Yy = ["/approval-queue", "/approval-queue/:token"], Xy = [
  "/card-products",
  "/card-products/new",
  "/card-products/:token"
], Jy = ["/mcc-groups", "/mcc-groups/new", "/mcc-groups/:token"], Zy = ["/program-controls", "/program-controls/:shortcode"], Qy = ["/data-catalog", "/data-catalog/product"];
function eS(e) {
  window.location.href = e;
}
function tS() {
  return !0;
}
function Kb({
  currentPath: e = window.location.pathname,
  verifier: t = tS,
  go: r = eS
} = {}) {
  const n = Oy.some(t);
  return /* @__PURE__ */ d.jsxs(ty, { currentPath: e, verifier: t, go: r, children: [
    /* @__PURE__ */ d.jsx(Ee, { title: "Home", icon: "side-bar-home", path: "/home" }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Reports", icon: "side-bar-reports", path: "/reports", children: [
      /* @__PURE__ */ d.jsx(k, { path: "/reports/guide", associatedPaths: ["/reports/guide"], children: "Reports guide" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/reports/data-dictionary",
          associatedPaths: ["/reports/data-dictionary"],
          children: "Data dictionary"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          hidden: !zn.diDataCatalog,
          path: "/data-catalog",
          associatedPaths: Qy,
          children: "Data Marketplace"
        }
      )
    ] }),
    /* @__PURE__ */ d.jsx(
      Ee,
      {
        title: "Digital wallet",
        icon: "side-bar-digital-wallet",
        path: "/program/token-service",
        associatedPaths: ["/program/token-service/token"]
      }
    ),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Card management", icon: "side-bar-card-management", id: "/card-management", children: [
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/card-products",
          associatedPaths: Ay,
          children: "Card products"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/bulk-issuances",
          associatedPaths: Ey,
          children: "Bulk issuance"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/program/providers", associatedPaths: Ry, children: "Providers" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/card-management-inventories",
          associatedPaths: Cy,
          children: "Inventory management"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/card-order-and-shipment",
          associatedPaths: Ty,
          children: "Card order and shipment report"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/program/hsm-keys", associatedPaths: Iy, children: "HSM keys" })
    ] }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Customers", icon: "side-bar-customers", id: "/customers", children: [
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/accountholders",
          associatedPaths: Py,
          children: "Account holders"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/program/users", associatedPaths: xy, children: "Users" }),
      /* @__PURE__ */ d.jsx(k, { path: "/program/businesses", associatedPaths: ["/program/business"], children: "Businesses" })
    ] }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "RiskControl", icon: "side-bar-control-plane", id: "/control-plane", children: [
      /* @__PURE__ */ d.jsx(k, { path: "/risk/disputes", associatedPaths: ky, children: "Disputes" }),
      /* @__PURE__ */ d.jsx(k, { path: "/risk/bank-reporting", hidden: !zn.bankReporting, children: "Disputes bank reporting" }),
      /* @__PURE__ */ d.jsx(k, { path: "/risk/transaction-report?real-time-decisioning=v1", children: /* @__PURE__ */ d.jsx(po, { alignItems: "center", children: "Real-time decisioning   " }) }),
      /* @__PURE__ */ d.jsx(k, { path: "/risk/transaction-report?real-time-decisioning=v2", children: /* @__PURE__ */ d.jsx(po, { alignItems: "center", children: "Real-time decisioning dashboard   " }) }),
      /* @__PURE__ */ d.jsx(k, { path: "/risk/alerts", children: "Transaction alerts" }),
      /* @__PURE__ */ d.jsx(k, { path: "/risk/transaction-report", children: "Transaction review report" })
    ] }),
    /* @__PURE__ */ d.jsxs(
      Ee,
      {
        title: "Risk management",
        icon: "side-bar-fraud-prevention",
        path: "/risk/fraudstream/home",
        children: [
          /* @__PURE__ */ d.jsx(k, { path: "/risk/fraudstream/transactions", children: "Fraud transactions" }),
          /* @__PURE__ */ d.jsx(k, { path: "/risk/fraudstream/history", children: "Fraud history" }),
          /* @__PURE__ */ d.jsx(k, { path: "/risk/fraudstream/health", children: "Fraud health" }),
          /* @__PURE__ */ d.jsx(k, { path: "/risk/decision-manager", children: "Manual review" }),
          /* @__PURE__ */ d.jsx(k, { path: "/risk/case-management", children: "Case management" })
        ]
      }
    ),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Credit Programs", icon: "side-bar-credit", id: "/credit", children: [
      /* @__PURE__ */ d.jsx(k, { path: "/credit/welcome", hidden: !0, children: "Welcome" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/credit/template-editor",
          associatedPaths: jy,
          children: "Template editor"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/credit/policy-library",
          associatedPaths: Fy,
          children: "Policy library"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/credit/bundles", associatedPaths: By, children: "Bundles" }),
      /* @__PURE__ */ d.jsx(k, { path: "/credit/work-queue", associatedPaths: Vy, children: "Work queue" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/credit/approval-queue",
          associatedPaths: zy,
          children: "Approval queue"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/credit/credit-products",
          associatedPaths: Uy,
          children: "Credit products"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/credit/acquisition-offers",
          associatedPaths: Hy,
          children: "Offers"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          hidden: !zn.creditPortalBeta,
          path: "/credit/accounts",
          associatedPaths: Gy,
          children: "Account holders"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/credit/templates", associatedPaths: $y, children: "Templates" })
    ] }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Settlement", icon: "side-bar-settlements", id: "/settlement", children: [
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/settlement/exceptions",
          nestedAssociatedPaths: Ly,
          children: "Exceptions"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/settlement/approvals",
          nestedAssociatedPaths: Ny,
          children: "Approvals"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/settlement/program-funding",
          nestedAssociatedPaths: Dy,
          children: "Program funding"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/settlement/export-queue", children: "Export queue" })
    ] }),
    n && /* @__PURE__ */ d.jsx(Sy, { children: "PROGRAM CONTROLS" }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Development", icon: "side-bar-development", path: "/development", children: [
      /* @__PURE__ */ d.jsx(k, { path: "/development", children: "API keys" }),
      /* @__PURE__ */ d.jsx(k, { path: "/development/transaction-timeline", children: "Transaction timeline" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/development/webhooks",
          associatedPaths: ["/development/add-webhook", "/development/webhooks/show"],
          children: "Webhooks"
        }
      )
    ] }),
    /* @__PURE__ */ d.jsxs(Ee, { title: "Control center", icon: "side-bar-settings", id: "/control-center", children: [
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/commando-modes",
          associatedPaths: My,
          children: "Commando mode"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/bin-management", associatedPaths: by, children: "BIN Summary" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/bin-data-management",
          associatedPaths: wy,
          children: "BIN Data Management"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/admin", associatedPaths: qy, children: "User profiles" }),
      /* @__PURE__ */ d.jsx(k, { path: "/admin/sandbox-management", children: "Sandbox Management" }),
      /* @__PURE__ */ d.jsx(k, { path: "/audit-logs", children: "Audit logs" }),
      /* @__PURE__ */ d.jsx(k, { path: "/program/ach-management", children: "ACH management" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/program/ach-funding",
          associatedPaths: [
            "/program/ach-funding",
            "/program/ach-funding/transfer",
            "/program/ach-funding/transfer-funds"
          ],
          children: "ACH program funding"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/program/pin-reveal", children: "PIN reveal" }),
      /* @__PURE__ */ d.jsx(k, { path: "/program/3d-secure", children: "3D secure" }),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/accepted-countries",
          associatedPaths: Ky,
          children: "Accepted countries"
        }
      ),
      /* @__PURE__ */ d.jsx(
        k,
        {
          path: "/application-tokens",
          associatedPaths: Wy,
          children: "Application tokens"
        }
      ),
      /* @__PURE__ */ d.jsx(k, { path: "/approval-queue", associatedPaths: Yy, children: "Approval queue" }),
      /* @__PURE__ */ d.jsx(k, { path: "/card-products", associatedPaths: Xy, children: "Card products" }),
      /* @__PURE__ */ d.jsx(k, { path: "/mcc-groups", associatedPaths: Jy, children: "MCC groups" }),
      /* @__PURE__ */ d.jsx(k, { path: "/program-controls", associatedPaths: Zy, children: "Programs" })
    ] })
  ] });
}
const rS = "_DropdownToggleInputContainer_luw3x_1", nS = "_DropdownToggleInput_luw3x_1", aS = "_DropdownToggleInputText_luw3x_12", Hn = {
  DropdownToggleInputContainer: rS,
  DropdownToggleInput: nS,
  DropdownToggleInputText: aS
};
function Qa({
  reorderProgram: e,
  children: t,
  // props from select
  focused: r,
  onFocus: n,
  onKeyDown: a,
  onMouseDown: o
}) {
  const [i, s] = hr(!1), u = i || r ? $n.actionColor : $n.blackLighter2, l = () => {
    e(!0), n();
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: Hn.DropdownToggleInputContainer,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      children: /* @__PURE__ */ d.jsxs(
        "div",
        {
          className: Hn.DropdownToggleInput,
          "data-testid": "program_selector_dropdown",
          onClick: l,
          onKeyDown: a,
          onMouseDown: o,
          children: [
            /* @__PURE__ */ d.jsx(
              ae,
              {
                className: Hn.DropdownToggleInputText,
                color: u,
                type: "h5",
                testId: "program-name",
                children: t || "Select Program"
              }
            ),
            /* @__PURE__ */ d.jsx(St, { factor: 1 }),
            /* @__PURE__ */ d.jsx(et, { type: "caret-down", noHoverEffects: !0, overrideColor: u })
          ]
        }
      )
    }
  );
}
Qa.propTypes = {
  reorderProgram: N.func,
  onFocus: N.func,
  onKeyDown: N.func,
  onMouseDown: N.func
};
Qa.defaultProps = {
  reorderProgram: () => {
  },
  focused: !1,
  onFocus: () => {
  },
  onKeyDown: () => {
  },
  onMouseDown: () => {
  }
};
const oS = "_ProgramOptionContainer_1s3ay_1", iS = "_ProgramOption_1s3ay_1", sS = "_NoProgramOption_1s3ay_14", cS = "_ProgramSubOption_1s3ay_21", uS = "_ProgramSubOptionLink_1s3ay_29", lS = "_starContainer_1s3ay_41", dS = "_NoProgramOptionContainer_1s3ay_47", gt = {
  ProgramOptionContainer: oS,
  ProgramOption: iS,
  NoProgramOption: sS,
  ProgramSubOption: cS,
  ProgramSubOptionLink: uS,
  starContainer: lS,
  NoProgramOptionContainer: dS
};
function eo({
  program: e,
  selectActiveProgram: t,
  toggleFavoriteProgram: r,
  hideFavoriteProgramsIcons: n,
  ...a
}) {
  const { favorite: o, program: i, short_name: s } = e, [c, u] = hr(!1), l = () => c && !o ? "hover" : o ? "full" : "empty";
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ...a,
      style: { height: "100%", width: "auto" },
      "data-testid": `program-list_${i}-row`,
      children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            className: gt.starContainer,
            "data-testid": `program-list_${i}-${l()}`,
            onMouseEnter: () => u(!0),
            onMouseLeave: () => u(!1),
            children: !n && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
              /* @__PURE__ */ d.jsx(
                et,
                {
                  type: `star-${l()}`,
                  noHoverEffects: !0,
                  onClick: () => r(e),
                  mod: "warning"
                }
              ),
              /* @__PURE__ */ d.jsx(St, { factor: 1 })
            ] })
          }
        ),
        /* @__PURE__ */ d.jsx(
          ae,
          {
            className: gt.ProgramOption,
            testId: `program-list_${i}-text`,
            onClick: () => t(e),
            children: i
          }
        ),
        /* @__PURE__ */ d.jsx(St, { factor: 2 })
      ]
    }
  );
}
eo.propTypes = {
  program: N.object,
  selectActiveProgram: N.func,
  toggleFavoriteProgram: N.func,
  hideFavoriteProgramsIcons: N.bool
};
eo.defaultProps = {
  program: {},
  selectActiveProgram: () => {
  },
  toggleFavoriteProgram: () => {
  }
};
const fS = () => {
  window.sessionStorage.setItem("accessToken", "gibberish");
  const e = vi.fn(() => Promise.resolve({ body: !0 })), t = vi.fn(() => Promise.resolve({ body: !0 }));
  return fetch.mockResponse((r) => {
    if (r.url.includes("/diva/security/users/redsea/logout"))
      return e();
    if (r.url.includes("/redsea/logout"))
      return t();
  }), { janusLogoutStub: e, redseaLogoutStub: t };
}, Wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setupLogOutStubs: fS
}, Symbol.toStringTag, { value: "Module" }));
function pS({ ...e }) {
  const t = Ct();
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ...e,
      className: e.className + " " + gt.NoProgramOptionContainer,
      "data-testid": "no-program-option",
      children: /* @__PURE__ */ d.jsx(
        ju,
        {
          text: /* @__PURE__ */ d.jsx(ae, { type: "p-lg", className: gt.NoProgramOption, children: "Something's gone wrong" }),
          subText: /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
            /* @__PURE__ */ d.jsx(ae, { className: gt.ProgramSubOption, type: "small", children: "To see your programs listed here," }),
            " ",
            /* @__PURE__ */ d.jsx(
              Bu,
              {
                className: gt.ProgramSubOptionLink,
                onClick: () => {
                  t();
                },
                inline: !0,
                inheritParentFont: !0,
                children: "sign out"
              }
            ),
            ",",
            " ",
            /* @__PURE__ */ d.jsx(ae, { className: gt.ProgramSubOption, type: "small", children: "and then sign back in." })
          ] })
        }
      )
    }
  );
}
function du({
  selectActiveProgram: e,
  toggleFavoriteProgram: t,
  hideFavoriteProgramsIcons: r,
  programs: n,
  activeProgram: a,
  reorderProgram: o,
  loading: i,
  width: s,
  marginLeft: c
}) {
  const u = le(() => typeof a == "string" ? a : a && a.program ? a.program : "", [a]), l = n && n.length > 4, f = !n, m = n ? n.length ? n.map((S, x) => {
    const { favorite: P, program: T, short_name: F } = S;
    return {
      val: F,
      searchString: `${T}${F}`,
      render: /* @__PURE__ */ d.jsx(
        eo,
        {
          program: S,
          selectActiveProgram: e,
          toggleFavoriteProgram: t,
          hideFavoriteProgramsIcons: r
        },
        x
      ),
      renderSelected: T
    };
  }) : [
    {
      val: null,
      render: /* @__PURE__ */ d.jsx(pS, {})
    }
  ] : [], g = {
    boxShadow: "0px 15px 30px rgba(25, 25, 25, 0.12), 0px 5px 15px rgba(25, 25, 25, 0.18), 0px 0px 1px rgba(25, 25, 25, 0.2)",
    marginLeft: c,
    ...n != null && n.length || n === null ? {} : { height: "103px" }
  };
  return /* @__PURE__ */ d.jsx(
    fi,
    {
      width: s,
      testId: "program-selector",
      dropdownToggleInputOverride: /* @__PURE__ */ d.jsx(Qa, { reorderProgram: o, children: u }),
      loading: i || f,
      disableOptionHandleBlur: !0,
      options: m,
      showSearch: l,
      dropDownWrap: g,
      disableOptionSearchClear: !0
    }
  );
}
du.propTypes = {
  selectActiveProgram: N.func,
  toggleFavoriteProgram: N.func,
  reorderProgram: N.func,
  programs: N.array,
  activeProgram: N.object,
  loading: N.bool,
  marginLeft: N.string,
  width: N.string
};
du.defaultProps = {
  selectActiveProgram: () => {
  },
  toggleFavoriteProgram: () => {
  },
  reorderProgram: () => {
  },
  programs: null,
  activeProgram: null,
  loading: !1,
  width: "100%"
};
const vS = {
  symbol: "",
  separator: ",",
  decimal: ".",
  precision: 2,
  pattern: "!#",
  negativePattern: "-!#",
  fromCents: !1,
  errorOnInvalid: !1,
  increment: null,
  useVedic: !1
};
function Yb(e, t = {}, r = !1) {
  let n = e;
  const a = typeof e == "object";
  return t === !0 && (r = !0, t = {}), a && ((typeof e.scale != "number" || e.scale < 0) && (e.scale = 2), t.precision = e.scale, t.fromCents = !0, n = e.units), n = Gu(n, Object.assign({}, vS, t)), r && (n = n.format()), n;
}
function Xb() {
  window.localStorage.clear(), window.fetch.resetMocks();
}
const to = {
  id: 4,
  first_name: "cheese",
  last_name: "olive",
  email: "colive@marqeta.com",
  json_web_token: 100,
  org_name: "Marqeta",
  role: "Admin",
  supplements: ["Stories", "Decision Manager", "Scheduler", "FraudStream"],
  programs: [{ program: "mqdm", short_name: "marqeta" }]
}, fu = [
  {
    org_name: "Marqeta",
    programs: [
      {
        program: "Honeydue",
        short_name: "hdue"
      },
      {
        program: "MasterCard Demo",
        short_name: "mqdm"
      },
      {
        program: "VISA Demo",
        short_name: "vdm"
      },
      {
        program: "Sales Demo",
        short_name: "psdm"
      },
      {
        program: "Passive",
        short_name: "pass"
      },
      {
        program: "Taco Bell",
        short_name: "taco"
      }
    ]
  }
], hn = (e = {}, t) => window.fetch.mockResponse((r) => {
  if (r.url.includes("/diva/security/users/redsea/authenticate") && (!t || t === 200)) {
    const n = {
      ...e
    };
    return Promise.resolve({
      body: JSON.stringify(n),
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  return r.url.includes("/diva/security/orgs/programs") ? Promise.resolve({
    body: JSON.stringify(fu),
    headers: {
      "Content-Type": "application/json"
    }
  }) : r.url.includes("/persist/gql") ? Promise.resolve("ok") : Promise.reject(new Error("Request failed with status code 500"));
}), mS = (e = {}, t = 200) => window.fetch.mockResponse((r) => {
  if (r.url.includes("/diva/security/users/redsea/logout"))
    return t === 200 ? Promise.resolve({
      body: JSON.stringify(e),
      headers: {
        "Content-Type": "application/json"
      }
    }) : Promise.reject(new Error("Request failed with status code 500"));
}), pu = (e = {}, t) => hn({ ...to, ...e }, t), hS = () => hn({}, 500), gS = (e = {}) => {
  const t = { ...to, role: "Viewer", ...e };
  return hn(t);
}, _S = () => hn({
  code: 400,
  message: "Failed to find user with email"
}), Jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authAdminUserMock: pu,
  authViewerUserMock: gS,
  defaultUserData: to,
  failedAuthenticateMock: hS,
  failedToFindUser: _S,
  janusPrograms: fu,
  logOutMock: mS
}, Symbol.toStringTag, { value: "Module" }));
function Zb() {
  let e;
  pu(), sessionStorage.setItem("accessToken", "gibberish"), typeof vi > "u" ? e = jest : e = vi, de.populate = e.fn().mockImplementation(() => ({
    message: "Successfully retrieved feature flag access information for current user.",
    data: {
      "unify-beta": !0,
      "developer-dashboard": !0,
      "transaction-trainer": !1,
      "card-inventory-beta": !1,
      "card-inventory-manager-beta": !1,
      "active-issue-link": !1,
      "new-feature-link": !0,
      "card-management-beta": !1,
      "kyb-access": !1,
      "combined-user-management": !1
    }
  }));
}
function vu(e = { testFeature: "test" }) {
  return {
    request: {
      query: Ga
    },
    result: {
      data: {
        applicationData: {
          json: JSON.stringify(e)
        }
      }
    }
  };
}
function mu(e = {}) {
  return {
    request: {
      query: Za
    },
    result: {
      data: {
        currentUser: {
          first_name: "something",
          last_name: "different",
          email: "it@exists.com",
          scopes: ["p:marqeta:marqeta-admin-internal"],
          roles: [
            {
              domain_type: "program",
              domain_id: "marqeta",
              role_token: "marqeta-admin-internal"
            }
          ],
          customer_token: null,
          token: null,
          phone: null,
          field_customer_token: null,
          ttl_in_seconds: null,
          active: !0,
          password_updated_time: null,
          failed_login_attempts: null,
          last_failed_login_attempt_time: null,
          last_signed_in_time: null,
          last_signed_in_ip_address: null,
          email_verified_time: null,
          email_opt_in: null,
          terms_of_service: null,
          hub_spot_sync_id: null,
          mfa_enabled: null,
          mfa_totp_enabled: null,
          mfa_totp_revealed: null,
          mfa_last_challenge_time: null,
          device_token: null,
          created_time: null,
          last_modified_time: null,
          ...e
        }
      }
    }
  };
}
function yS(e) {
  return function(r) {
    const { data: n, error: a, loaded: o, loadingFromApi: i, loadingFromLocalStorage: s } = za(), c = {
      data: o ? n : void 0,
      error: a || void 0,
      loading: !n && !a && !i && !s
    };
    return /* @__PURE__ */ d.jsx(e, { ...r, applicationData: c });
  };
}
const SS = () => se.removeItem(sn), bS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearLocalStorage: SS
}, Symbol.toStringTag, { value: "Module" }));
function Qb(e) {
  return function(r) {
    const n = Rt(), a = $e(
      (i) => {
        n({ type: Ar, payload: i });
      },
      [n]
    ), o = le(() => ({ ...bS, updateApplicationData: a }), [
      a
    ]);
    return /* @__PURE__ */ d.jsx(e, { ...r, applicationDataActions: o });
  };
}
function wS(e) {
  return function(r) {
    const { error: n, loaded: a } = ut.useContext(un), o = {
      loading: !a && !n,
      data: !n && a && de || void 0,
      error: !a && n || void 0
    };
    return /* @__PURE__ */ d.jsx(e, { ...r, flipFlop: o });
  };
}
function AS(e) {
  return function(r) {
    const {
      error: n,
      isLoggedIn: a,
      loadingFromApi: o,
      loadingFromLocalStorage: i,
      loadedFromLocalStorage: s,
      user: c
    } = Ke(), u = {
      data: a ? c : void 0,
      error: n || void 0,
      loading: o || i,
      loadedFromLocalStorage: s
    };
    return /* @__PURE__ */ d.jsx(e, { ...r, janusUser: u });
  };
}
function ES(e) {
  return function(r) {
    const {
      isLoggedIn: n,
      loadingFromApi: a,
      loadingFromLocalStorage: o,
      loadedFromLocalStorage: i,
      error: s,
      user: c
    } = ut.useContext(ln), u = {
      data: n ? c : void 0,
      error: s || void 0,
      loading: a || o || void 0,
      loadedFromLocalStorage: i
    };
    return /* @__PURE__ */ d.jsx(e, { ...r, redseaUser: u });
  };
}
function ew(e) {
  return function(r) {
    const [n, { data: a, error: o, loading: i }] = Uu(Kc, {
      onError: (l) => console.error(l)
    }), s = Wc();
    J(() => {
      a && a.updateCurrentUser && s(a.updateCurrentUser);
    }, [a, s]);
    const c = $e(() => [n, { data: a, loading: i, error: o }], [a, o, i, n]), u = le(() => ({ updateRedseaUser: c }), [c]);
    return /* @__PURE__ */ d.jsx(e, { ...r, redseaUserActions: u });
  };
}
function TS(e) {
  return function(r) {
    const { janusUser: n, redseaUser: a, flipFlop: o, applicationData: i } = r, s = !n.loading && !a.loading && !o.loading && !i.loading;
    return /* @__PURE__ */ d.jsx(e, { ...r, sessionIsBootstrapped: s });
  };
}
const RS = di(
  yS,
  wS,
  AS,
  ES,
  TS
), ro = {
  isLoading: !1,
  message: ""
};
function no(e, t) {
  const { type: r, payload: n } = t;
  switch (console.info(r, n), r) {
    case Ya:
      return {
        ...e,
        isLoading: !0,
        message: n
      };
    case zc:
      return {
        ...e,
        isLoading: !1,
        message: ""
      };
    default:
      throw new Error(`Reducer for: IsLoading does not support this action type: ${r}`);
  }
}
const tw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  initialState: ro,
  reducer: no
}, Symbol.toStringTag, { value: "Module" }));
function CS({ children: e }) {
  const [t, r] = st(no, ro);
  return /* @__PURE__ */ d.jsx(mn.Provider, { value: r, children: /* @__PURE__ */ d.jsx(vn.Provider, { value: t, children: e }) });
}
const IS = RS(
  ({ children: e, sessionIsBootstrapped: t }) => t ? e : null
);
function rw({ children: e, mocks: t, addTypename: r = !1 }) {
  J(() => {
    sessionStorage.setItem("accessToken", "fakeToken");
  });
  const n = [
    vu(),
    mu()
  ], a = t || n;
  return /* @__PURE__ */ d.jsx(
    $u,
    {
      mocks: a,
      addTypename: r,
      defaultOptions: {
        watchQuery: { fetchPolicy: "no-cache" },
        query: { fetchPolicy: "no-cache" }
      },
      children: /* @__PURE__ */ d.jsx(x_, { children: /* @__PURE__ */ d.jsx(CS, { children: /* @__PURE__ */ d.jsx(IS, { children: e }) }) })
    }
  );
}
const OS = vu({
  feature: "testFeature"
}), xS = mu({
  first_name: "something",
  last_name: "different",
  email: "it@exists.com",
  scopes: ["p:marqeta:marqeta-admin-internal"],
  roles: [
    {
      domain_type: "program",
      domain_id: "marqeta",
      role_token: "marqeta-admin-internal"
    }
  ]
});
function nw() {
  return {
    gqlMocks: [xS, OS]
  };
}
const kS = {
  customer_token: null,
  token: null,
  first_name: "something",
  last_name: "different",
  phone: "111-222-3333",
  email: "it@exists.com",
  field_customer_token: null,
  ttl_in_seconds: null,
  active: !0,
  has_additional_auth_factor: null,
  password_updated_time: null,
  failed_login_attempts: null,
  last_failed_login_attempt_time: null,
  last_signed_in_time: null,
  last_signed_in_ip_address: null,
  email_verified_time: null,
  email_opt_in: null,
  terms_of_service: null,
  hub_spot_sync_id: null,
  mfa_enabled: null,
  mfa_totp_enabled: null,
  mfa_totp_revealed: null,
  mfa_last_challenge_time: null,
  device_token: null,
  scopes: ["p:marqeta:marqeta-admin-internal"],
  roles: [
    {
      domain_type: "program",
      domain_id: "marqeta",
      role_token: "marqeta-admin-internal"
    }
  ],
  created_time: null,
  last_modified_time: null
}, aw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  redseaUser: kS
}, Symbol.toStringTag, { value: "Module" }));
function ow() {
  const { user: { redseaRoles: e } = {} } = qe();
  return le(() => e || [], [e]);
}
function ao() {
  const { user: { webToken: e } = {} } = Ke();
  return le(() => !!e, [e]);
}
function iw() {
  const e = fn();
  return le(
    () => ({
      loadJanusUser: (t) => e({ type: pn, payload: t })
    }),
    [e]
  );
}
const sw = () => {
  const e = Rt(), { data: t, error: r, loading: n } = da(Ga);
  J(() => {
    if (t && t.applicationData)
      try {
        const a = JSON.parse(t.applicationData.json);
        cn(a), e({ type: Ar, payload: a });
      } catch (a) {
        console.error(`No Application Data for logged in user: ${a}`);
      }
  }, [t, e]), J(() => {
    e(n ? { type: Ha } : { type: pc });
  }, [e, n]), J(() => {
    r && (console.error(r), e({ type: on, payload: r }));
  }, [e, r]);
}, PS = ({ children: e }) => {
  const [t, r] = st(no, ro);
  return /* @__PURE__ */ d.jsx(vn.Provider, { value: t, children: /* @__PURE__ */ d.jsx(mn.Provider, { value: r, children: e }) });
}, cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IsLoadingTestWrapper: PS
}, Symbol.toStringTag, { value: "Module" }));
function uw(e) {
  return function(r) {
    const n = Xa(), a = le(
      () => ({
        setLoading: (o) => n({ type: Ya, payload: o }),
        stopLoading: () => n({ type: zc })
      }),
      [n]
    );
    return /* @__PURE__ */ d.jsx(e, { ...r, isLoadingActions: a });
  };
}
const NS = () => ({
  get: () => !1
});
function oo() {
  const { error: e } = yc();
  return e ? NS : de;
}
function lw() {
  const e = oo();
  return e.get("unify-beta", !1) || e.get("unify-beta-org", !1);
}
function LS() {
  const e = oo();
  return $e(
    (t, r = !1) => e.get(t, r),
    [e]
  );
}
function dw(e) {
  return function(r) {
    const n = LS();
    return /* @__PURE__ */ d.jsx(e, { ...r, flipFlopFlag: n });
  };
}
const He = {
  rootRedirect: {
    path: "/",
    name: "Root Redirect",
    view: null
  },
  applicationReset: {
    path: "/application-reset",
    name: "Application Reset",
    view: null
  },
  home: {
    path: "/home",
    name: "Home",
    view: null
  },
  admin: {
    path: "/admin",
    name: "Admin",
    view: null
  },
  adminRoles: {
    path: "/admin/roles",
    name: "Roles",
    view: null
  },
  adminDepartments: {
    path: "/admin/departments",
    name: "Departments",
    view: null
  },
  adminSupplements: {
    path: "/admin/supplements",
    name: "Supplements",
    view: null
  },
  adminConfigManagement: {
    path: "/admin/config-management",
    name: "Config management",
    view: null
  },
  adminSandboxesManagement: {
    path: "/admin/sandbox-management",
    name: "Sandbox management",
    view: null
  },
  apiAccess: {
    path: "/api-access",
    name: "Api Access",
    view: null
  },
  auditLogs: {
    path: "/audit-logs",
    name: "Audit logs",
    view: null
  },
  authCallback: {
    path: "/auth-callback",
    name: "Auth Callback"
  },
  authError: {
    path: "/auth-error",
    name: "Auth Error"
  },
  binDataManagement: {
    path: "/bin-data-management",
    name: "Bin Data Management",
    view: null
  },
  binDataManagementCreateBin: {
    path: "/bin-data-management/bin/create",
    name: "Bin Data Management Create Bin",
    view: null
  },
  binDataManagementUpdateBin: {
    path: "/bin-data-management/bin/edit",
    name: "Bin Data Management Update Bin",
    view: null
  },
  binDataManagementDetailsBin: {
    path: "/bin-data-management/bin",
    name: "Bin Data Management Bin Page",
    view: null
  },
  binDataManagementDetailsRange: {
    path: "/bin-data-management/range",
    name: "Bin Data Management Range Page",
    view: null
  },
  binDataManagementUpdateRange: {
    path: "/bin-data-management/range/edit",
    name: "Bin Data Management Update Page",
    view: null
  },
  binDataManagementCreateRange: {
    path: "/bin-data-management/range/create",
    name: "Bin Data Management Create Range",
    view: null
  },
  binManagement: {
    path: "/bin-management",
    name: "Bin Management",
    view: null
  },
  binManagementBinView: {
    path: "/bin-management/bin",
    name: "Bin Management Bin View",
    view: null
  },
  binManagementRangeView: {
    path: "/bin-management/range",
    name: "Bin Management Range View",
    view: null
  },
  binManagementProgramView: {
    path: "/bin-management/program",
    name: "Bin Management Program View",
    view: null
  },
  contactCS: {
    path: "/contact-customer-success",
    name: "Contact Customer Success",
    view: null
  },
  development: {
    path: "/development",
    name: "Development",
    view: null
  },
  developmentTransactionTimeline: {
    path: "/development/transaction-timeline",
    name: "TransactionTimeline",
    view: null
  },
  notFoundView: {
    path: "/not-found",
    name: "Not Found",
    view: null
  },
  fraudstream: {
    path: "/fraudstream",
    name: "FraudStream",
    view: null
  },
  reports: {
    path: "/reports",
    name: "Reports",
    view: null
  },
  reportsDataDictionary: {
    path: "/reports/data-dictionary",
    name: "Reports Data Dictionary",
    view: null
  },
  reportsGuide: {
    path: "/reports/guide",
    name: "Reports Guide",
    view: null
  },
  diDataCatalog: {
    path: "/data-catalog",
    name: "Data Marketplace",
    view: null
  },
  credit: {
    path: "/credit",
    name: "Credit",
    view: null
  },
  creditTemplateEditor: {
    path: "/credit/template-editor",
    name: "Credit Template Editor",
    view: null
  },
  creditWelcome: {
    path: "/credit/welcome",
    name: "Credit Welcome",
    view: null
  },
  creditBundle: {
    path: "/credit/bundle",
    name: "Credit Bundle",
    view: null
  },
  creditBundles: {
    path: "/credit/bundles",
    name: "Credit Bundles",
    view: null
  },
  creditBundlesCreate: {
    path: "/credit/bundles/create",
    name: "Credit Bundles Create",
    view: null
  },
  creditPolicyCreate: {
    path: "/credit/policy-library/create",
    name: "Policy Create",
    view: null
  },
  creditPolicyLibrary: {
    path: "/credit/policy-library",
    name: "Policy Library",
    view: null
  },
  creditPolicyLibraryCreditProductsDashboard: {
    path: "/credit/policy-library/credit-products",
    name: "Policy Library Credit Products Dashboard",
    view: null
  },
  creditPolicyLibraryCreditProduct: {
    path: "/credit/policy-library/credit-product",
    name: "Policy Library Credit Product",
    view: null
  },
  creditPolicyLibraryAPRsDashboard: {
    path: "/credit/policy-library/aprs",
    name: "Policy Library APRs Dashboard",
    view: null
  },
  creditPolicyLibraryAPR: {
    path: "/credit/policy-library/apr",
    name: "Policy Library APR",
    view: null
  },
  creditPolicyLibraryFeesDashboard: {
    path: "/credit/policy-library/fees",
    name: "Policy Library Fees Dashboard",
    view: null
  },
  creditPolicyLibraryFee: {
    path: "/credit/policy-library/fee",
    name: "Policy Library Fee",
    view: null
  },
  creditPolicyLibraryRewardsDashboard: {
    path: "/credit/policy-library/rewards",
    name: "Policy Library Rewards Dashboard",
    view: null
  },
  creditPolicyLibraryReward: {
    path: "/credit/policy-library/reward",
    name: "Policy Library Reward",
    view: null
  },
  creditPolicyLibraryOffersDashboard: {
    path: "/credit/policy-library/offers",
    name: "Policy Library Offers Dashboard",
    view: null
  },
  creditBundleWorkQueue: {
    path: "/credit/work-queue",
    name: "Work Queue",
    view: null
  },
  creditProductApprovalQueue: {
    path: "/credit/approval-queue",
    name: "Approval Queue",
    view: null
  },
  creditProducts: {
    path: "/credit/credit-products",
    name: "Credit Products",
    view: null
  },
  creditProductsRejected: {
    path: "/credit/credit-products/rejected",
    name: "Credit Products Rejected",
    view: null
  },
  creditProduct: {
    path: "/credit/credit-product",
    name: "Credit Product",
    view: null
  },
  creditProductsActivity: {
    path: "/credit/credit-products/activity",
    name: "Credit Product Activity",
    view: null
  },
  creditProductsHistory: {
    path: "/credit/credit-products/history",
    name: "Credit Products History",
    view: null
  },
  creditProductCreate: {
    path: "/credit/credit-products/create",
    name: "Credit Product Create",
    view: null
  },
  creditOffers: {
    path: "/credit/acquisition-offers",
    name: "Offers",
    view: null
  },
  creditOffersHistory: {
    path: "/credit/acquisition-offers/history",
    name: "Credit Offers History",
    view: null
  },
  creditOffer: {
    path: "/credit/acquisition-offer",
    name: "Offer",
    view: null
  },
  creditOfferCreate: {
    path: "/credit/acquisition-offers/create",
    name: "Offer Create",
    view: null
  },
  creditAccounts: {
    path: "/credit/accounts",
    name: "Credit account holders",
    view: null
  },
  creditUsers: {
    path: "/credit/users",
    name: "Credit users",
    view: null
  },
  creditUser: {
    path: "/credit/user",
    name: "Credit user",
    view: null
  },
  creditAccountSubstatus: {
    path: "/credit/account/substatus",
    name: "Credit account substatus",
    view: null
  },
  creditAccount: {
    path: "/credit/account",
    name: "Credit Account",
    view: null
  },
  creditAccountCard: {
    path: "/credit/account/card",
    name: "Credit Account Card",
    view: null
  },
  creditDigitalWalletToken: {
    path: "/credit/digital-wallet-token",
    name: "Credit digital wallet token",
    view: null
  },
  creditAccountPaymentInitiation: {
    path: "/credit/account/payment-initiation",
    name: "Credit Account Payment Initiation",
    view: null
  },
  creditAccountPaymentDetails: {
    path: "/credit/account/payment-details",
    name: "Credit Account Payment Details",
    view: null
  },
  creditPaymentSourceDetails: {
    path: "/credit/account/payment-source-details",
    name: "Credit Payment Source Details",
    view: null
  },
  creditAccountPaymentAccount: {
    path: "/credit/account/payment-account-management",
    name: "Credit Payment Accounts Management",
    view: null
  },
  creditAccountStatementDetails: {
    path: "/credit/account/statement-details",
    name: "Credit Account Statement Details",
    view: null
  },
  creditAccountTransactionDetails: {
    path: "/credit/account/transactions",
    name: "Credit Account Transaction Details",
    view: null
  },
  creditTemplates: {
    path: "/credit/templates",
    name: "Credit Templates",
    view: null
  },
  tokenization: {
    path: "/program/token-service",
    name: "Digital wallet",
    view: null
  },
  tokenizationDetail: {
    path: "/program/token-service/token",
    name: "Digital wallet detail",
    view: null
  },
  scheduler: {
    path: "/schedule",
    name: "Scheduler",
    view: null
  },
  stories: {
    path: "/stories",
    name: "Stories",
    view: null
  },
  tester: {
    path: "/tester",
    name: "Tester",
    view: null
  },
  userProfile: {
    path: "/user-profile",
    name: "User Profile",
    view: null
  },
  userActivityLogs: {
    path: "/user-activity-logs",
    name: "User Activity Logs",
    view: null
  },
  userProfileSecuritySettings: {
    path: "/user-profile/security-settings",
    name: "User Profile Security Settings",
    view: null
  },
  userProfilePermissions: {
    path: "/user-profile/permissions",
    name: "User Profile Permissions",
    view: null
  },
  program: {
    path: "/program",
    name: "Program",
    view: null
  },
  programCommandoModes: {
    path: "/program/commando-modes",
    name: "Commando modes",
    view: null
  },
  programCommandoMode: {
    path: "/program/commando-mode",
    name: "Commando mode",
    view: null
  },
  programBusinesses: {
    path: "/program/businesses",
    name: "Businesses",
    view: null
  },
  programAccountholders: {
    path: "/program/accountholders",
    name: "Program account holders",
    view: null
  },
  programAchFunding: {
    path: "/program/ach-funding",
    name: "Program ach funding",
    view: null
  },
  programAchFundingTransfer: {
    path: "/program/ach-funding/transfer",
    name: "Program ach funding transfer",
    view: null
  },
  programAchFundingTransferFunds: {
    path: "/program/ach-funding/transfer-funds",
    name: "Program ach funding transfer funds",
    view: null
  },
  programCardholders: {
    path: "/program/users",
    name: "Users",
    view: null
  },
  programCardCreation: {
    path: "/program/cards/new",
    name: "Card creation",
    view: null
  },
  programCardProducts: {
    path: "/program/card-products",
    name: "Card products",
    view: null
  },
  programCardProduct: {
    path: "/program/card-product",
    name: "Card product",
    view: null
  },
  programBulkCardProducts: {
    path: "/program/card-products/bulk",
    name: "Bulk card products",
    view: null
  },
  programBulkIssuance: {
    path: "/program/bulk-issuances",
    name: "Bulk-issuance card products",
    view: null
  },
  programCardManagementProviders: {
    path: "/program/providers",
    name: "Card management providers",
    view: null
  },
  programCardManagementInventory: {
    path: "/program/card-management-inventories",
    name: "Card management inventory",
    view: null
  },
  programBulkIssuanceDetail: {
    path: "/program/bulk-issuance",
    name: "Bulk-issuances detail",
    view: null
  },
  programBulkIssuanceCreate: {
    path: "/program/bulk-issuance/new",
    name: "Bulk-issuances creation",
    view: null
  },
  programBusiness: {
    path: "/program/business",
    name: "Business",
    view: null
  },
  programCardholder: {
    path: "/program/user",
    name: "User",
    view: null
  },
  programCardholderAccount: {
    path: "/program/account",
    name: "User's account",
    view: null
  },
  programAccountholder: {
    path: "/program/accountholder",
    name: "Program account holder",
    view: null
  },
  programAccountholderAccount: {
    path: "/program/accountholder/account",
    name: "Program account holder's account",
    view: null
  },
  programAccountholderCards: {
    path: "/program/accountholder/cards",
    name: "Program account holder cards",
    view: null
  },
  programAccountholderCard: {
    path: "/program/accountholder/card",
    name: "Program account holder's card",
    view: null
  },
  programAccountholderActivate: {
    path: "/program/accountholder/activate",
    name: "Program account holder activate",
    view: null
  },
  programAccountholderSuspend: {
    path: "/program/accountholder/suspend",
    name: "Program account holder suspend",
    view: null
  },
  programAccountholderTerminate: {
    path: "/program/accountholder/terminate",
    name: "Program account holder terminate",
    view: null
  },
  programAccountholderTransaction: {
    path: "/program/accountholder/transaction",
    name: "Program account holder's transaction details",
    view: null
  },
  programCard: {
    path: "/program/card",
    name: "Card",
    view: null
  },
  programDigitalWalletToken: {
    path: "/program/digital-wallet-token",
    name: "Digital wallet token",
    view: null
  },
  pinReveal: {
    path: "/program/pin-reveal",
    name: "PIN reveal",
    view: null
  },
  programBalance: {
    path: "/program/program-balance",
    name: "Program balance",
    view: null
  },
  programInventoryCardPackages: {
    path: "/program/inventory/card-packages",
    name: "Inventory card packages",
    view: null
  },
  programInventoryOrderSummary: {
    path: "/program/inventory/order-summary",
    name: "Inventory order summary",
    view: null
  },
  programInventorySku: {
    path: "/program/inventory/sku",
    name: "Inventory SKU",
    view: null
  },
  programCardOrderAndShipment: {
    path: "/program/card-order-and-shipment",
    name: "Card order and shipment",
    view: null
  },
  programHSMKeys: {
    path: "/program/hsm-keys",
    name: "HSM keys",
    view: null
  },
  programAssignHSMKeys: {
    path: "/program/hsm-keys/assign",
    name: "Assign HSM keys",
    view: null
  },
  programProviders: {
    path: "/program/vendor-catalog/providers",
    name: "Provider catalog",
    view: null
  },
  programProvider: {
    path: "/program/vendor-catalog/provider",
    name: "Provider",
    view: null
  },
  programProviderCreate: {
    path: "/program/vendor-catalog/provider/create",
    name: "Provider create",
    view: null
  },
  programSkus: {
    path: "/program/vendor-catalog/skus",
    name: "SKU catalog",
    view: null
  },
  programSku: {
    path: "/program/vendor-catalog/sku",
    name: "SKU",
    view: null
  },
  programSkuCreate: {
    path: "/program/vendor-catalog/sku/create",
    name: "SKU create",
    view: null
  },
  programCardPackages: {
    path: "/program/vendor-catalog/card-packages",
    name: "Card package catalog",
    view: null
  },
  programCardPackage: {
    path: "/program/vendor-catalog/card-package",
    name: "Card package",
    view: null
  },
  programCardPackageCreate: {
    path: "/program/vendor-catalog/card-package/create",
    name: "Card package create"
  },
  programReviewDetails: {
    path: "/risk/review-details",
    name: "Review details",
    view: null
  },
  risk: {
    path: "/risk",
    name: "Risk",
    view: null
  },
  riskAlerts: {
    path: "/risk/alerts",
    name: "Transaction alerts",
    view: null
  },
  riskDecisionManager: {
    path: "/risk/decision-manager",
    name: "Decision manager",
    view: null
  },
  riskDisputes: {
    path: "/risk/disputes",
    name: "Disputes",
    view: null
  },
  riskBulkUpload: {
    path: "/risk/disputes/bulk-upload",
    name: "Bulk upload",
    view: null
  },
  riskDispute: {
    path: "/risk/dispute",
    name: "Dispute details",
    view: null
  },
  riskNewDispute: {
    path: "/risk/dispute/new",
    name: "Create dispute",
    view: null
  },
  riskBankReporting: {
    path: "/risk/bank-reporting",
    name: "Disputes bank reporting",
    view: null
  },
  riskFraudStream: {
    path: "/risk/fraudstream",
    name: "FraudStream",
    view: null
  },
  riskFraudStreamTransactions: {
    path: "/risk/fraudstream/transactions",
    name: "FraudStream transactions",
    view: null
  },
  riskFraudStreamPolicy: {
    path: "/risk/fraudstream/home/policy",
    name: "FraudStream policy",
    view: null
  },
  riskFraudStreamHealth: {
    path: "/risk/fraudstream/health",
    name: "FraudStream health",
    view: null
  },
  riskFraudStreamHistory: {
    path: "/risk/fraudstream/history",
    name: "FraudStream history",
    view: null
  },
  riskFraudStreamHome: {
    path: "/risk/fraudstream/home",
    name: "FraudStream home",
    view: null
  },
  riskCaseManagement: {
    path: "/risk/case-management",
    name: "Case management",
    view: null
  },
  riskRealTimeDecisioning: {
    path: "/risk/transaction-report?real-time-decisioning=v1",
    name: "Real-time decisioning",
    view: null
  },
  riskRealTimeDecisioningDashboard: {
    path: "/risk/transaction-report?real-time-decisioning=v2",
    name: "Real-time decisioning",
    view: null
  },
  riskTransactionReport: {
    path: "/risk/transaction-report",
    name: "Transaction review report",
    view: null
  },
  threeDS: {
    path: "/program/3d-secure",
    name: "3D secure",
    view: null
  },
  directDeposit: {
    path: "/program/direct-deposit",
    name: "Direct deposit",
    view: null
  },
  achManagement: {
    path: "/program/ach-management",
    name: "ACH management",
    view: null
  }
};
Object.keys(He).forEach((e) => {
  He[e].id = e;
});
function fw(e) {
  if (typeof e == "object" && e.path)
    Gn(e);
  else if (typeof e == "object")
    for (const t in e) {
      const r = e[t];
      r.id || (r.id = t), Gn(r);
    }
  else
    e instanceof Array && e.forEach(Gn);
  return He;
}
function Gn(e = {}) {
  return He[e.id] && console.warn(`Skipped. Route ${e.id} already exists.`), He[e.id] = e, He;
}
const DS = {};
Object.keys(He).forEach((e) => {
  const t = He[e];
  DS[t.path] = t;
});
function qr(e) {
  return He[e] ? He[e].path : e;
}
function MS(e) {
  const t = qr(e);
  window.location.assign(t);
}
function la(e, { currentPath: t = window.location.pathname, matchChildren: r = !1 } = {}) {
  const n = qr(e);
  return t = qr(t), r ? n === t : oi(t) === oi(n);
}
function oi(e) {
  return e.split("/")[e[0] === "/" ? 1 : 0];
}
const Ft = {}, sr = {
  go: MS,
  isRouteActive: la
}, ii = {
  string: "",
  number: 0,
  boolean: !1
};
Object.keys(sr).forEach((e) => {
  const t = typeof sr[e];
  Object.defineProperty(Ft, e, {
    get() {
      return Ft["_" + e] || sr[e];
    },
    set(r) {
      if (typeof r != typeof sr[e])
        return console.warn(
          `WARNING: Cannot set \`${e}\` in voltConfig. It needs to be type: ${typeof sr[e]}`
        ), !1;
      Ft["_" + e] = r;
    }
  }), Ft["_" + e] = ii[t] ? ii[t] : null;
});
const US = "_header_154zn_6", FS = "_sidebar_154zn_16", jS = "_main_154zn_21", BS = "_search_154zn_31", VS = "_seperator_154zn_38", zS = "_links_154zn_47", HS = "_link_154zn_47", gn = {
  header: US,
  sidebar: FS,
  main: jS,
  search: BS,
  seperator: VS,
  links: zS,
  link: HS
};
function hu({ active: e }) {
  return e ? /* @__PURE__ */ d.jsx(
    "div",
    {
      className: gn.link,
      onClick: () => {
        window.open(
          "https://marqeta-notifications.s3.amazonaws.com/active-issue.html",
          "newwindow",
          "width=780, height=700, titlebar=no, location=no, menubar=no"
        );
      },
      children: /* @__PURE__ */ d.jsx(ae, { mod: "error semi-bold", children: "Active Issue" })
    }
  ) : null;
}
hu.propTypes = {};
hu.defaultProps = {};
const GS = (e) => (window.env && window.env.DOCS_URL ? window.env.DOCS_URL : window.hostname === "app.marqeta.com" ? "https://www.marqeta.com/docs" : "https://www-qa.marqeta.com/docs") + (e ? "/developer-guides/dashboard-overview-and-quick-start" : "");
function pw() {
  const e = ao(), t = e ? "User guides" : "Docs";
  return /* @__PURE__ */ d.jsx(pi, { content: t, direction: "bottom", width: e ? 112 : 67, children: /* @__PURE__ */ d.jsx(
    "a",
    {
      id: "docs-link",
      target: "_blank",
      rel: "noopener noreferrer",
      href: GS(e),
      className: gn.link,
      "data-testid": "docs-link",
      children: /* @__PURE__ */ d.jsx(et, { type: "docs-24" })
    }
  ) });
}
function vw() {
  const e = ao(), n = e ? "mailto:support@marqeta.com?subject=Support%20needed%20for%20Marqeta%20Dashboard" : "https://community.marqeta.com/t5/discussions/bd-p/discussions";
  return /* @__PURE__ */ d.jsx("span", { className: gn.link, children: /* @__PURE__ */ d.jsx(
    "a",
    {
      id: "feedback-link",
      target: "_blank",
      rel: "noopener noreferrer",
      href: n,
      "data-testid": "feedback-link",
      children: /* @__PURE__ */ d.jsx(pi, { content: e ? "Support" : "Community", direction: "bottom", children: /* @__PURE__ */ d.jsx(et, { type: "help-24" }) })
    }
  ) });
}
function gu({ active: e }) {
  return e ? /* @__PURE__ */ d.jsx(
    "div",
    {
      className: gn.link,
      onClick: () => {
        window.open(
          "https://marqeta-notifications.s3.amazonaws.com/update.html",
          "newwindow",
          "width=780, height=700, titlebar=no, location=no, menubar=no"
        );
      },
      children: /* @__PURE__ */ d.jsx(ae, { mod: "success semi-bold", children: "Product Update!" })
    }
  ) : null;
}
gu.propTypes = {};
gu.defaultProps = {};
function si(e) {
  const { children: t, to: r } = e, n = qr(r), a = (o) => {
    typeof Ft._go == "function" && (o.preventDefault(), Ft._go(n)), typeof e.onClick == "function" && e.onClick(o);
  };
  return /* @__PURE__ */ d.jsx("a", { href: n, onClick: a, ...e, children: t });
}
const $S = "_userInfo_m8r4l_1", qS = "_dropdownLinks_m8r4l_5", KS = "_dropdownLink_m8r4l_5", WS = "_active_m8r4l_26", YS = "_cfnSection_m8r4l_40", ot = {
  userInfo: $S,
  dropdownLinks: qS,
  dropdownLink: KS,
  active: WS,
  cfnSection: YS
};
function mw() {
  const e = Ct(), t = { marginTop: "14px", marginRight: "-4px" }, r = ao(), n = V_(), a = B_(), { user: { userOrgName: o, supplements: i } = {} } = Ke(), { user: { redseaRoles: s } = {} } = qe(), c = o && o === "Upgrade", u = oo(), l = u.get("upgrade-permissions", !1), f = u.get("cfn-beta", !1), p = (s == null ? void 0 : s.includes("no-reports")) || (i == null ? void 0 : i.includes("No Reports")), m = s == null ? void 0 : s.includes("aux-view-diva-api-access"), g = () => l ? !(c && !m) : !0, S = () => g() && !p;
  return /* @__PURE__ */ d.jsx(
    Vu,
    {
      control: /* @__PURE__ */ d.jsx("div", { id: "user-profile-link", children: /* @__PURE__ */ d.jsx(et, { type: "user-24" }) }),
      anchor: "right",
      contentPadding: 0,
      contentContainerStyle: t,
      withCaret: !0,
      testId: "user-profile-dropdown",
      children: /* @__PURE__ */ d.jsxs("div", { children: [
        n || a ? /* @__PURE__ */ d.jsxs("div", { className: ot.userInfo, children: [
          n && /* @__PURE__ */ d.jsx(ae, { type: "h6", children: n }),
          n && a && /* @__PURE__ */ d.jsx(fr, { factor: 0.5 }),
          a && /* @__PURE__ */ d.jsx(ae, { children: a })
        ] }) : null,
        /* @__PURE__ */ d.jsx(vo, { factor: 0 }),
        r && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsxs("div", { className: ot.cfnSection, children: [
            /* @__PURE__ */ d.jsxs(ae, { children: [
              "You’re using the ",
              /* @__PURE__ */ d.jsx("br", {}),
              f ? "new" : "old",
              " dashboard view"
            ] }),
            /* @__PURE__ */ d.jsx(
              qu,
              {
                link: !0,
                style: { padding: 0, fontWeight: 600, fontFamily: "inherit" },
                onClick: () => Ku("cfn-beta", !f, !0),
                children: f ? "Revert to old view" : "Try out new view"
              }
            )
          ] }),
          /* @__PURE__ */ d.jsx(vo, { factor: 0 })
        ] }),
        /* @__PURE__ */ d.jsxs("div", { className: ot.dropdownLinks, "data-testid": "user-profile-link", children: [
          r && S() && /* @__PURE__ */ d.jsx(si, { to: "/api-access", "data-testid": "api-access-link", children: /* @__PURE__ */ d.jsx(
            "div",
            {
              className: `${ot.dropdownLink} ${la("/api-access") ? ot.active : ""}`,
              children: /* @__PURE__ */ d.jsx(ae, { type: "h6", children: "DiVA API access" })
            }
          ) }),
          /* @__PURE__ */ d.jsx(si, { to: "/user-profile", "data-testid": "edit-profile-link", children: /* @__PURE__ */ d.jsx(
            "div",
            {
              className: `${ot.dropdownLink} ${la("/user-profile") ? ot.active : ""}`,
              children: /* @__PURE__ */ d.jsx(ae, { type: "h6", children: "Edit profile" })
            }
          ) }),
          /* @__PURE__ */ d.jsx(
            "div",
            {
              className: ot.dropdownLink,
              onClick: () => e(!1),
              "data-testid": "user-profile-dropdown__signout",
              children: /* @__PURE__ */ d.jsx(ae, { type: "h6", children: "Sign out" })
            }
          )
        ] })
      ] })
    }
  );
}
const XS = "selectedActiveProgram", JS = "selectedEnvironment", ZS = () => {
  try {
    const e = se.getItem(XS);
    return e ? JSON.parse(e).short_name : "";
  } catch (e) {
    return console.warn(`Unable to read active program from localStorage ${e}`), null;
  }
}, QS = (e) => {
  const t = e.getContext();
  if (e.variables["x-marqeta-program-short-code"]) {
    const r = e.variables["x-marqeta-program-short-code"];
    return delete e.variables["x-marqeta-program-short-code"], r;
  } else if (t.shortCode)
    return t.shortCode;
}, eb = () => {
  try {
    return se.getItem(JS);
  } catch (e) {
    return console.warn(`Unable to read environment from localStorage ${e}`), null;
  }
};
function tb() {
  const e = de.get("app-api-proxy-beta", !1) && window.env.APP_API_URL || window.env.DATA_DOG_ENVIRONMENT !== "production" && window.env.APP_API_URL ? `${window.env.APP_API_URL}/graphql` : "/graphql";
  return new Wu({
    uri: e,
    request: (t) => {
      const r = QS(t) || ZS(), n = eb(), a = {
        "x-marqeta-access-token-type": "redsea",
        "x-marqeta-program-short-code": r,
        "x-marqeta-environment": n
      }, o = window.sessionStorage.getItem("accessToken");
      o && (a.authorization = `Bearer ${o}`), t.setContext({ headers: a });
    },
    credentials: "include"
  });
}
function hw(e) {
  return function(r) {
    const n = le(() => tb(), []), a = le(
      () => ({
        gqlClient: n,
        mutate: ({ mutate: o, fetchPolicy: i = "no-cache", variables: s }) => n.mutate({ mutate: o, fetchPolicy: i, variables: s })
      }),
      [n]
    );
    return /* @__PURE__ */ d.jsx(e, { ...r, gqlApi: a });
  };
}
function io() {
  const e = li(), t = Ct(null);
  return $e(() => {
    (async () => {
      try {
        const a = await uc(e);
        console.log("REDSEA gql token check", a), aa();
      } catch (a) {
        const o = `[DEBUG-AUTH] the following error was returned when checking redsea token: ${a}, logging out ts:${(/* @__PURE__ */ new Date()).toISOString()}`;
        console.warn(o);
        const i = new Error(o);
        Ze.addError(i, {
          source: "useRunRedseaTokenCheck"
        }), t();
      }
    })();
  }, [e, t]);
}
function rb() {
  J(() => (window.addEventListener("click", aa), () => window.removeEventListener("click", aa)), []);
}
function _u(e, t) {
  const r = Mu();
  J(() => {
    r.current = e;
  }, [e]), J(() => {
    function n() {
      r.current();
    }
    if (t !== null) {
      let a = setInterval(n, t);
      return () => clearInterval(a);
    }
  }, [t]);
}
const nb = be({}), yu = be(), Su = () => xe(yu);
function ab() {
  const e = li(), t = Ct(null);
  return $e(() => {
    (async () => {
      try {
        await uc(e);
      } catch (a) {
        const o = `[DEBUG-AUTH] the following error was returned when attempting to refreshing token when restarting session timer: ${a}, logging out ts:${(/* @__PURE__ */ new Date()).toISOString()}`, i = new Error(o);
        console.warn(o), Ze.addError(i, {
          source: "useRefreshRedseaToken"
        }), t();
      }
    })();
  }, [e]);
}
function ob() {
  const e = Su(), t = io(), r = ab(), n = le(() => 1e3 * Ur(1.5), []), a = $e(() => {
    const o = dc();
    console.log("activity timer run, seconds since last activity:", o), console.warn(
      `[DEBUG-AUTH] activity timer run, seconds since last activity: ${o} ts:${(/* @__PURE__ */ new Date()).toISOString()}`
    ), o >= Ur(15) ? (console.warn(
      `[DEBUG-AUTH] more than 15 minutes since activity, running redsea check ts:${(/* @__PURE__ */ new Date()).toISOString()}`
    ), t()) : o >= Ur(13.5) ? (console.warn(
      `[DEBUG-AUTH] more than 13.5 minutes, showing activity modal ts:${(/* @__PURE__ */ new Date()).toISOString()}`
    ), e({ type: Gr })) : o <= n && (console.warn(
      `[DEBUG-AUTH] less than 13.5 minutes since activity, starting redsea token refresh ts:${(/* @__PURE__ */ new Date()).toISOString()}`
    ), r());
  }, [e, n, t, r]);
  _u(a, n);
}
function ib() {
  const e = io(), t = dc(), r = Ur(15);
  t && t >= r && e(), rb(), ob();
}
function sb() {
  const [e, t] = hr(59), r = $e(() => t(e - 1), [e, t]);
  return _u(r, 1e3), e;
}
const cb = () => {
  const e = Su(), t = sb(), r = Ct(null), n = io(), a = () => {
    n(), e({ type: Gr });
  };
  return J(() => {
    t <= 0 && (r(), e({ type: Gr }));
  }, [t, r, e]), fc("lastAppActivity", a), /* @__PURE__ */ d.jsxs(
    zu,
    {
      type: "sm",
      heading: "Your session is about to end",
      buttonText: "Stay signed in",
      hideModal: a,
      showHideModalButton: !1,
      footerButtons: [
        /* @__PURE__ */ d.jsx(Hu, { onClick: a, children: "Stay signed in" }, "continue-session")
      ],
      children: [
        /* @__PURE__ */ d.jsx(ae, { children: "You've been inactive for a while. For your security," }),
        /* @__PURE__ */ d.jsx(ae, { children: "we'll automatically sign you out in approximately" }),
        /* @__PURE__ */ d.jsx(ae, { children: "one minute." })
      ]
    }
  );
}, ub = {
  showActivityModal: !1
};
function lb(e, t) {
  const { type: r, payload: n } = t;
  switch (console.info(r, n), r) {
    case Gr:
      return {
        ...e,
        showActivityModal: !e.showActivityModal
      };
    default:
      throw new Error(`Reducer for: ActivityMonitor does not support this action type: ${r}`);
  }
}
const db = () => (ib(), null), gw = () => {
  const [e, t] = st(lb, ub), { showActivityModal: r } = e;
  return /* @__PURE__ */ d.jsx(nb.Provider, { value: e, children: /* @__PURE__ */ d.jsx(yu.Provider, { value: t, children: r ? /* @__PURE__ */ d.jsx(cb, {}) : /* @__PURE__ */ d.jsx(db, {}) }) });
}, fb = "_progressBar_458sw_1", pb = "_barOnTop_458sw_12", vb = "_barHide_458sw_16", mb = "_barPercent_458sw_22", Lr = {
  progressBar: fb,
  barOnTop: pb,
  barHide: vb,
  barPercent: mb
};
class bu extends ut.PureComponent {
  constructor(t) {
    super(t), this.state = {
      percent: this.props.percent
    }, this.handleProps = this.handleProps.bind(this), this.increment = this.increment.bind(this);
  }
  componentDidMount() {
    this.handleProps(this.props);
  }
  componentDidUpdate(t) {
    this.interval && clearInterval(this.interval), this.timeout && clearTimeout(this.timeout), this.handleProps(t);
  }
  componentWillUnmount() {
    this.interval && clearInterval(this.interval), this.timeout && clearTimeout(this.timeout);
  }
  increment() {
    let { percent: t } = this.state;
    t += Math.random() + 1 - Math.random(), t = t < 99 ? t : 99, this.setState({
      percent: t
    });
  }
  handleProps(t) {
    const { autoIncrement: r, percent: n, intervalTime: a } = t;
    r && n >= 0 && n < 99 && (this.interval = setInterval(this.increment, a)), !(n >= 100 && this.state.percent === -1) && (n >= 100 ? this.setState(
      {
        percent: 99.999999
      },
      () => {
        this.timeout = setTimeout(() => {
          this.setState({
            percent: -1
          });
        }, 1e3);
      }
    ) : this.setState({
      percent: n
    }));
  }
  render() {
    const { percent: t } = this.state, r = [Lr.progressBar, Lr.barOnTop];
    (t < 0 || t >= 100) && r.push(Lr.barHide);
    const n = { opacity: `${t < 0 ? 0 : 1}`, width: `${t}%` };
    return /* @__PURE__ */ d.jsx("div", { className: r.join(" "), children: /* @__PURE__ */ d.jsx("div", { className: Lr.barPercent, style: n, "data-testid": `pageProgressBar-${t}` }) });
  }
}
bu.propTypes = {
  percent: N.number.isRequired,
  autoIncrement: N.bool,
  intervalTime: N.number
};
bu.defaultProps = {
  percent: -1,
  autoIncrement: !1,
  intervalTime: 200
};
const hb = [
  {
    val: gi,
    render: Ju,
    icon: "lightning-bolt",
    color: "#3751FF"
  },
  {
    val: _i,
    render: Zu,
    icon: "sandbox",
    color: "#B0480E"
  }
], ci = ({ option: e, children: t }) => {
  const { render: r, icon: n, color: a } = e;
  return /* @__PURE__ */ d.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ d.jsx(et, { type: n, overrideColor: a, noHoverEffects: !0 }),
    /* @__PURE__ */ d.jsx(St, { factor: 1 }),
    /* @__PURE__ */ d.jsx(
      "div",
      {
        style: {
          color: a,
          fontFamily: "DIN W01 Bold",
          fontSize: "12px",
          letterSpacing: "1px",
          textTransform: "uppercase"
        },
        children: r
      }
    ),
    t
  ] });
}, gb = (e, t) => e.map((r) => {
  const { val: n, color: a } = r;
  return {
    id: n,
    val: n,
    render: /* @__PURE__ */ d.jsx("div", { children: /* @__PURE__ */ d.jsxs(ci, { option: r, children: [
      /* @__PURE__ */ d.jsx(St, { factor: 1 }),
      t === n && /* @__PURE__ */ d.jsx(et, { type: "check", overrideColor: a, noHoverEffects: !0 })
    ] }) }),
    renderSelected: /* @__PURE__ */ d.jsx(ci, { option: r })
  };
});
function _w({ environment: e, onChange: t }) {
  const r = gb(hb, e), n = r.find((a) => a.id === e);
  return /* @__PURE__ */ d.jsx(
    fi,
    {
      backgroundColor: e === gi ? "rgba(55,81,255, 0.2)" : e === _i ? "rgba(176,72,14, 0.2)" : null,
      width: "156px",
      testId: "env-selector",
      options: r,
      value: n,
      onChange: t
    }
  );
}
export {
  hu as ActiveIssueLink,
  gw as ActivityMonitorController,
  Lb as ApplicationDataContext,
  x_ as BootstrapSession,
  pw as DocsLink,
  _w as EnvironmentSelector,
  vw as FeedbackLink,
  Mb as FlipFlopContext,
  CS as IsLoading,
  Vb as IsLoadingContext,
  cw as IsLoadingTestUtils,
  jb as JanusContext,
  su as LeftNav,
  ty as LeftNavContainer,
  Ee as LeftNavLink,
  k as LeftNavSubLink,
  gu as NewFeatureLink,
  Kb as NewLeftNav,
  bu as PageProgressBar,
  du as ProgramSelector,
  Fb as RedseaContext,
  rw as SessionTestWrapper,
  mw as UserProfileDropdown,
  fw as addRoutesToRouteMap,
  Xb as afterEachHook,
  Db as applicationDataUtils,
  Hr as authorization,
  Zb as beforeEachHook,
  de as flipFlop,
  zn as flipFlopFlags,
  Ub as flipFlopReducer,
  ri as googleAnalytics,
  tb as gqlClient,
  tw as isLoadingReducer,
  Bb as janusUtils,
  vu as mockApplicationData,
  mu as mockRedseaUser,
  Yb as number,
  Hb as redseaQueries,
  zb as redseaReducer,
  Gb as redseaRoleMapping,
  aw as redseaTestUtils,
  Nb as redseaUtils,
  He as routeMap,
  se as secureStorage,
  nw as setup,
  fa as urlHelpers,
  $b as useExtendedJanusDepartments,
  qb as useExtendedJanusSupplements,
  sw as useFetchApplicationData,
  oo as useFlipFlop,
  LS as useFlipFlopFlag,
  ao as useIsLoggedInToJanus,
  iw as useJanusActions,
  y_ as useJanusApi,
  Jb as useJanusApiTestUtils,
  Wc as useLoadRedseaUser,
  Ct as useLogOut,
  Wb as useLogOutTestUtils,
  B_ as useRedseaOrJanusEmail,
  V_ as useRedseaOrJanusFullName,
  ow as useRedseaRoles,
  lw as useUnifyActive,
  Ft as voltConfig,
  yS as withApplicationData,
  Qb as withApplicationDataActions,
  RS as withBootstrapSession,
  wS as withFlipFlop,
  dw as withFlipFlopFlag,
  hw as withGqlApi,
  uw as withIsLoadingActions,
  AS as withJanusUser,
  ES as withRedseaUser,
  ew as withRedseaUserActions,
  TS as withSessionIsBootstrapped
};
